export const langEs = {
  // Sidebar Menu
  sidebar_home: 'Inicio',
  sidebar_notifications: 'Notificaciones',
  sidebar_invoicing: 'Facturación',
  sidebar_accounting: 'Revisar y Emparejar',
  sidebar_business: 'Mi Empresa',
  sidebar_banks: 'Bancos',
  sidebar_customers: 'Clientes',
  sidebar_employees: 'Empleados',
  sidebar_contractors: 'Freelancers',
  sidebar_purchases: 'Compras',
  sidebar_sales: 'Ventas',
  sidebar_travels: 'Viajes',
  sidebar_business_info: 'Información de la Empresa',
  sidebar_reports: 'Informes',
  sidebar_accounting_reports: 'Informes Contables',
  sidebar_annual_report: 'Informe Anual',
  sidebar_agreements: 'Acuerdos',
  sidebar_premium: 'Premium',
  sidebar_projects: 'Proyectos',
  sidebar_financials: 'Finanzas',
  sidebar_transactions: 'Transacciones',
  sidebar_workflows: 'Flujos de trabajo',
  sidebar_amazon: 'Vendedor Amazon',
  sidebar_companion: 'Companion®',
  sidebar_offer: 'Ofertas',
  sidebar_support: 'Soporte',

  // User Menu
  user_menu_profile: 'Perfil',
  user_menu_team: 'Equipo',
  user_menu_refer_a_friend: 'Recomendaciones',
  user_menu_manage_subscription: 'Suscripción',
  user_menu_billing: 'Facturación',
  user_menu_automation: 'Automatización',
  user_menu_marketplace: 'Marketplace',
  user_menu_settings: 'Configuración',
  user_menu_others: 'Otros',
  user_menu_log_out: 'Cerrar sesión',
  user_menu_switch_version: 'Cambiar a la versión anterior',
  user_menu_dark_mode: 'Modo oscuro',
  user_menu_light_mode: 'Modo claro',
  user_menu_switch_to_light_mode: 'Cambiar a modo claro',
  user_menu_switch_to_dark_mode: 'Cambiar a modo oscuro',

  // Page Titles
  page_title_home: '¡Hola {{- name}}!',
  page_title_invoicing: 'Facturación',
  page_title_accounting: 'Revisar y Emparejar',
  page_title_business: 'Mi Empresa',
  page_title_banks: 'Bancos',
  page_title_customers: 'Clientes',
  page_title_customer_details: 'Volver a Clientes',
  page_title_employees: 'Empleados',
  page_title_contractors: 'Freelancers',
  page_title_purchases: 'Compras',
  page_title_sales: 'Ventas',
  page_title_travels: 'Viajes',
  page_title_virtual_office: 'Oficina Virtual',
  page_title_business_info: 'Información de la Empresa',
  page_title_annual_report: 'Informes Anuales',
  page_title_bank_details: 'Volver a Bancos',
  page_title_update_purchase_invoice: 'Volver a Compras',
  page_title_update_sale_invoice: 'Volver a Ventas',
  page_title_profile: 'Perfil',
  page_title_team: 'Equipo',
  page_title_refer_a_friend: '¡Recomienda a un amigo!',
  page_title_manage_subscription: 'Gestionar suscripción',
  page_title_billing: 'Facturación',
  page_title_automation: 'Automatización',
  page_title_marketplace: 'Marketplace',
  page_title_my_business: 'Información de la empresa',
  page_title_settings: 'Configuración',
  page_title_add_card: 'Volver a Facturación',
  page_title_referral_history: 'Volver a Recomendaciones',
  page_title_add_or_edit_user: 'Volver al Equipo',
  page_title_add_or_edit_member: 'Volver al registro',
  page_title_travel_details: 'Volver a viajes',
  page_title_add_travel: 'Volver a viajes',
  page_title_agreements: 'Acuerdos',
  page_title_add_agreement: 'Volver a Acuerdos',
  page_title_agreement_details: 'Volver a Acuerdos',
  page_title_transactions: 'Transacciones',
  employee_or_contractor_label: 'Empleado / freelance',
  member_of_company_label: 'miembro del consejo',
  page_title_secure_download:
    'Aquí puedes ver y descargar todos los documentos que se han compartido contigo.',
  page_title_offers: 'Ofertas',
  page_title_missing_bank: 'Volver a Bancos',

  // Login Page
  login_welcome: '¡Bienvenido de vuelta!',
  login_description_1: 'Introduce tu email para recibir un enlace mágico y acceder al sistema.',
  login_description_2: 'También puedes iniciar sesión con tu tarjeta e-Residency.',
  login_enter_your_email: 'Introduce tu email',
  login_enter_magic_link_submit: 'Obtener enlace mágico',
  login_email_valid: 'El email no es válido',
  login_email_required: 'El email es obligatorio',
  login_keep_me_logged_in: 'Recordarme',
  login_sending_magic_link: 'Enviando enlace mágico',
  login_we_sent_you_magic_link_html:
    'Te hemos enviado un enlace mágico por email para acceder a Companio. Por favor, no olvides revisar tu carpeta de spam. Si aún no lo encuentras, <a href="https://help.companio.co/es" target="_blank" rel="noreferrer">contáctanos</a>.',
  login_error_sending_magic_link:
    'Ha ocurrido un error al intentar enviar tu enlace mágico. No te preocupes, nuestro equipo de IT está al tanto del error, pero puedes contactarnos para darnos información adicional.',
  login_dont_have_account: '¿No tienes una cuenta?',
  login_sign_up: 'Regístrate',
  login_check_your_notifications: '¡Revisa tus notificaciones!',
  login_which_email_page_open: '¿Qué página de email deseas abrir?',
  login_didnt_get_the_email: '¿No recibiste el email?',
  login_resend_code_to_my_email: 'Reenviar el código a mi email',
  login_gmail: 'Gmail',
  login_outlook: 'Outlook',
  login_apple: 'Mail',

  // Home Page
  home_accounting_period_tab_label_previous: 'Mes pasado',
  home_accounting_period_tab_label_current: 'Este mes',
  home_dashboard_walkthrough_button: 'Recorrido guiado',
  home_invoices_and_movements: 'Facturas y Movimientos',
  home_sales_invoices: 'Facturas de ventas',
  home_purchase_invoices: 'Facturas de compras',
  home_bank_statements: 'Extractos bancarios',
  home_matchings_pending: '{{ matchings }} coincidencias pendientes',
  home_match_button: 'Emparejar',
  home_upload_button: 'Subir',
  home_submitting_reports: 'Envío de Informes',
  home_tsd_report: 'Informe TSD',
  home_vat_report: 'Informe IVA',
  home_oss_report: 'Informe OSS',
  home_deadline: 'Fecha límite: {{ date }}',
  home_payment_of_taxes: 'Pago de Impuestos',
  home_tsd_taxes: 'Pago de Impuestos TSD',
  home_vat_taxes: 'Pago de Impuestos IVA',
  home_reference: 'Referencia: {{ reference }}',
  home_taxes_how_to: '¿No estás seguro de cómo hacer los pagos de impuestos?',
  home_taxes_find_out: '¡Descubre cómo aquí! 😉',
  home_important_messages: '¡Mensajes importantes!',
  home_oss_banner_title: '¿Vendes a través de Amazon FBA?',
  home_oss_banner_button: 'Contáctanos',
  home_oss_banner_description:
    'Accede a contabilidad digital completa diseñada para vendedores de Amazon.',
  home_messages_bank_account_up_to_date_title: 'Conexiones Bancarias Actualizadas',
  home_messages_bank_account_up_to_date_description:
    '¡Tus conexiones bancarias están actualizadas! Disfruta de una gestión perfecta y segura de tus transacciones financieras.',
  home_messages_bank_account_disconnected_title:
    '{{ banks }} cuenta(s) bancaria(s) desconectada(s)',
  home_messages_bank_account_disconnected_description: 'Por favor reconecta tus cuentas bancarias',
  home_messages_bank_account_expiring_soon_title: '{{ banks }} conexión(es) bancaria(s) por vencer',
  home_messages_bank_account_expiring_soon_description:
    '{{ banks }} conexión(es) bancaria(s) vencerán pronto. Por favor, reconecta tu banco para evitar interrupciones en la sincronización de transacciones.',
  home_messages_no_pending_invoices_title: 'Tus pagos están al día',
  home_messages_no_pending_invoices_description:
    '¡Buenas noticias! No tienes ningún pago pendiente por nuestros servicios, todo está completamente liquidado.',
  home_messages_invoices_to_pay_title: 'Tienes {{ invoices }} factura(s) por pagar',
  home_messages_invoices_to_pay_description:
    'Tienes {{ invoices }} factura(s) pendiente(s) por un total de {{ total_value }}',
  home_created_at: 'Creado el: {{ date }}',
  home_accounting_report: 'Informe',
  terms_and_conditions_modal_title:
    'Hemos actualizado los Términos y Condiciones de nuestro servicio',
  terms_and_conditions_modal_description:
    'Puedes leer <a href="https://companio.co/terms-of-service/" target="_blank">aquí</a> las nuevas condiciones para estar al tanto de los cambios.',
  terms_and_conditions_modal_button: 'Aceptar',
  terms_update_pending: 'Términos actualizados con éxito',
  terms_update_error: 'Hubo un error al actualizar los términos',
  fba_support_message: 'Quiero informarme sobre los servicios de Amazon FBA.',
  financial_period_banner_description:
    'En <b>{{current}}</b>, preparamos tus cuentas de <b>{{previous}}</b>, así que asegúrate de <b>subir todas tus facturas de {{previous}}</b> (tanto de ventas como de compras) en las secciones <b>Finanzas > Ventas</b> y <b>Finanzas > Compras</b> antes del <b>día 5 de {{current}}</b>. También puedes empezar a subir ahora tus <b>facturas de {{current}}</b>.',
  certificate_signing_modal_error_title: '¡Ups! Algo salió mal',
  certificate_signing_modal_error_description:
    'Se produjo un error al actualizar tu certificado. Por favor, asegúrate de que el lector USB funciona correctamente, reinicia el navegador o prueba con otro distinto. Si el problema persiste, contáctanos.',
  certificate_signing_modal_success_title: 'Se han guardado nuevos datos',
  certificate_signing_modal_success_description:
    'La información de tu tarjeta se ha almacenado de forma segura en nuestro sistema. ¡Gracias por tu apoyo!',
  home_disconnected_bank_accounts: '{{ disconnected_bank_accounts }} banco(s) desconectado(s)',
  home_statements_button: 'Extractos',
  home_connect_button: 'Conectar',
  home_deadline_at: 'Fecha límite: {{ date }}',
  confirmation_code_modal_title: 'Te hemos enviado un código por SMS',
  confirmation_code_modal_description:
    'Por favor, revisa tu teléfono. Te hemos enviado un SMS con un código para verificar tu número. Introdúcelo aquí. Si no lo encuentras, puedes solicitar un nuevo código.',
  verify_code: 'Verificar código',
  receive_code_question: '¿No has recibido ningún código?',
  resend_again: 'Reenviar de nuevo',
  request_new_code_in: 'Solicitar nuevo código en',
  request_new_code: 'Solicitar nuevo código',
  instructions: 'Instrucciones',
  eresidency_about_to_expire_title: '¡Tu Certificado de e-Residency Está a Punto de Caducar!',
  eresidency_about_to_expire_description:
    'Hemos detectado que tu certificado de e-Residency caducará en menos de un mes. Para evitar perder acceso a tu empresa y nuestros servicios, renuévalo cuanto antes.',
  certificate_is_expired_title: 'Tu tarjeta de e-Resident ha caducado',
  certificate_is_about_to_expire_title: 'Tu tarjeta de e-Resident está a punto de caducar',
  members_certificate_is_expired_title: 'Atención: tarjeta(s) de e-Residency caducada(s)',
  certificate_is_close_to_expire_title: 'Tu tarjeta de e-Resident está a punto de caducar',
  certificate_is_expired_description:
    '<p>Tu tarjeta actual de e-Resident ya no es válida. <bold>Por favor, inserta tu nueva tarjeta para actualizar tus datos y seguir utilizando nuestros servicios sin interrupción.</bold> Este paso es obligatorio para garantizar un acceso seguro y el cumplimiento legal.</p>',
  certificate_is_about_to_expire_description:
    '<p>Hemos detectado que tu tarjeta de e-Resident puede estar próxima a su fecha de caducidad. <bold>Por favor, revisa la fecha de vencimiento de la tarjeta y asegúrate de solicitar una nueva o iniciar la renovación si es necesario.</bold> Una vez que recibas la nueva tarjeta, conéctala de nuevo para actualizar tus datos en nuestro sistema.</p>',
  members_certificate_is_expired_description:
    '<p>Los siguientes miembros tienen una tarjeta caducada y deberán volver a registrarla ellos mismos:</p>',
  members_certificate_is_expired_description_2:
    '<p>Pueden actualizarla en <bold>Información de empresa > Registro</bold> para mantener el cumplimiento de la empresa.</p>',
  member_certificate_expired: 'caducó el {{date}}',
  member_certificate_expires: 'caduca el {{date}}',
  registry_my_eresidency_expired_alert:
    '<b>Acción requerida: tu tarjeta de e-Residency ha caducado.</b> Vuelve a registrarla abajo para mantener el cumplimiento de tu empresa.',
  registry_member_eresidency_expired_alert:
    '<b>La tarjeta de e-Residency de {{name}} ha caducado.</b> Volver a registrarla depende de esa persona — mientras tanto, puedes enviarle un recordatorio.',
  registry_members_eresidency_expired_alert:
    '<b>Algunos miembros tienen la tarjeta de e-Residency caducada.</b> Volver a registrarla depende de ellos — mientras tanto, puedes enviarles un recordatorio.',
  send_reminder: 'Enviar recordatorio',
  re_register: 'Volver a registrar',
  eresidency_reminder_loading: 'Enviando recordatorio...',
  eresidency_reminder_success: 'Recordatorio enviado a {{sent}} miembro(s)',
  eresidency_reminder_error:
    'No hemos podido enviar el recordatorio. Por favor, inténtalo de nuevo.',
  review_members: 'Revisar miembros',
  certificate_is_close_to_expire_description:
    'Hemos detectado que tu tarjeta de e-Resident puede estar próxima a su fecha de caducidad. Por favor, revisa la fecha de vencimiento de la tarjeta y asegúrate de solicitar una nueva o iniciar la renovación si es necesario. Una vez que recibas la nueva tarjeta, conéctala de nuevo para actualizar tus datos en nuestro sistema.',
  certificate_is_expired_button: 'Conectar nueva tarjeta',
  certificate_is_close_to_expire_button: 'Ok',
  certificate_extracting_data: 'Estamos extrayendo los datos de tu tarjeta',
  terms_update_success: 'Términos aceptados correctamente',
  financial_period: 'Periodo financiero',
  eresidency_update_modal_title: 'Actualizar tarjeta de e-Residency',
  eresidency_update_modal_description:
    '<p><b>Por favor, inserta tu nueva tarjeta para actualizar tus datos y continuar usando nuestros servicios sin interrupciones.</b> Este paso es necesario para garantizar un acceso seguro y el cumplimiento legal.</p>',
  missing_bank_banner_description:
    '<b>Puede haber una cuenta bancaria que aún no se haya conectado.</b> Por favor, revísala y conéctala o confirma que no existen cuentas adicionales.',

  // Walkthrough Guide
  get_started_modal_title: '¡Bienvenido a Companio!',
  get_started_modal_description:
    '<p>Acabas de desbloquear tu panel todo en uno para la contabilidad, el cumplimiento y la gestión empresarial de tu compañía.</p><p><bold>Prepárate para descubrir cómo Companio hace que la libertad funcione, ofreciéndote claridad, control y la confianza para crecer sin fronteras.</bold></p><p>Ahora te mostraremos las funciones clave de tu panel para que descubras todo lo que puede hacer por ti.</p>',
  get_started_button: 'Comenzar',
  homescreen_guide_step_title: 'Pantalla principal',
  homescreen_guide_step_description:
    '<p>Este es tu centro principal. Aquí verás recordatorios para subir tus facturas de ventas y compras de cada mes, <bold>a más tardar el día 5 del mes siguiente.</bold></p><p>También encontrarás el progreso de tus informes mensuales y recordatorios cuando sea momento de pagar impuestos.</p><p>Además, verás <bold>notificaciones importantes</bold> que te informarán de inmediato si se requiere alguna acción.</p>',
  invoicing_guide_step_title: 'Facturación',
  invoicing_guide_step_description:
    '<p>Crear una factura en Companio es rápido y sencillo. Solo sigue estos pasos:</p><li>1. Rellena <bold>los datos de la factura</bold>, como el cliente, el asunto o cualquier instrucción especial.</li><li>2. Añade tus <bold>elementos de factura.</bold></li><li>3. <bold>Revisa y previsualiza</bold> tu factura para asegurarte de que todo esté correcto.</li><li>4. Haz clic en <bold>Añadir factura</bold> — ¡y listo!</li>',
  accounting_guide_step_title: 'Revisar y Emparejar',
  accounting_guide_step_description:
    '<p>Esta sección te permite realizar la conciliación bancaria vinculando una transacción o movimiento con una factura o un motivo.</p><p>Haz clic en <bold>Conciliar transacción</bold> y elige el tipo de vinculación adecuado. Recuerda subir todas las facturas del mes anterior entre el día 1 y el 5 del mes actual.</p>',
  financials_guide_step_title: 'Finanzas',
  financials_guide_step_description:
    '<p>En esta sección encontrarás las herramientas principales para gestionar las finanzas de tu empresa:</p><li> • <bold>Bancos:</bold> conecta y gestiona tus cuentas bancarias corporativas.</li><li> • <bold>Ventas y Compras:</bold> sube y gestiona tus facturas de ventas y compras.</li><li> • <bold>Transacciones:</bold> revisa y gestiona todas tus transacciones bancarias.</li>',
  my_busisness_guide_step_title: 'Mi Empresa',
  my_busisness_guide_step_description:
    '<li>• <bold>Información de la empresa:</bold> datos esenciales de tu compañía.</li><li>• <bold>Clientes:</bold> visualiza, añade y gestiona tus clientes.</li><li>• <bold>Contratistas:</bold> visualiza, añade y gestiona colaboradores externos.</li><li>• <bold>Empleados:</bold> contrata y gestiona personal en más de 80 países.</li><li>• <bold>Viajes:</bold> gestiona viajes corporativos.</li><li>• <bold>Acuerdos:</bold> gestiona préstamos.</li>',
  reports_guide_step_title: 'Informes',
  reports_guide_step_description:
    '<p>Aquí encontrarás dos secciones clave:</p><li>• <bold>Informes contables:</bold> controla el estado de tus informes y consulta información detallada.</li><li>• <bold>Informe anual:</bold> revisa su estado, consulta detalles o accede a años anteriores.</li><p>Mantén todo en cumplimiento desde un solo lugar.</p>',
  end_tour_modal_title: '¡Gracias por realizar el recorrido!',
  end_tour_modal_description:
    '<p>Esperamos que este recorrido te haya ayudado a descubrir lo esencial de tu panel contable todo en uno.</p><p>¿Quieres profundizar más? <bold>Explora cada sección en detalle a través del botón Recorrido del Panel</bold> en tu pantalla principal, donde encontrarás tutoriales en vídeo paso a paso.</p><p>Y recuerda, si alguna vez necesitas ayuda, nuestro equipo está a solo un mensaje de distancia en el <a>chat</a>.</p>',
  finish_tour_button: 'Finalizar recorrido',
  delete_it: 'Eliminarlo',
  need_more_details:
    '<p>¿Necesitas más detalles? <a><strong>Mira el tutorial en video</strong></a></p>',
  dont_show_walkthrough: 'No mostrar de nuevo',
  user_not_found: 'Usuario no encontrado',
  upgrade: 'Actualizar',
  customer_phone_number: 'Número de teléfono (opcional)',
  email_duplicated_exception:
    'Este correo electrónico está vinculado a otra cuenta. Intenta con otro correo.',
  uploading_file: 'Subiendo documento...',
  please_wait: 'Por favor, espera...',
  continue_anyway: 'Continuar de todos modos',
  connect_anyway: 'Conectar de todos modos',
  change_vat: 'Cambiar VAT',
  some_required_fields_are_missing:
    'Faltan algunos campos obligatorios. Por favor, complétalos para continuar',
  at_least_one_is_required_please_complete:
    'Se requiere al menos un elemento. Por favor, completa todos sus campos para continuar',
  pay_now: 'Pagar ahora',
  open: 'Abrir',
  complete: 'Completar',
  sign: 'Firmar',
  period: 'Periodo',
  review_now: 'Revisar ahora',
  clone: 'Duplicar',
  duplicate_invoice: 'Duplicar factura',
  enabled: 'Activado',
  upload_valid_image_pdf: 'Sube una imagen o PDF válido',
  choose_employee_or_contractor: 'Elige un empleado o contratista',
  choose_member_of_the_board: 'Elige un miembro del consejo',
  choose_source: 'Elige un origen',
  choose_destination: 'Elige un destino',
  select_a_date: 'Selecciona una fecha',
  type_an_amount: 'Escribe un importe',
  beautify: 'Mejorar',

  // Dashboard Walkthrough
  page_title_dashboard_walkthrough: 'Volver al Inicio',
  dashboard_walkthrough_page: 'Recorrido guiado',
  create_new_invoices: 'Crear nuevas facturas',
  connecting_banks: 'Conectar bancos',
  amazon_fba: 'Amazon FBA',
  getting_started_video_title: 'Primeros pasos con tu panel de Companio',
  getting_started_video_description:
    'En este vídeo aprenderás a usar la sección “Inicio” de panel de control de tu empresa todo en uno.',
  manage_sales_invoice_video_title: 'Cómo gestionar tus facturas de ventas',
  manage_sales_invoice_video_description:
    'En este vídeo aprenderás a usar la sección “Ventas” de panel de control de tu empresa todo en uno.',
  manage_international_employees_video_title: 'Cómo gestionar empleados internacionales',
  manage_international_employees_video_description:
    'En este vídeo aprenderás a usar la sección “Empleados” de panel de control de tu empresa todo en uno.',
  manage_contractors_video_title: 'Cómo gestionar freelancers internacionales',
  manage_contractors_video_description:
    'En este vídeo aprenderás a usar la sección “freelancers” de panel de control de tu empresa todo en uno.',
  manage_busisness_expenses_video_title: 'Cómo gestionar tus gastos de empresa',
  manage_busisness_expenses_video_description:
    'En este vídeo aprenderás a usar la sección “Compras” de panel de control de tu empresa todo en uno.',
  use_accounting_section_video_title: 'Mantén el cumplimiento, precisión y organización',
  use_accounting_section_video_description:
    'En este video, aprenderás a usar la sección “Contabilidad” de tu panel todo en uno',
  anual_report_video_title: 'Informe Anual de Estonia',
  anual_report_video_description:
    'En este video te guiamos a través de todo el proceso del Informe Anual de Estonia en Companio 2.0, desde el pago hasta la presentación final.',
  dashboard_walkthrough_description:
    'Todo lo que necesitas saber para dominar tu panel de control, en unos breves vídeos. ¿Necesitas más información? Explora nuestra <a href="https://help.companio.co/es/" target="_blank" rel="noreferrer">Base de conocimiento</a>.',

  // Secure download
  your_shared_documents: 'Tus documentos compartidos',
  security_code_required: 'Se requiere código de seguridad',
  enter_security_code_sent_to_email:
    'Por favor, introduce el código de seguridad que se envió a tu correo electrónico',
  enter_the_6_digit_code_sent_to_your_email:
    'Introduce el código de 6 dígitos enviado a tu correo electrónico',
  verifying_code: 'Verificando código...',
  code_verified_successfully: 'Verificación exitosa. Ahora puedes descargar tus documentos.',
  invalid_security_code: 'Código de seguridad inválido. Por favor, inténtalo de nuevo.',
  creation_date: 'Fecha de creación',
  who_sent_it: 'Quién lo envió',
  download_document: 'Descargar documento',
  download_selected: 'Descargar seleccionado',
  error_loading_documents: 'Error al cargar los documentos. Por favor, inténtalo de nuevo.',
  no_documents_shared: 'No se han compartido documentos contigo.',
  financial_periods: 'Periodos financieros',
  verify: 'Verificar',
  having_troubles: '¿Tienes problemas?',
  get_help: 'Obtener ayuda',
  security_code_resent_successfully:
    'El código de seguridad ha sido reenviado a su correo electrónico',
  error_resending_security_code:
    'Error al reenviar el código de seguridad. Por favor, inténtelo de nuevo.',
  please_wait_before_requesting_new_code: 'Por favor, espere antes de solicitar un nuevo código',

  // Sales/Purchases Page
  sales_table_title: 'Facturas de ventas',
  purchases_table_title: 'Facturas de compras',
  invoices_table_header_name: 'Nombre del documento',
  invoices_table_header_date: 'Fecha',
  invoices_table_header_status: 'Estado',
  invoices_table_header_transaction: 'Transacción',
  invoices_table_header_out_of_pocket: 'De bolsillo',
  invoices_table_header_bulk_actions: 'Acciones masivas',
  sales_table_header_multi_button: 'Añadir factura',
  purchases_table_header_add_invoice_button: 'Añadir factura',
  invoices_filter_uploaded: 'Subido',
  invoices_filter_processing: 'Procesando',
  invoices_filter_processed: 'Procesado',
  invoices_filter_rejected: 'Rechazado',
  invoices_filter_matched: 'Emparejado',
  invoices_filter_unmatched: 'Sin emparejar',
  invoices_table_header_create_new_invoice: 'Crear nueva factura',
  invoices_table_header_import_amazon: 'Importar ventas de Amazon',
  invoices_table_header_import_sales: 'Importar ventas desde CSV',
  invoices_table_header_upload_invoices: 'Subir facturas',
  invoice_status_uploaded: 'Subido',
  invoice_status_processing: 'Procesando',
  invoice_status_processed: 'Procesado',
  invoice_status_rejected: 'Rechazado',
  invoice_status_deleted: 'Eliminado',
  invoices_origin: 'De {{company}}. total: {{total}} {{ currency }}',
  invoices_uploaded: 'Subido {{ date }}',
  invoices_empty_state: 'No se encontraron documentos para esta selección. Por favor, elige otra.',
  invoices_transaction_invalid_invoice:
    'Sin número de factura · Sin datos del vendedor · Sin datos del comprador…',
  invoices_transaction_button_link: 'Enlazar',
  invoices_table_options_edit: 'Editar',
  invoices_table_options_download: 'Descargar',
  invoices_table_options_change_type: 'Editar tipo',
  invoices_table_options_move_to: 'Mover a {{ date }}',
  invoices_table_options_move_to_pending: 'Actualizando fecha de documentos...',
  invoices_table_options_move_to_success: 'Fecha de documentos actualizada correctamente.',
  invoices_table_options_move_to_error: 'Hubo un error al actualizar la fecha de los documentos.',
  invoices_table_options_mark_as_out_of_pocket: 'Marcar como de bolsillo',
  invoices_table_options_remove_out_of_pocket: 'Quitar de bolsillo',
  invoices_table_options_mark_as_out_of_pocket_success:
    'Los documentos han sido marcados como de bolsillo.',
  invoices_table_options_remove_out_of_pocket_success:
    'Los documentos han sido desmarcados como de bolsillo.',
  invoices_table_options_edit_name: 'Editar nombre',
  sales_table_why_rejected: '¿Por qué fue rechazado?',
  invoices_table_options_replace: 'Reemplazar con documento correcto',
  invoices_table_options_match: 'Emparejar con transacción',
  invoices_table_options_unmatch: 'Desemparejar',
  invoices_table_options_clone_invoice: 'Clonar factura',
  invoices_table_options_delete: 'Eliminar',
  cannot_delete_matched_invoice:
    'No se puede eliminar una factura emparejada. Por favor, desemparéjala primero.',
  invoice_date_update_pending: 'Actualizando fecha del documento...',
  invoice_date_update_success: 'Fecha del documento actualizada correctamente.',
  invoice_date_update_error: 'Hubo un error al actualizar la fecha del documento.',
  invoice_out_of_pocket_pending: 'Actualizando documento...',
  invoice_out_of_pocket_success: 'El documento ha sido marcado como de bolsillo.',
  invoice_out_of_pocket_error: 'Hubo un error al actualizar el documento.',
  sales_invoice_cannot_be_modified_modal_title: 'La factura no se puede modificar',
  sales_invoice_cannot_be_modified_modal_title_multiple: 'Las facturas no se pueden modificar',
  sales_invoice_cannot_be_modified_modal_description_html:
    'La factura ya se ha registrado en la contabilidad; por favor, genere una nueva factura de rectificación.',
  sales_invoice_cannot_be_modified_modal_description_multiple_html:
    'Una o más de las facturas ya han sido añadidas a los libros contables, por favor genera una nueva factura de rectificación.',
  sales_invoice_cannot_be_modified_modal_button: 'Vale',
  invoice_description_modal_title: 'Editar descripción',
  invoice_description_modal_cancel_button: 'Cancelar',
  invoice_description_modal_save_button: 'Guardar',
  invoice_description_modal_input_placeholder: 'Máx {{ characters }} car.',
  invoice_description_modal_pending: 'Actualizando descripción de documentos.',
  invoice_description_modal_success: 'Descripción de documentos actualizada correctamente.',
  invoice_description_modal_error: 'Hubo un error al actualizar la descripción de los documentos.',
  invoice_description_modal_warning: 'La descripción es la misma que la anterior',
  invoice_update_multiple_pending: 'Actualizando documentos.',
  invoice_update_multiple_success: 'Documentos actualizados correctamente.',
  invoice_update_multiple_error: 'Hubo un error al actualizar los documentos.',
  invoice_name_modal_title: 'Editar nombre',
  invoice_name_modal_cancel_button: 'Cancelar',
  invoice_name_modal_save_button: 'Guardar',
  invoice_name_modal_input_placeholder: 'Introduce el nuevo nombre del documento aquí',
  invoice_name_modal_warning:
    'El nombre del documento es el mismo que el anterior, por favor introduce un nuevo nombre.',
  invoice_name_modal_pending: 'Actualizando nombre del documento...',
  invoice_name_modal_success: 'Nombre del documento actualizado correctamente.',
  invoice_name_modal_error: 'Hubo un error al actualizar el nombre del documento.',
  invoice_type_modal_title: 'Editar tipo',
  invoice_type_modal_pending: 'Actualizando tipo de documento.',
  invoice_type_modal_success: 'Tipo de documento actualizado correctamente.',
  invoice_type_modal_error: 'Hubo un error al actualizar el tipo de documento.',
  invoice_type_modal_warning_same_type: 'El tipo seleccionado es el mismo que el anterior.',
  invoice_type_modal_description: 'Selecciona un nuevo tipo',
  invoice_type_modal_cancel_button: 'Cancelar',
  invoice_type_modal_confirm_button: 'Confirmar',
  delete_invoice_modal_title: 'Confirmar eliminación',
  delete_invoice_modal_description_single:
    '¿Estás seguro de que quieres eliminar este documento? Esta acción no se puede deshacer. Una vez eliminado, no podrás subir el documento de nuevo, ya que nuestro sistema recuerda una huella digital del archivo para prevenir envíos duplicados.',
  delete_invoice_modal_description_multiple:
    'Por favor, confirma que quieres eliminar los siguientes documentos:',
  delete_invoice_modal_description_recurrent:
    'Esta factura tiene una recurrencia asociada. Si continúas, la factura recurrente también será eliminada y no se generarán más facturas automáticamente.',
  delete_invoice_modal_description_processed_html:
    '<strong>Atención:</strong> este documento <strong>ya ha sido procesado por tu contable</strong>. Al eliminarlo, <strong>también se eliminará de nuestro sistema contable</strong> y <strong>se notificará a tu contable</strong>. Esta acción no se puede deshacer.',
  delete_invoice_blocked_modal_title: 'Este documento ya no se puede eliminar',
  delete_invoice_blocked_period_closed_sales_html:
    'Esta factura pertenece a un período financiero que ya está cerrado, por lo que no se puede eliminar. En su lugar, emite una nota de crédito.',
  delete_invoice_blocked_period_closed_purchase_html:
    'Este documento pertenece a un período financiero que ya está cerrado, por lo que no se puede eliminar. Pide a tu proveedor una nota de crédito y súbela, o <a href="https://go.crisp.chat/chat/embed/?website_id=92ee1c03-fe47-44ef-8782-1f8593e54d6a" target="_blank" rel="noreferrer">contacta con soporte</a>.',
  delete_invoice_blocked_accounting_paid_html:
    'Este documento no se puede eliminar porque está marcado como pagado en nuestro sistema contable y está vinculado a una transacción bancaria. No ha sido eliminado.',
  delete_invoice_blocked_accounting_reconciled_html:
    'Este documento no se puede eliminar porque ya ha sido compensado con otro documento en nuestro sistema contable. No ha sido eliminado.',
  delete_invoice_blocked_accounting_unavailable_html:
    'No pudimos conectar con nuestro sistema contable, por lo que el documento no ha sido eliminado. Por favor, inténtalo de nuevo en unos minutos.',
  delete_invoice_blocked_accounting_generic_html:
    'No se pudo eliminar este documento de nuestro sistema contable, por lo que no ha sido eliminado. Por favor, <a href="https://go.crisp.chat/chat/embed/?website_id=92ee1c03-fe47-44ef-8782-1f8593e54d6a" target="_blank" rel="noreferrer">contacta con soporte</a> si el problema continúa.',
  delete_invoice_modal_cancel_button: 'Cancelar',
  delete_invoice_modal_confirm_button: 'Confirmar',
  delete_invoice_modal_pending: 'Eliminando documento(s)...',
  delete_invoice_modal_success: 'El/los documento(s) fueron eliminados correctamente',
  delete_invoice_modal_error: 'Hubo un error al eliminar el/los documento(s)',
  sales_upload_invoice_modal_title: 'Subir facturas',
  sales_upload_invoice_modal_description:
    'Antes de subirla, consulta <a href="https://help.companio.co/en/article/whats-a-correct-or-valid-invoice-data-checklist-198olzm/" target="_blank">qué debe incluir una factura válida</a>.',
  sales_upload_invoice_modal_drop_files_description: 'También puedes soltar tus archivos aquí',
  sales_upload_invoice_modal_cancel_button: 'Cancelar',
  sales_upload_invoice_modal_add_button: 'Añadir',
  sales_upload_invoice_modal_image_too_small_error:
    'Esta imagen es demasiado pequeña para contener una factura legible y fue ignorada.',
  sales_upload_invoice_modal_failed_uploads_divider: 'Subidas fallidas ({{filesFailed}})',
  type_of_document_choose_one: 'Tipo de documento (elige uno)',
  invoice: 'Factura',
  local_travel_tickets: 'Billetes de transporte local',
  business_travel_expenses: 'Gastos de viaje de negocios',
  travel: 'Viaje',
  business_trip: 'Viaje de negocios',
  select_travel: 'Selecciona un viaje',
  travel_not_selected: 'Selecciona un viaje antes de subir el archivo',
  upload_modal_category_invoice_description:
    'Documentos emitidos a tu empresa por la compra de bienes o servicios deducibles relacionados con la actividad de tu negocio.',
  upload_modal_category_local_travel_ticket_description:
    'Billetes de viajes locales relacionados con el negocio dentro del mismo país, como visitar a clientes locales o asistir a conferencias locales (por ejemplo, billetes de bus, tren o metro).',
  upload_modal_category_business_travel_expense_description:
    'Gastos no deducibles incurridos durante viajes al extranjero o entre países (por ejemplo, café en el aeropuerto o conexión a internet). Estos gastos están vinculados a un viaje específico y se usan para justificar las dietas diarias. No uses esta categoría para gastos deducibles como alojamiento o billetes de avión, que deben registrarse como facturas.',
  upload_modal_drop_invoice_title:
    'Arrastra y suelta tus facturas aquí o haz clic para seleccionarlas.',
  upload_modal_drop_local_travel_ticket_title:
    'Arrastra y suelta tus billetes de transporte local aquí o haz clic para seleccionarlos.',
  upload_modal_drop_business_travel_expense_title:
    'Arrastra y suelta los billetes del viaje de {{origin}} a {{destination}} ({{startDate}} a {{endDate}}) aquí o haz clic para seleccionarlos.',
  upload_modal_drop_business_travel_expense_generic_title:
    'Elige primero un viaje de negocios para subir sus gastos de viaje.',
  document_category_column_header: 'Categoría',
  document_category_invoice: 'Factura',
  document_category_local_travel_ticket: 'Billete de transporte local',
  document_category_business_travel_expense: 'Gastos de viaje de negocios',
  sales_import_from_csv_modal_premium_alert_title:
    '¡Actualiza a PREMIUM para Desbloquear la Importación de Facturas CSV!',
  sales_import_from_csv_modal_premium_alert_description_html:
    "Si deseas utilizar esta función, necesitarás actualizar a nuestro plan PREMIUM. Para detalles sobre precios mensuales, consulta nuestra <a href='https://companio.co/es/precios/' target='_blank' rel='noreferrer'>página de precios</a>. ¿Estás listo para proceder con la actualización?",
  sales_import_from_csv_modal_premium_alert_reject_button: 'No, gracias',
  sales_import_from_csv_modal_premium_alert_upgrade_button: 'Sí, actualizar',
  sales_import_from_csv_modal_title: 'Importar archivo CSV',
  sales_import_from_csv_modal_description_html:
    'Nuestra funcionalidad de Importación te permite importar múltiples facturas de ventas desde un CSV con un formato específico <a target="_blank" rel="noreferrer" href="https://api.companio.co/uploads/files/companio_csv_upload_template.csv" download>haz clic aquí para descargar un archivo de muestra</a>.',
  sales_import_from_csv_modal_drop_files_description: 'Sube un archivo CSV válido para comenzar',
  sales_import_from_csv_modal_conversion_error_html:
    '¡Ups! Algunos documentos no pudieron convertirse correctamente 😓, recomendamos que los vuelvas a subir.',
  sales_import_from_csv_modal_conversion_error_html_2:
    ' La información detallada del error está disponible en el ',
  sales_import_from_csv_modal_conversion_step_1: 'Contenido del archivo leído correctamente',
  sales_import_from_csv_modal_conversion_step_2: 'Verificando información de cabeceras requerida',
  sales_import_from_csv_modal_conversion_step_3: 'Verificando información de filas requerida',
  sales_import_from_csv_modal_conversion_step_4: 'Extrayendo número de ventas en el documento',
  sales_import_from_csv_modal_conversion_step_5: 'Generando facturas desde CSV',
  sales_import_from_csv_modal_conversion_not_started: 'No iniciado',
  sales_import_from_csv_modal_conversion_in_progress: 'En progreso',
  sales_import_from_csv_modal_conversion_done: 'Hecho',
  sales_import_from_csv_modal_conversion_error: 'Error',
  sales_import_from_csv_modal_conversion_sales_found: '{{ totalSales }} ventas encontradas',
  sales_import_from_csv_modal_completed_title: 'Importación de Facturas CSV completada',
  sales_import_from_csv_modal_completed_description:
    '{{ successfully_converted_files }} de {{ total_files }} facturas importadas. Puedes cerrar esta ventana ahora.',
  sales_import_from_csv_modal_completed_button: 'Vale',
  sales_import_from_csv_modal_partial_import_alert_title: 'Alerta de Conversión Parcial',
  sales_import_from_csv_modal_partial_import_alert_message_details:
    'La información detallada del error está disponible en <0>Descargar informe</0>.',
  invoices_table_options_match_as_net: 'Emparejar como liquidación neta',
  invoices_filter_deleted: 'Eliminado',
  invoices_table_options_appeal: 'Apelar rechazo',
  invoices_transaction_rejected_confirmed:
    'Nuestro departamento de contabilidad ha confirmado el rechazo de este documento...',
  rejected_reason_modal_title: '¿Por qué fue rechazado?',
  rejected_reason_modal_description_one: 'Este documento fue rechazado por las siguientes razones:',
  rejected_reason_modal_description_two:
    'Corrige y reemplaza la factura siguiendo <a href="https://help.companio.co/es/article/que-hago-si-mi-factura-ha-sido-rechazada-1g9wobm/" target="_blank" rel="noreferrer" >este tutorial paso a paso</a>.',
  rejected_reason_modal_description_three:
    'Si la factura <strong style="font-weight: bold">ha sido rechazada automáticamente por el sistema</strong> y crees que es correcta, puedes apelar el rechazo siguiendo <a href="https://help.companio.co/en/article/how-to-appeal-the-rejection-of-a-document-in-companio-7aikj8/" target="_blank" rel="noreferrer">este tutorial</a>.',
  rejected_reason_modal_description_four:
    'Si la factura <strong style="font-weight: bold">ha sido rechazada por el equipo contable</strong>, siempre debe ser corregida y reemplazada.',
  rejection_unknown_reason: 'El documento no cumple los requisitos para una factura válida.',
  rejection_ai_algorithm:
    'Después de analizar el documento, el algoritmo de nuestro sistema piensa que esto no es realmente una factura válida',
  rejection_many_items: 'Esto parece una lista de pagos, no una factura',
  rejection_no_invoice_number: 'El número de factura falta o no es válido',
  rejection_no_issue_date: 'Falta la fecha de emisión',
  rejection_no_buyer_info: 'Información del comprador incorrecta o incompleta',
  rejection_no_seller_info: 'Información del vendedor incorrecta o incompleta',
  rejection_unreadable_document: 'El documento no se puede leer o tiene un formato no válido',
  rejection_duplicate_invoice: 'Este documento ya ha sido procesado',
  rejection_missing_seller_vat: 'El número de IVA del vendedor falta o no es válido',
  rejection_missing_buyer_vat: 'El número de IVA del comprador falta o no es válido',
  rejection_missing_key_info: 'Falta información clave',
  rejection_non_final_document: 'Este documento es un recibo, proforma o documento no definitivo',
  rejection_wrong_vat: 'El importe de IVA es incorrecto',
  rejection_wrong_amounts: 'Los totales de la factura no cuadran',
  AI_DETECTED_NOT_INVOICE: 'La IA detectó que este documento no es una factura',
  TOO_MANY_ITEMS:
    'El documento contiene demasiados elementos de línea para procesarse como factura',
  MISSING_INVOICE_NUMBER: 'El número de factura falta o es inválido',
  MISSING_ISSUE_DATE: 'La fecha de emisión de la factura falta',
  MISSING_BUYER_INFORMATION: 'La información del comprador está incompleta o falta',
  MISSING_SELLER_INFORMATION: 'La información del vendedor está incompleta o falta',
  MISSING_OR_INVALID_TOTAL: 'El total de la factura falta o es inválido',
  CONTAINS_PLACEHOLDER_VALUES: 'El documento contiene valores temporales o incompletos',
  replace_document_pending: 'Reemplazando documento, por favor espera...',
  replace_document_success: 'Documento reemplazado correctamente',
  appeal_rejection_modal_title: 'Dinos por qué deberíamos aceptar este documento',
  appeal_rejection_not_filled_warning: 'Por favor completa la razón para la apelación del rechazo',
  appeal_rejection_sent_success_modal_title: '¡Hemos recibido tu apelación!',
  appeal_rejection_sent_success_modal_description:
    'Gracias por proporcionar más detalles. Tu solicitud ha sido enviada al contable y te notificaremos tan pronto como haya una actualización.',
  unlink_entity_from_matching_by_transaction_id_pending:
    'Desemparejando documento, por favor espera...',
  unlink_entity_from_matching_by_transaction_id_success: 'Documento desemparejado correctamente',
  sales_to_estonia: 'Ventas a Estonia',
  no_tag_selected: 'Ninguna etiqueta seleccionada',
  sales_vat_exempt: 'Ventas exentas de IVA',
  unlink_documents_confirm_modal_title: '¡Espera! Esta acción desenlazará estos documentos',
  unlink_documents_confirm_modal_description:
    'Cambiar el tipo de estos documentos los desenlazará de las transacciones. ¿Estás seguro de que quieres continuar?',
  invoices_table_options_out_of_pocket: 'De bolsillo',
  sales_upload_pdf_image: 'Sube un archivo PDF, PNG o JPG válido para comenzar',
  fiscal_month: 'Mes fiscal',
  current_month: 'Mes actual',
  last_month: 'Mes anterior',
  csv_unsuccessfull_download_error:
    'Ocurrió un error inesperado al intentar descargar el archivo csv.',
  import_amazon_sales_error_modal_title: '¡Ups! algo salió mal 😓',
  import_amazon_sales_error_modal_description:
    'Ha ocurrido un error de verificación con las columnas del CSV. Por favor revisa la estructura del CSV y vuelve a intentarlo.',
  error_processing_the_csv_file:
    'Ha ocurrido un error de procesamiento con el archivo CSV. Por favor intenta la operación de nuevo más tarde.',
  csv_headers_malformed:
    'Las cabeceras del CSV parecen malformadas. Por favor verifica la integridad del documento y vuelve a enviarlo.',
  amazon_csv_error_item: 'Ocurrió un error al procesar la venta',
  advanced_search_title: 'Filtros de búsqueda',
  time_range: 'Rango de tiempo',
  counterparty: 'Contraparte',
  invoice_total: 'Total de factura',
  amount_from: 'Desde el importe',
  amount_to: 'Hasta el importe',
  advanced_search: 'Búsqueda avanzada',
  invoicing_edit_title: 'Editar factura',
  invoicing_edit_alert:
    '<strong>Por favor revisa todos los datos antes de editar la factura.</strong> Puedes ver una vista previa haciendo clic en el botón "Vista previa de factura" a continuación.',
  updating_invoice_loading: 'Actualizando factura, por favor espera...',
  updating_invoice_success: 'Factura actualizada correctamente',
  invoicing_button_update_invoice: 'Actualizar factura',
  invoicing_edit_success_modal_title: 'Factura editada correctamente',
  invoicing_edit_success_modal_description: 'Tu factura ha sido editada correctamente.',
  generate_pro_forma: 'Generar Pro Forma',
  invoicing_generate_pro_forma_pending: 'Generando factura pro forma, por favor espera...',
  invoicing_generate_pro_forma_success: 'Factura pro forma generada correctamente',
  updating_document_tag_loading: 'Actualizando etiqueta de documento, por favor espera...',
  document_tag_updated_successfully: 'Etiqueta de documento actualizada correctamente',
  invoices_table_options_disable_reminder: 'Deshabilitar recordatorios de facturas',
  invoices_table_options_enable_reminder: 'Habilitar recordatorios de facturas',
  enabling_reminder_loading: 'Habilitando recordatorio, por favor espera...',
  enabling_reminder_success: 'Recordatorio habilitado correctamente',
  removing_reminder_loading: 'Eliminando recordatorio, por favor espere...',
  removing_reminder_success: 'Recordatorio eliminado correctamente',
  advanced_search_note:
    'La búsqueda avanzada solo funciona con documentos que ya han sido analizados por nuestra plataforma.',
  sales_import_from_csv_modal_description_html_2:
    'Use the Import functionality following <a href="https://help.companio.co/es/article/como-importar-tus-facturas-en-companio-con-la-importacion-de-facturas-en-csv-13csmr3/" target="_blank" rel="noreferrer">this step-by-step tutorial</a>.',
  sales_upload_invoice_modal_close_button: 'Cerrar',
  import_amazon_sales_modal_premium_alert_title:
    'Actualiza a PREMIUM para desbloquear la importación de ventas de Amazon!',
  import_amazon_sales_modal_premium_alert_description_html:
    'Para acceder a esta funcionalidad, por favor actualiza a nuestro plan PREMIUM. Para más información sobre los precios mensuales, visita nuestra <a href="https://companio.co/pricing/" target="_blank" rel="noreferrer">Página de precios</a>. ¿Listo para actualizar?',
  tag: 'Etiqueta',
  sales_upload_invoice_modal_dismiss_button: 'Descartar',
  sales_upload_invoice_modal_uploading_files:
    'Subiendo 1 - Subido {{filesUploaded}} de {{filesToUpload}} correctamente',
  sales_upload_invoice_modal_uploaded_files:
    'Subido {{filesUploaded}} de {{filesToUpload}} correctamente',
  sales_upload_invoice_modal_uploaded_files_failed: '- {{filesFailed}} fallidos',
  sales_upload_invoice_modal_rejected_guidance:
    'Cierra este panel para consultar los motivos del rechazo y las acciones disponibles.',
  upload_again: 'Subir de nuevo',
  generated_date: 'Generado {{date}}',
  back_to_invoicing: 'Volver a Invoicing',
  email_dropbox_banner_description:
    'Puedes añadir documentos enviándolos a <strong style="font-weight: bold">{{email}}</strong>; gestiona esta opción en <strong style="font-weight: bold">Configuración > Automatización</strong>.',
  email_dropbox_notification_dont_show_me_again: 'No mostrar de nuevo',
  advanced_search_purchases_table_title: 'Búsqueda avanzada: Facturas de compra',
  advanced_search_sales_table_title: 'Búsqueda avanzada: Facturas de venta',
  select_tag: 'Seleccionar etiqueta',
  document_tooltip_description:
    '<strong style="font-weight: bold">Description: </strong>{{description}}',
  document_tooltip_from: '<strong style="font-weight: bold">De: </strong>{{counterparty}}',
  document_tooltip_to: '<strong style="font-weight: bold">Para: </strong>{{counterparty}}',
  hide_closed_bank_accounts: 'Ocultar cuentas bancarias cerradas',
  hide_balances: 'Ocultar saldos',
  invoice_regular: 'Regular',
  invoice_savings: 'Ahorros',
  invoice_out_of_pocket_unmarked_success: 'El documento ha sido desmarcado como de bolsillo.',
  back_to_customers: 'Volver a Clientes',
  invoice_preview_unauthorized: 'Respuesta JSON no autorizada',
  invoice_preview_network_not_ok_error: 'Respuesta de red no ok',
  confirm_delete_invoice_modal_title: 'Confirmar eliminación de factura',
  invoices_table_options_can_not_move: 'Ya no se puede mover',
  sales_import_from_csv_modal_friendly_messages_title: 'No se pudo importar el CSV',
  sales_import_from_csv_modal_friendly_messages_description:
    'Algunos de los campos obligatorios no se completaron correctamente según el <a href="https://help.companio.co/es/article/como-importar-mis-facturas-en-companio-con-la-importacion-de-facturas-en-csv-13csmr3/" target="_blank" rel="noreferrer">manual</a>. A continuación, se indican las columnas incorrectas:',
  sales_import_from_csv_modal_friendly_messages_error: '<strong>Motivo: </strong>{{error}}',
  sales_import_from_csv_modal_friendly_messages_instruction:
    '<strong>Instrucción: </strong>Nuestra funcionalidad de importación te permite importar múltiples facturas de venta desde un CSV con un formato específico. Descarga la plantilla <a href="https://api.companio.co/uploads/files/companio_csv_upload_template.csv">aquí</a> y ajústala según sea necesario antes de volver a subirla.',
  invoice_table_bulk_action_match_all_with_transaction: 'Emparejar todo con transacciones',
  selected_documents_already_matched_error:
    'Algunos de los elementos seleccionados ya están conciliados. Por favor, desmárcalos o deshaz la conciliación para continuar.',
  none_selected_documents_error:
    'No se han seleccionado documentos. Por favor, selecciona al menos un documento para continuar.',
  no_documents_selected_for_matching:
    'No se encontraron documentos seleccionados para la conciliación. Por favor, vuelve a la página anterior e inténtalo de nuevo.',
  matching_type_not_found:
    'No se encontró el tipo de conciliación. Por favor, vuelve a la página anterior e inténtalo de nuevo.',
  selected_documents_have_blocking_status_error:
    'Algunos elementos seleccionados tienen un estado de bloqueo, como RECHAZADO o ELIMINADO. Por favor, desmárcalos para continuar.',
  invoice_not_parsed: 'No se pudo parsear la factura.',
  search_documents_by: 'Buscar por nombre, descripción, etiqueta o importe total',
  unparsed_document_modal_description:
    'Parece que el contenido del archivo no se puede leer ni analizar. ¿Desea descargarlo?',
  failed_to_read_document: 'No se pudo leer este documento.',
  rejection_outdated_or_out_of_time:
    'Esta factura llega demasiado tarde para incluirse en la contabilidad',
  rejection_out_of_time_transaction_non_business:
    'La transacción asociada <bold>{{ description }}</bold>, del {{ date }} se emparejó como Gasto no empresarial,',
  rejection_self_issued: 'Esta factura no fue emitida por el proveedor',

  // Invoicing Page
  invoicing_step_label_data: 'Datos de la factura',
  invoicing_step_label_items: 'Artículos de la factura',
  invoicing_step_label_summary: 'Resumen',
  invoicing_step_title: 'Crear nueva factura',
  invoicing_field_customer: 'Cliente',
  invoicing_field_full_name: 'Nombre completo',
  invoicing_field_address: 'Dirección',
  invoicing_field_tax_id: 'Número de registro',
  invoicing_field_vat_number: 'Número de IVA',
  invoicing_field_country: 'País',
  invoicing_field_subject: 'Asunto',
  invoicing_field_invoice_number: 'Número de factura',
  invoicing_field_currency: 'Moneda',
  invoicing_field_frequency: 'Frecuencia',
  invoicing_field_frequency_week: 'Día de la semana',
  invoicing_field_frequency_month: 'Día del mes',
  invoicing_field_frequency_year: 'Día del año',
  invoicing_field_currency_rate: 'Tipo de cambio',
  invoicing_field_issue_date: 'Fecha de emisión',
  invoicing_field_due_date: 'Fecha de vencimiento',
  invoicing_field_transaction_date: 'Fecha de transacción',
  invoicing_field_penalty: 'Aplicar penalización por pago tardío ',
  invoicing_field_penalty_tooltip: '(¿Qué es esto?)',
  invoicing_field_penalty_tooltip_content:
    'Esto añadirá una cláusula de penalización a tu factura del 0,5% por día de pago tardío después de la fecha de vencimiento. Eso significa que puedes reclamar un aumento extra del 0,5% en el coste de los productos o servicios vendidos por día de pago tardío a tu cliente, pero es tu responsabilidad reclamarlo.',
  invoicing_field_pro_forma: 'Esta es una factura pro forma',
  invoicing_field_instructions: 'Instrucciones de pago personalizadas',
  invoicing_field_instructions_modal: '(¿Qué es esto?)',
  invoicing_button_go_back: 'Volver',
  invoicing_button_next_step: 'Siguiente paso',
  invoicing_button_add_invoice: 'Añadir factura',
  invoicing_button_preview_invoice: 'Vista previa de factura',
  invoicing_item_title_open: 'Artículo {{ index }}',
  invoicing_item_title_closed:
    'Artículo {{ index }}: {{ name }}, {{ cost }}, IVA {{ vat }}, Importe IVA {{ vatAmount }}, total {{ totalPrice }}.',
  invoicing_field_description: 'Descripción',
  invoicing_field_quantity: 'Cantidad',
  invoicing_field_vat: 'IVA',
  invoicing_field_price: 'Precio',
  invoicing_field_subtotal: 'Subtotal',
  invoicing_field_vat_amount: 'Importe IVA',
  invoicing_field_total: 'Total',
  invoicing_button_add_item: 'Añadir otro artículo',
  invoicing_button_delete_item: 'Eliminar',
  invoicing_summary_alert:
    '<strong>Por favor revisa todos los datos antes de generar la factura.</strong> Puedes ver una vista previa haciendo clic en el botón "Vista previa de factura" a continuación.',
  invoicing_summary_data_of_the_buyer: 'Datos del comprador',
  invoicing_summary_invoice_data: 'Datos de la factura',
  invoicing_summary_invoice_items: 'Artículos de la factura',
  invoicing_summary_total: 'Total (IVA incluido)',
  invoicing_sellers_data: 'Datos del vendedor',
  invoicing_invoice_data: 'Datos de la factura',
  invoicing_add_more: 'Añadir más',
  invoicing_total_section: 'Total (IVA incluido)',
  invoicing_update_button: 'Actualizar',
  invoicing_no_customers_found: 'No se encontraron clientes',
  add_new_customer: 'Añadir nuevo cliente',
  invoicing_preview_pending: 'Generando vista previa de factura...',
  invoicing_preview_success: 'Vista previa de factura generada correctamente',
  invoicing_preview_error: 'Error al generar vista previa de factura',
  invoicing_add_pending: 'Creando factura, por favor espera...',
  invoicing_add_success:
    'Factura generada correctamente. <0>Enviar email al cliente {{ name }} ({{ email }})</0> o <1>descargarla</1>.',
  invoicing_add_error: 'Error al generar nueva factura',
  invoicing_email_pending: 'Enviando email, por favor espera...',
  invoicing_email_sent: 'La factura fue enviada correctamente a la dirección de email',
  invoicing_email_error: 'Hubo un error enviando el email',
  invoicing_field_penalty_rate: 'Tasa de penalización %',
  invoicing_field_penalty_interval: 'Intervalo de penalización',
  daily: 'Diario',
  weekly: 'Semanal',
  biweekly: 'Quincenal',
  monthly: 'Mensual',
  quarterly: 'Trimestral',
  yearly: 'Anual',
  penalty_rate_info: 'Penalización por retraso ({{rate}}% después de la fecha de vencimiento): ',
  penalty_rate_info_description: 'Total {{total}}.',
  invoicing_field_invoice_template: 'Plantilla de factura',
  modern: 'Moderno',
  bold: 'Negrita',
  tekkie: 'Tecnológico',
  elegant: 'Elegante',
  vibrant: 'Vibrante',
  default: 'Por defecto',
  invoicing_field_pro_forma_info: '(¿Qué es esto?)',
  pro_forma_info_modal_title: 'Información Importante Sobre Facturas Pro Forma',
  pro_forma_info_modal_description_one:
    'Una factura Pro Forma es un documento preliminar que proporciona una estimación de los detalles de la transacción, incluyendo el importe total a pagar antes de que se proporcionen los bienes o servicios. Es un acuerdo no vinculante para ayudarte a ti y a tu cliente a prever la transacción.',
  pro_forma_info_modal_description_two:
    'Esta factura es solo para <strong style="font-weight: bold">fines de visualización</strong> y no se almacenará en el sistema con otras facturas de ventas. No se incluirá en tus registros contables o en la sección de ventas. Puedes descargarla como referencia, pero <strong style="font-weight: bold">no se guardará en el sistema.</strong>',
  preview_template: 'Vista previa de plantilla',
  invoicing_add_success_modal_title: 'Factura generada correctamente',
  invoicing_add_success_modal_description: 'Factura generada correctamente.',
  invoicing_add_success_modal_description_email_button: 'Enviar email al cliente {{- name}}',
  invoicing_add_success_modal_description_email: '({{- email}}) o ',
  invoicing_add_success_modal_description_download_button: 'descargarla.',
  email_dropbox_notification_please_note: 'Ten en cuenta',
  email_dropbox_notification_body:
    'Para añadir documentos a esta sección, también puedes enviarlos al siguiente email:',
  email_dropbox_notification_dont_show_again: 'No mostrar de nuevo',
  email_dropbox_notification_dismiss: 'Descartar',
  email_dropbox_notification_email_copied: '¡Email copiado al portapapeles!',
  invoice_parsing_details_failed_to_load: 'Error al cargar vista previa de factura',
  invoice_data: 'Datos de la factura',
  payment_info: 'Información de pago',
  parsing_document_loading: 'Analizando documento, por favor espera...',
  parsing_document_success: 'Documento analizado correctamente',
  add_payment_reminders: 'Añadir recordatorios de pago',
  frequency_of_reminder: 'Frecuencia de recordatorios',
  message_of_reminder: 'Mensaje',
  payment_reminders_modal_title: 'Configurar recordatorios',
  invoicing_table_title: 'Facturas generadas',
  invoicing_table_add_buttonn: 'Nueva factura',
  invoicing_invoice_info: 'Información de la factura',
  invoicing_invoice_info_number: 'Factura {{ number }}',
  invoicing_invoice_info_number_not_parsed: 'Factura',
  invoicing_invoice_date: 'Fechas',
  invoicing_vat_info_vat_amount: 'Importe: ',
  invoicing_vat_info_vat_rate: 'Tasa: ',
  invoicing_vat_info: 'Información del IVA',
  invoicing_customer_vat_number: 'NIF: {{ vatNumber }}',
  invoicing_customer: 'Cliente',
  invoicing_total: 'Total',
  invoicing_table_options_resend: 'Enviar por email',
  invoicing_table_resend_email_error:
    'Este cliente no tiene una dirección de correo electrónico en su ficha de cliente.',
  invoicing_table_options_edit: 'Editar',
  invoicing_table_options_download: 'Descargar',
  invoicing_tab_generated: 'Facturas generadas',
  invoicing_tab_recurrent: 'Facturas recurrentes',
  invoicing_recurrent_chip: 'Recurrente',
  recurrent_invoices_table_title: 'Facturas recurrentes',
  recurrent_invoice_action_pause: 'Pausar factura recurrente',
  recurrent_invoice_action_resume: 'Reanudar factura recurrente',
  recurrent_invoice_action_update: 'Actualizar frecuencia',
  recurrent_invoice_status_active: 'Activa',
  recurrent_invoice_status_paused: 'Pausada',
  recurrent_invoice_card_title: 'Convertir en factura recurrente',
  recurrent_invoice_card_description:
    'Esta factura se generará automáticamente según la programación seleccionada. Las facturas generadas aparecerán en la pestaña Facturas generadas, mientras que la regla de recurrencia podrá gestionarse en la pestaña Facturas recurrentes.',
  recurrent_invoice_update_frequency_modal_title: 'Actualizar frecuencia',
  recurrent_invoice_update_frequency_modal_description:
    'Estás editando la configuración de recurrencia de esta factura. El ciclo actual no se verá afectado — los cambios se aplicarán a partir de la próxima fecha programada.',
  recurrent_invoice_next_invoice_label:
    'Próxima factura: {{date}} • La factura #{{number}} se generará automáticamente',
  recurrent_invoice_biweekly_days_hint: 'Las facturas se generan los días 1 y 15 de cada mes',
  recurrent_invoice_biweekly_days: '1 y 15 del mes',
  recurrent_invoice_send_automatically_title: 'Enviar factura automáticamente',
  recurrent_invoice_send_automatically_description: 'La factura se envía directamente a tu cliente',
  recurrent_invoice_notify_when_generated_title: 'Notificarme cuando se genere',
  recurrent_invoice_notify_when_generated_description: 'Recibe un correo cuando se cree la factura',
  recurrent_invoice_update_pending: 'Actualizando factura recurrente...',
  recurrent_invoice_update_success: 'Factura recurrente actualizada correctamente',
  recurrent_invoice_update_error: 'No se pudo actualizar la factura recurrente',
  recurrent_invoice_status_update_pending: 'Actualizando el estado de la factura recurrente...',
  recurrent_invoice_status_update_success:
    'Estado de la factura recurrente actualizado correctamente',
  recurrent_invoice_status_update_error: 'No se pudo actualizar el estado de la factura recurrente',
  recurrent_invoice_delete_pending: 'Eliminando factura recurrente...',
  recurrent_invoice_delete_success: 'Factura recurrente eliminada correctamente',
  recurrent_invoice_delete_error: 'No se pudo eliminar la factura recurrente',
  recurrent_invoice_summary_title: 'Factura recurrente',
  recurrent_invoice_summary_frequency: 'Frecuencia',
  recurrent_invoice_summary_frequency_value: '{{frequency}} — Cada {{detail}}',
  recurrent_invoice_summary_next_invoice: 'Próxima factura',
  recurrent_invoice_summary_auto_generated: 'La factura #{{number}} se generará automáticamente',
  recurrent_invoice_create_pending: 'Creando factura recurrente...',
  recurrent_invoice_create_success: 'Factura recurrente creada correctamente',
  recurrent_invoice_create_error: 'No se pudo crear la factura recurrente',
  all_clients_placeholder: 'Todos los clientes',
  payment_reminder_added_modal_title: '¡Recordatorio añadido!',
  payment_reminder_added_modal_description:
    'Nos aseguraremos de que tu cliente reciba recordatorios periódicos hasta que complete el pago.',
  invoice_template: 'Plantilla de factura seleccionada',
  edit_customer: 'Editar cliente',
  change_customer_invoice_template: 'Cambiar plantilla de factura',
  delete_customer: 'Eliminar cliente',
  customer_details_is_not_company: 'Este cliente no es una empresa',
  delete_customer_modal_title: 'Confirma la eliminación del cliente',
  delete_customer_modal_description:
    '¿Estás seguro de que deseas eliminar este cliente? Esta acción no se puede deshacer.',
  delete_customer_success_modal_title: 'El cliente ha sido eliminado',
  delete_customer_success_modal_description:
    'Si deseas recuperar a ese cliente en tu lista, tendrás que agregarlo nuevamente.',
  customer_updated_success_modal_title: '¡Cliente actualizado con éxito!',
  customer_updated_success_modal_description:
    'La información del cliente se ha actualizado correctamente. Ahora puedes continuar emitiendo y enviando facturas.',
  customer_added_success_modal_title: '¡Cliente agregado con éxito!',
  customer_added_success_modal_description:
    'La información del cliente se ha registrado correctamente. Ahora puedes comenzar a emitir y enviar facturas.',
  customer_update_template_modal_title: 'Actualizar plantilla de factura',
  customer_update_template_modal_description:
    'Esta plantilla se utilizará cada vez que crees una nueva factura para este cliente.',
  invoice_templates: 'Plantillas de factura',
  preview: 'Vista previa',
  invoice_template_changed_pending: 'Actualizando modelo de factura, espere un momento...',
  invoice_template_successful_changed_modal_title: '¡Plantilla actualizada con éxito!',
  invoice_template_successful_changed_modal_description:
    'La plantilla de factura para {{customerName}} se ha actualizado correctamente. Todas las facturas futuras usarán automáticamente el nuevo diseño.',
  rejection_vat_number_invalid: 'El número de IVA no es válido o está ausente',
  uploaded_date_column: 'Subido: {{date}}',
  issue_date_column: 'Fecha de emisión: {{date}}',
  invoicing_field_supplier: 'Proveedor',
  invoicing_field_instructions_supplier: 'Instrucciones de pago del proveedor',
  invoices_table_options_associate_to_contractor: 'Asociar a freelance',
  associate_to_contractor_modal_title: 'Asociar factura a freelance',
  associate_to_contractor_modal_description:
    'Por favor, selecciona un freelance para esta factura.',
  associate_to_contractor_modal_table_header_description: 'Descripción',
  associate_to_contractor_modal_table_header_date: 'Fecha',
  associate_to_contractor_modal_table_header_total: 'Total',
  associate_to_contractor_modal_select_contractor_label: 'Freelance',
  confirm_associate_invoice_to_contractor_modal_title: 'Estás a punto de asociar esta factura',
  confirm_associate_invoice_to_contractor_modal_description:
    'Antes de proceder, ¿estás seguro de que deseas asociar la factura al freelance <strong style="font-weight: bold">{{contractorName}}</strong>?',
  contractor_not_selected_error: 'Por favor, selecciona un freelance para continuar',
  invoice_associate_to_contractor_success: 'La factura se ha asociado correctamente.',
  invoice_associate_to_contractor_success_description:
    'Ahora puedes verla en el perfil del freelance.',
  associating_invoice_to_contractor_loading: 'Asociando factura al freelance, por favor espera...',
  confirm_invoice_belongs_to_another_contractor_modal_title:
    'Parece que esta factura pertenece a otro freelance',
  confirm_invoice_belongs_to_another_contractor_modal_description:
    'Nuestro sistema considera que esta factura pertenece al freelance "{{invoiceContractorName}}" (NIF {{invoiceContractorTaxId}}), pero el freelance que has seleccionado es "{{selectedContractorName}}" (NIF {{selectedContractorTaxId}}). <strong style="font-weight: bold">¿Estás seguro de que deseas continuar y asociar la factura al freelance "{{selectedContractorName}}"?</strong>',
  invoices_table_options_detach_from_contractor: 'Desvincular del freelance',
  detach_invoice_from_contractor_modal_title: 'Estás a punto de desvincular esta factura',
  detach_invoice_from_contractor_modal_description:
    'Antes de proceder, ¿estás seguro de que deseas desvincular la factura del freelance <strong style="font-weight: bold">{{contractorName}}</strong>?',
  detaching_invoice_from_contractor_loading:
    'Desvinculando factura del freelance, por favor espera...',
  detaching_invoice_from_contractor_success:
    'La factura se ha desvinculado correctamente del freelance.',
  confirm_leave_invoicing_page_modal_title: '¿Estás seguro de que deseas abandonar esta factura?',
  confirm_leave_invoicing_page_modal_description:
    'Si regresas, toda la información ingresada se perderá y tendrás que volver a ingresarla para crear la factura.',
  custom_payment_instructions_modal_title: 'Instrucciones de Pago Personalizadas',
  custom_payment_instructions_modal_description_row_one:
    'En este campo, puede ingresar instrucciones de pago específicas para la factura seleccionada. Si no se proporciona información, el sistema aplicará automáticamente las instrucciones de pago predeterminadas del cliente (si están definidas).',
  custom_payment_instructions_modal_description_row_two:
    'Si no hay instrucciones específicas del cliente disponibles, se utilizarán las instrucciones de pago globales configuradas en Ajustes.',
  late_penalty_instructions_modal_title: 'Aplicar penalización por pago tardío',
  late_penalty_instructions_modal_description_row_one:
    'Esta opción agrega una cláusula de penalización por pago tardío a la factura.',
  late_penalty_instructions_modal_description_row_two:
    'El monto de la penalización se determina por el valor especificado en el campo Tasa de Penalización y se aplica según el intervalo definido en el campo Intervalo de Penalización, comenzando después de la fecha de vencimiento.',
  late_penalty_instructions_modal_description_row_three:
    'Esto le permite cobrar una tarifa adicional por los productos o servicios vendidos por cada intervalo de pago tardío.',
  late_penalty_instructions_modal_description_row_four:
    'Tenga en cuenta que <strong style="font-weight: bold">es su responsabilidad reclamar este pago adicional.</strong>',
  choose_customer_first_placeholder: 'Seleccione un cliente primero',
  payment_reminders_modal_description:
    'Al configurar un recordatorio, su cliente recibirá notificaciones periódicas hasta que la factura esté completamente pagada.',
  schedule: 'Programar',
  invoicing_step_one_title: 'Datos de la factura',
  invoicing_step_two_title: 'Elementos de la factura',
  invoicing_step_three_title: 'Resumen',
  vat_wizard_modal_title: 'Asistente de IVA',
  vat_wizard_modal_description:
    '<p>¿No sabes qué tasa de IVA aplicar? No eres el único. Esta guía rápida te ayudará a encontrar el IVA correcto para tu factura con unas pocas preguntas sencillas.</p><p>Solo toma un momento. <strong>Empecemos con una pregunta simple para orientarte en la dirección correcta.</strong></p>',
  vat_wizard_first_option: 'Sí, tengo un número de IVA válido',
  vat_wizard_second_option: 'No, no tengo un número de IVA válido',
  has_valid_vat_number_label: '¿Tu empresa tiene un número de IVA válido?',
  vat_wizard_has_vat_description:
    'Perfecto. Ahora veamos dónde está ubicado tu cliente, esto nos ayuda a determinar las reglas de IVA correctas.',
  vat_wizard_has_vat_select_label: '¿Dónde está ubicado tu cliente?',
  country_of_company_option: 'En',
  another_eu_country_option: 'En otro país de la UE',
  outside_eu_option: 'Fuera de la UE',
  same_country_as_company: 'el mismo país que mi empresa',
  vat_wizard_has_vat_country_of_company_description:
    '<p><strong>Transacción nacional</strong></p><p>Dado que tanto tu empresa como tu cliente están en {{countryName}}, esta factura se trata como una venta local.</p><p>👉 La tasa de IVA correcta para esta factura es {{vatRate}}.</p>',
  vat_wizard_has_vat_another_eu_country_description:
    '<p>Casi listo. Un detalle más sobre tu cliente para concretar esto.</p>',
  vat_wizard_has_vat_another_eu_country_select_label: '¿Tu cliente es una empresa o un particular?',
  vat_wizard_eu_individual_option: 'Particular',
  vat_wizard_eu_company_option: 'Empresa',
  vat_wizard_has_vat_outside_eu_description:
    '<p><strong>Cliente fuera de la UE.</strong></p><p>Según las normas de IVA de la UE, las ventas a países no pertenecientes a la UE se tratan como exportaciones, por lo que no se añade IVA.</p><p>Esto se aplica independientemente de: <ul><li>si tu cliente es una empresa o un particular</li><li>si tu empresa tiene número de IVA o no</li></ul></p><p>👉 La tasa de IVA correcta para esta factura es 0%</p>',
  apply_vat: 'Aplicar IVA',
  restart_vat_wizard_process: 'Reiniciar proceso',
  vat_wizard_eu_individual_description:
    '<p>Entendido. Ahora revisemos un último detalle para determinar cómo se debe aplicar el IVA.</p>',
  vat_wizard_eu_company_description:
    '<p>Solo una última comprobación para confirmar cómo debe aplicarse el IVA. Puedes verificar el número de IVA de tu cliente en el <a href="https://ec.europa.eu/taxation_customs/vies/#/vat-validation" target="_blank" rel="noreferrer">registro oficial VIES</a>.</p>',
  vat_wizard_eu_company_select_label: '¿Tu cliente tiene un número de IVA válido?',
  vat_wizard_eu_company_has_vat_option: 'Sí, este cliente tiene un número de IVA válido',
  vat_wizard_eu_company_no_vat_option: 'No, este cliente no tiene un número de IVA válido',
  vat_wizard_eu_company_has_vat_description:
    '<p><strong>Empresa registrada en el IVA de la UE.</strong></p><p>Como ambas empresas tienen números de IVA intracomunitario de distintos países, se aplica el IVA intracomunitario inverso del 0%.</p><p>👉 La tasa de IVA correcta para esta factura es 0%</p>',
  vat_wizard_eu_company_no_vat_description:
    '<p><strong>Empresa de la UE sin número de IVA.</strong></p><p>Dado que tu cliente no está registrado en el IVA, el vendedor debe aplicar el IVA.</p><p>👉 La tasa de IVA correcta para esta factura es el IVA de {{countryName}}: {{vatRate}}</p>',
  vat_wizard_no_vat_description:
    '<p>Entendido. Ahora entendamos la naturaleza de esta transacción — esto nos ayuda a determinar si el IVA aplica.</p>',
  vat_wizard_button: 'Asistente de IVA',
  same_country_option: 'El mismo país que mi empresa',
  different_country_eu_option: 'Un país diferente en la UE',
  vat_wizard_no_vat_outside_eu_description:
    '<p><strong>Se aplica 0% de IVA</strong></p><p>Dado que su empresa no tiene un número de IVA de la UE válido y esta transacción es una exportación (fuera de la UE), se aplican las reglas de exportación.</p><p>👉 La tasa de IVA correcta en este caso es 0%</p>',
  vat_wizard_no_vat_same_country_description:
    '<p><strong>No se aplica IVA</strong></p><p>Dado que su empresa no tiene un número de IVA de la UE válido y esta transacción no es una exportación, no se debe aplicar IVA.</p><p>La única excepción es para empresas españolas que facturan dentro de España, donde puede aplicarse el IVA español.</p><p>👉 La opción correcta en este caso es "No IVA".</p>',
  vat_wizard_no_vat_different_country_eu_description:
    '<p><strong>No se aplica IVA</strong></p><p>Dado que su empresa no tiene un número de IVA de la UE válido y esta transacción no es una exportación, no se debe aplicar IVA.</p><p>La única excepción es para empresas españolas que facturan dentro de España, donde puede aplicarse el IVA español.</p><p>👉 La opción correcta en este caso es "No IVA".</p>',
  vat_wizard_eu_individual_select_label:
    '¿Está su empresa registrada en el esquema de Ventanilla Única (OSS)?',
  vat_wizard_eu_individual_has_oss_option: 'Sí',
  vat_wizard_eu_individual_no_oss_option: 'No',
  vat_wizard_eu_individual_has_oss_description:
    '<p><strong>Se aplica el IVA OSS</strong></p><p>Al facturar a un particular (no a una empresa) en la UE bajo el esquema OSS, el IVA debe aplicarse según el país del cliente.</p><p>👉 Por favor, seleccione el país de su cliente en el desplegable para aplicar la tasa de IVA correcta.</p>',
  vat_wizard_eu_individual_has_oss_select_label: '',
  vat_wizard_eu_individual_no_oss_description:
    '<p><strong>Se aplica el IVA estándar</strong></p><p>Al facturar a un particular (no a una empresa) en la UE, el IVA debe aplicarse según el país del vendedor.</p><p>👉 La tasa de IVA correcta para esta factura es {{vatRate}}</p>',
  vat_wizard_warning:
    '¿No sabe qué IVA aplicar? <strong>El Asistente de IVA puede ayudarle.</strong>',
  vat_wizard_check_for_me: 'Verificar por mí',
  vat_wizard_eu_company_vat_check_invalid_description:
    '<p><strong>Empresa de la UE sin número de IVA.</strong></p><p>Dado que su cliente no está registrado en el IVA, el vendedor debe aplicar el IVA.</p><p>👉 La tasa de IVA correcta para esta factura es {{countryName}} IVA: {{vatRate}}</p>',
  vat_wizard_eu_company_vat_check_valid_description:
    '<p><strong>Empresa de la UE con número de IVA.</strong></p><p>Como ambas empresas tienen números de IVA intracomunitario de diferentes países, se aplica 0% de IVA intracomunitario inverso.</p><p>👉 La tasa de IVA correcta para esta factura es 0%</p>',
  is_checking_vat: 'Un momento, estamos verificando...',
  vat_wizard_vat_check_error:
    'Tenemos problemas para verificar la información en este momento. Por favor, inténtelo de nuevo más tarde.',
  invoice_total_quantity: 'Cantidad:',
  invoice_total_vat: 'IVA:',
  invoice_total_vat_amount: 'Importe IVA:',
  invoice_total_price: 'Precio:',
  invoice_total_title: 'Total',
  checking_vat: 'Verificando el VAT del cliente, por favor espere...',
  not_valid_vat_modal_title: 'El VAT de este cliente ya no es válido',
  not_valid_vat_modal_description_row_one:
    'El número de VAT <strong>{{vatNumber}}</strong> de este cliente ya no aparece como válido en el <a href="https://ec.europa.eu/taxation_customs/vies/#/vat-validation" target="_blank" rel="noreferrer">registro VIES</a>. Continuar con datos de VAT desactualizados puede provocar el rechazo de la factura o problemas contables.',
  not_valid_vat_modal_description_row_two:
    '¿Deseas actualizar la información del VAT ahora antes de continuar?',
  update_vat: 'Actualizar VAT',
  vat_number_updated_successfully: 'Número de VAT actualizado correctamente',
  vat_check_success: 'Número de VAT validado correctamente',
  vat_number_update_failed:
    'No se pudo actualizar el número de VAT. Por favor, inténtalo de nuevo con un VAT válido.',
  vat_validation_service_unavailable:
    'El servicio de validación de VAT no está disponible temporalmente o está saturado. No se pudo verificar tu número de VAT en este momento; por favor, inténtalo de nuevo en unos minutos.',
  invalid_vat_format: 'Formato de VAT inválido.',
  vat_number_checked_successfully: 'Número de VAT verificado correctamente',
  customer_vat_number_update_pending: 'Actualizando el número de VAT del cliente...',
  unable_to_proceed: 'No se puede continuar. Por favor, inténtalo de nuevo.',
  update_vat_number_modal_title: 'Actualizar número de VAT',
  update_vat_number_modal_description:
    'Puedes actualizar o eliminar el número de VAT de este cliente. <strong>Por favor, elige cómo deseas proceder.</strong>',
  update_vat_number_modal_option_change: 'Cambiarlo',
  update_vat_number_modal_option_change_subtitle:
    'Los números de VAT suelen comenzar con un código de país de 2 letras (por ejemplo, ESXXXXXXXXX o FRXXXXXXXXX)',
  update_vat_number_modal_option_remove: 'Eliminarlo',
  update_vat_number_modal_option_remove_subtitle:
    'Este cliente ya no tiene un número de VAT válido.',
  update_vat_number_modal_error_description:
    '<strong>Este número de VAT puede ser incorrecto.</strong> Verifica <a href="https://ec.europa.eu/taxation_customs/vies/#/vat-validation" target="_blank" rel="noopener noreferrer">aquí</a> para evitar problemas de contabilidad y cumplimiento, y asegúrate de que pertenece a tu cliente antes de continuar.',
  update_vat_number_modal_success_description:
    '<strong>Este número de VAT es correcto.</strong> Puedes continuar con la actualización.',
  update_vat_number_modal_placeholder: 'Introduce el número de VAT',
  invoicing_field_instructions_tooltip: '(¿Qué es esto?)',
  vat_still_valid_confirm_remove_modal_title: 'Este número de VAT sigue siendo válido',
  vat_still_valid_confirm_remove_modal_description_row_one:
    'Hemos verificado este número de VAT {{vatNumber}} en el registro VAT/VIES y sigue siendo válido.',
  vat_still_valid_confirm_remove_modal_description_row_two:
    'Por favor, elimínalo solo si estás seguro de que este cliente ya no utiliza este número de VAT o si fue añadido por error.',
  keep_vat_number: 'Mantener número de VAT',
  vat_number_removed: 'El número de VAT ha sido eliminado.',
  no_vat: 'No VAT',
  invoicing_no_customers_alert:
    'Todavía no tienes clientes. Añade uno en Mi Negocio → <a href="/customers">Clientes</a> para empezar a crear facturas.',
  pro_forma_generated_modal_title: 'Tu factura proforma está lista',
  pro_forma_generated_modal_description:
    'Puedes encontrar la factura proforma generada en la pestaña de vista previa. Esta factura es únicamente para fines de visualización y no se almacenará en el sistema junto con las demás facturas de venta. No se incluirá en tus registros contables ni en la sección de ventas. Puedes descargarla como referencia y compartirla con tu cliente, pero no se guardará en el sistema.',

  // Matching Page
  invoice_matching_gross_and_fee: 'Bruto: {{ gross }}, comisión: {{ fee }}',
  invoice_matching_bank_entity: 'Entidad bancaria',
  invoice_matching_bank_status: 'Estado',
  invoice_matching_missing_documents_alert:
    '<strong>Esta transacción tiene documentos faltantes.</strong> Por favor adjunta los elementos necesarios.',
  invoice_matching_other_transactions: 'Otras transacciones',
  invoice_matching_matching_items: 'Emparejando documento, salario o viaje',
  invoice_matching_filter_similar_amount: 'Importe similar',
  invoice_matching_filter_incoming_only: 'Solo entrantes',
  invoice_matching_filter_show_matched: 'Mostrar emparejados',
  invoice_matching_other_transactions_add_button: 'Añadir nuevo',
  invoice_matching_other_transactions_empty_state: 'No hay otras transacciones aún',
  invoice_matching_matching_add_invoices_button: 'Añadir facturas subidas',
  invoice_matching_matching_upload_button: 'Subir documento',
  invoice_matching_table_document: 'Nombre del documento',
  invoice_matching_table_date: 'Fecha',
  invoice_matching_table_status: 'Estado',
  invoice_matching_table_date_from: 'Desde: ',
  invoice_matching_table_date_to: 'Hasta: ',
  invoice_matching_table_status_matched: 'Emparejado',
  invoice_matching_table_status_unmatched: 'Sin emparejar',
  invoice_matching_table_status_linked: 'Salario está enlazado',
  invoice_matching_table_status_not_linked: 'Salario no ha sido enlazado',
  invoice_matching_table_status_link_button: 'Enlazar',
  invoice_matching_table_status_unlink_button: 'Desenlazar',
  investment_add_funds: 'Inversión - Fondos añadidos',
  investment_withdraw_funds: 'Inversión - Fondos retirados',
  inner_trading: 'Actividad de Trading No Declarable',
  bank_cashback: 'Cashback Bancario',
  commission_earnings: 'Ganancias por Comisión',
  released_fund_reserve: 'Reserva de Fondos Liberada',
  received_interest: 'Interés Recibido',
  card_verification: 'Verificación de tarjeta',
  state_refund: 'Reembolso del estado',
  matched_status: 'Emparejado',
  unmatched_status: 'Sin emparejar',
  bank_statement: 'Extracto bancario',
  other_transactions_reference: 'TRANSFERENCIA: {{ reference }} | {{ recipient }}',
  unmatch: 'Desemparejar',
  confirm_unmatch_modal_title: 'Confirmar eliminación de emparejamiento para transacción',
  confirm_unmatch_modal_description:
    'Esto eliminará el emparejamiento actual para esta transacción bancaria. Esta acción no se puede deshacer. ¿Estás seguro?',
  invoice_matching_transaction_unmatched_successfully: 'Transacción desemparejada correctamente.',
  confirm_unmatch_modal_error: 'Error al desemparejar transacción.',
  invoice_matching_unmatching_transaction: 'Desemparejando transacción',
  confirm_upload_document_modal_title: 'Confirmar subida de documento',
  confirm_upload_document_modal_description:
    'Esta transacción ya ha sido enlazada a una factura, ¿fue esta transacción un pago para varias facturas?',
  adding_document_to_matching_loading: 'Añadiendo documento al emparejamiento...',
  adding_document_to_matching_success: 'Documento añadido al emparejamiento correctamente.',
  back_to_sales: 'Volver a ventas',
  back_to_purchases: 'Volver a compras',
  back_to_matching_details: 'Volver a Detalles de emparejamiento',
  back_to_home: 'Volver al inicio',
  back_to_transactions: 'Volver a las transacciones',
  back_to_matched_payments: 'Volver a Pagos conciliados',
  back_to_contractor: 'Volver al Freelancers',
  invoice_number: 'Número de factura',
  issue_date: 'Fecha de emisión',
  supplier: 'Proveedor',
  total_including_vat: 'Total (IVA incluido)',
  match_transactions: 'Emparejar transacciones',
  match_sales_invoice: 'Emparejar factura de venta',
  match_purchases_invoice: 'Emparejar factura de compra',
  transactions_table_header_description: 'Descripción',
  transactions_table_header_date: 'Fecha',
  transactions_table_header_amount: 'Importe',
  banking_fee: 'Comisión bancaria',
  gross: 'Bruto',
  held_fund_reserve: 'Reserva de Fondos Retenida',
  internal: 'Interno',
  personal_expense_refund: 'Reembolso de Gasto Personal',
  refunded_sale: 'Venta reembolsada',
  refunded_purchase: 'Compra reembolsada',
  initial_principal_payment: 'Desembolso inicial del préstamo',
  repayment_installment: 'Cuota de Reembolso',
  transactions_table_header_status: 'Estado',
  transactions_table_header_transaction_status: 'Estado de la transacción',
  transactions_table_header_matching_status: 'Estado de conciliación',
  transactions_filter_matching_status_tooltip: 'Si una transacción se ha vinculado a un registro.',
  transactions_filter_matching_status_tooltip_matched_description:
    'vinculada a una factura o gasto.',
  transactions_filter_matching_status_tooltip_unmatched_description:
    'todavía necesita ser vinculada.',
  transactions_filter_transaction_status_tooltip: 'El estado de confirmación del banco.',
  transactions_filter_transaction_status_tooltip_booked_description: 'liquidada y confirmada.',
  transactions_filter_transaction_status_tooltip_pending_description:
    'iniciada pero aún no confirmada. Siempre sin conciliar hasta que se contabilice.',
  all: 'Todos',
  match_type_error: 'Esta transacción no es del mismo tipo que el documento.',
  incoming_transaction_expenses:
    'Estás intentando emparejar una transacción entrante como un gasto. Esto solo puede suceder para facturas de crédito emitidas por tus proveedores por reembolsos. ¿Es esta una factura de crédito? ¿Estás seguro de que quieres proceder con emparejarla como un gasto?',
  outgoing_transaction_sales:
    'Estás intentando emparejar una transacción saliente como una venta. Esto solo puede suceder para facturas de crédito emitidas a tus clientes por reembolsos. ¿Es esta una factura de crédito? ¿Estás seguro de que quieres proceder con emparejarla como una venta?',
  cant_check_transaction_document:
    'No podemos confirmar si la factura corresponde con la transacción. <strong style="font-weight: bold;">Si continúas, la conciliación podría ser incorrecta.</strong>',
  linking_entity_to_transaction_success: 'Entidad enlazada a transacción correctamente.',
  linking_entity_to_transaction_error: 'Error enlazando entidad a transacción.',
  linking_entity_to_transaction_loading: 'Enlazando entidad a transacción...',
  adding_transaction_to_matching_loading: 'Añadiendo transacción al emparejamiento...',
  adding_transaction_to_matching_success: 'Transacción añadida al emparejamiento correctamente.',
  unable_to_match: 'No se pudo completar el emparejamiento. Por favor reintenta el proceso.',
  invoice_transaction_amounts_dont_match:
    'Los importes de la factura ({{invoiceAmount}}) y la transacción ({{transactionAmount}}) no coinciden. Esto solo puede ocurrir si la factura fue pagada en múltiples cuotas o si la transacción cubre múltiples facturas. ¿Estás seguro de que quieres proceder con emparejar este documento con esta transacción?',
  loan_agreement: 'Acuerdo de Préstamo',
  lent_to: 'Prestado a',
  borrowed_from: 'Prestado de',
  interest_and_installment: 'al {{interest}}% de interés en {{installment}} cuotas',
  in_progress: 'En progreso',
  created: 'Creado',
  started: 'Iniciado',
  concluded: 'Concluido',
  invoice_matching_no_customer_info: 'Sin información del cliente',
  transactions_unmatched_success_modal_title: 'Transacción desemparejada correctamente.',
  transactions_unmatched_success_modal_description:
    'Todas las entidades han sido desemparejadas correctamente.',
  travel_employee_name: 'Nombre',
  to: 'A',
  out_of_pocket: 'De bolsillo',
  match_document: 'Emparejar documento',
  net_settlement: 'Liquidación neta',
  matching_document_pending: 'Emparejando documento...',
  matching_document_success: 'Documento emparejado correctamente.',
  matching_document_error: 'Error emparejando documento.',
  documents_already_linked: 'Documentos ya enlazados',
  match_transaction: 'Emparejar transacción',
  unlink_entity_from_matching_by_matching_id_pending:
    'Desenlazando entidad del emparejamiento por id de emparejamiento...',
  unlink_entity_from_matching_by_matching_id_success: 'Entidad desenlazada correctamente.',
  unlink_entity_from_matching_by_matching_id_error:
    'Error desenlazando entidad del emparejamiento por id de emparejamiento.',
  matching_autor: 'Emparejado por: {{- author}}',
  total_documents: 'Total documentos: {{ total }}',
  total_transactions: 'Total transacciones: {{ total }}',
  match_documents: 'Emparejar documentos',
  add_uploaded_invoices_navigation_error:
    'No se encontró tipo de documento. Por favor vuelve a la página anterior y reintenta.',
  transaction_not_found: 'Transacción no encontrada',
  transaction_matching_file: 'Archivo de emparejamiento de transacción',
  bank_statement_document: 'Extracto bancario',
  reason_empty_data_matching_document:
    'Los campos mostrarán datos una vez que el documento haya sido analizado por nuestro algoritmo.',
  time_range_advanced_search: 'Rango de tiempo (Fecha de emisión)',
  uncategorized: 'Sin categoría',
  back_to_advanced_search_sales: 'Volver a la búsqueda avanzada',
  back_to_advanced_search_purchases: 'Volver a la búsqueda avanzada',
  back_to_matching_items: 'Volver a emparejar documentos',
  incomplete_invoice_data: 'Datos de factura incompletos',
  documents_have_mixed_currencies:
    'Las facturas tienen monedas diferentes. Todas las facturas deben tener la misma moneda.',

  // Banks Page
  banks_title: 'Todas las cuentas bancarias',
  banks_statements_button: 'Extractos',
  banks_add_new_button: 'Añadir nuevo',
  bank_reconnect_button: 'Reconectar',
  bank_provide_information_button: 'Proporcionar información',
  bank_provide_information_description:
    'Por favor, proporciona información adicional sobre esta cuenta bancaria.',
  bank_upload_button: 'Subir un extracto bancario',
  bank_dropdown_details: 'Detalles',
  bank_dropdown_upload_statement: 'Subir extracto',
  bank_dropdown_change_name: 'Editar nombre',
  bank_dropdown_reconnect: 'Reconectar',
  bank_dropdown_closed: 'Cuenta cerrada',
  banks_empty_state:
    'No se encontraron cuentas bancarias vinculadas a tu empresa. Para emparejar movimientos bancarios con facturas, salarios o viajes, u obtener estadísticas de ingresos y gastos de tu negocio, <0>vincula tu primera cuenta bancaria ahora</0>.',
  banks_change_name_modal_title: 'Editar nombre del banco',
  banks_change_name_modal_placeholder: 'Introduce el nuevo nombre del banco aquí',
  banks_change_name_modal_cancel_button: 'Cancelar',
  banks_change_name_modal_save_button: 'Guardar',
  banks_change_name_modal_warning:
    'El nombre del banco es el mismo que el anterior, por favor introduce un nuevo nombre.',
  banks_change_name_modal_success: 'Nombre del banco cambiado correctamente.',
  banks_change_name_error: 'Hubo un error al cambiar el nombre del banco.',
  banks_delete_success: 'Banco deshabilitado correctamente.',
  banks_delete_bank_error: 'Hubo un error al eliminar la cuenta bancaria.',
  banks_get_authorization_link_error: 'Hubo un error al conectar la cuenta bancaria.',
  bank_type_crypto: 'Tipo: Crypto',
  bank_type_crypto_exchange: 'Tipo: Crypto Exchanges',
  bank_type_bank: 'Tipo: Banco',
  bank_status_needs_migration: 'Necesita migración',
  bank_status_expires_soon: 'Pronto expirará',
  bank_status_needs_confirm_investment_account: 'Necesita confirmación',
  bank_status_has_investments_earnings: 'Ganancias de inversiones',
  bank_status_investment_account: 'Cuenta de inversión',
  bank_status_closed: 'Cerrada',
  bank_status_pending_review: 'Pendiente de revisión',
  bank_dropdown_enable_automatic_invoice_downloads: 'Recupera facturas automáticamente',
  bank_dropdown_disable_automatic_invoice_downloads: 'Dejar de recuperar facturas automáticamente',
  bank_dropdown_confirm_investment_account: 'Confirmar tipo de cuenta',
  bank_dropdown_this_is_not_investment_account: 'Esta NO es una cuenta de inversión',
  bank_dropdown_this_is_investment_account: 'Esta es una cuenta de inversión',
  bank_dropdown_update: 'Actualizar',
  bank_filter_active: 'Activo',
  bank_filter_closed: 'Cerrado',
  bank_filter_pending_review: 'Pendiente de revisión',
  bank_filter_missing_bank_account: 'Cuenta bancaria faltante',
  document_upload_pending: 'Subiendo extracto bancario...',
  document_upload_success: 'Extracto bancario subido correctamente.',
  upload_statement_premium_upgrade_title: 'Únete al plan PREMIUM',
  upload_statement_premium_upgrade_description:
    "Para gestionar eficientemente la contabilidad de tu empresa y facilitar la conciliación de facturas, es crucial tener acceso a todas tus cuentas bancarias. Ten en cuenta que nuestro plan Pro no incluye cuentas de criptomonedas. Si deseas vincular esta billetera o cuenta de criptomonedas, deberás actualizar a nuestro plan Premium. Para conocer los precios mensuales, consulta nuestra <a href='https://companio.co/pricing/' target='_blank' rel='noreferrer'>página de precios</a>. ¿Estás listo para proceder con la actualización?",
  deleting_bank_loading: 'Marcando la cuenta bancaria como cerrada...',
  deleting_bank_success: 'La cuenta bancaria se ha marcado como cerrada correctamente.',
  confirm_delete_bank_modal_title: 'Confirmar acción',
  confirm_delete_bank_modal_description:
    'Esto marcará la <strong>{{bankName}}</strong> como cerrada o inactiva. Elige esta acción si cerraste tu <strong>{{bankName}}</strong> o ya no existe. Si la <strong>{{bankName}}</strong> está inactiva -sin actividad- pero aún abierta, conecta de nuevo y manténla conectada. ¿Estás seguro de que quieres marcar esta cuenta como cerrada ahora?',
  banks_get_authorization_link_loading: 'Obteniendo enlace de autorización...',
  banks_set_investment_property_loading: 'Configurando propiedad de inversión...',
  banks_set_investment_property_success: 'Propiedad de inversión configurada correctamente.',
  confirm_account_type_modal_title: '¿Estás seguro de que deseas cambiar el tipo de cuenta?',
  confirm_account_type_modal_description:
    'Cambiar el tipo de cuenta puede afectar directamente tus registros de transacciones financieras. Si procedes con el cambio, nuestro equipo de contabilidad revisará para asegurar que se aplique el tipo de cuenta correcto. Ten en cuenta que cualquier cambio tomará un tiempo debido al proceso de revisión manual.',
  confirm_investment_account_modal_title: '¿Estás seguro de que deseas cambiar el tipo de cuenta?',
  confirm_investment_account_modal_description:
    'Cambiar el tipo de cuenta puede afectar directamente tus registros de transacciones financieras. Si procedes con el cambio, nuestro equipo de contabilidad revisará para asegurar que se aplique el tipo de cuenta correcto. Ten en cuenta que cualquier cambio tomará un tiempo debido al proceso de revisión manual.',
  banks_ask_to_change_investment_property_loading:
    '¿Estás seguro de que deseas cambiar el tipo de cuenta?',
  banks_ask_to_change_investment_property_success:
    'Cambiar el tipo de cuenta puede afectar directamente tus registros de transacciones financieras. Si procedes con el cambio, nuestro equipo de contabilidad revisará para asegurar que se aplique el tipo de cuenta correcto. Ten en cuenta que cualquier cambio tomará un tiempo debido al proceso de revisión manual.',
  banks_ask_to_change_investment_property_error:
    'An error occurred while setting the account as an investment account. Please try again.',
  bank_type_investment_account: 'Tipo: Cuenta de Inversión',
  bank_type_investment_platform: 'Tipo: Plataforma de Inversión',
  add_new_bank_premium_upgrade_description:
    'Para gestionar eficientemente la contabilidad de tu empresa y facilitar la conciliación de facturas sin problemas, es crucial tener acceso a todas tus cuentas bancarias. Ten en cuenta que nuestro plan Pro cubre hasta 3 cuentas bancarias. Si deseas vincular cuentas bancarias adicionales, deberás actualizar a nuestro plan Premium. Para conocer los detalles sobre los precios mensuales, consulta nuestra <a href="https://companio.co/pricing/" target="_blank" rel="noreferrer">página de precios</a>. ¿Estás listo para proceder con la actualización?',
  add_new_bank_ultra_upgrade_title: 'Únete al plan ULTRA',
  add_new_bank_ultra_upgrade_description:
    "Para gestionar eficientemente la contabilidad de tu empresa y facilitar la conciliación de facturas, el acceso a todas tus cuentas bancarias es fundamental. Ten en cuenta que nuestro plan Premium cubre hasta 5 cuentas bancarias. Si deseas vincular cuentas bancarias adicionales, deberás actualizar a nuestro plan Ultra. Para más detalles sobre el precio mensual, consulta nuestra <a href='https://companio.co/pricing/' target='_blank' rel='noreferrer'>página de precios</a>. ¿Estás listo para proceder con la actualización?",
  confirm_bank_account: 'Confirmar cuenta bancaria',
  bank_account_doesnt_associated_with_company:
    'Parece que esta cuenta bancaria pertenece a {{accountHolder}}, y no pudimos verificar si pertenece a tu negocio, {{companyName}}. Asegúrate de vincular la cuenta bancaria específica de tu empresa, no una cuenta personal ni la de otro negocio. ¿Podrías confirmar que esta cuenta es, de hecho, la cuenta bancaria corporativa de tu empresa?',
  no_disconnect_it: 'No, desconéctalo',
  yes_confirm_it: 'Si, confirmado',
  connect_bank_account_again:
    'Hemos eliminado la cuenta bancaria. Por favor, vuelve a conectar tu cuenta bancaria.',
  connect_bank: 'Conectar banco',
  bank_filter_needs_migration: 'Necesita migración',
  bank_filter_disconnected: 'Desconectado',
  bank_filter_expires_soon: 'Pronto expirará',
  bank_filter_connected: 'Conectado',
  bank_filter_manual: 'Manual',
  bank_dropdown_delete: 'Cuenta cerrada',
  bank_ownership_modal_title:
    'Esta cuenta bancaria parece pertenecer a una entidad distinta de tu empresa.',
  bank_ownership_modal_description_1:
    'El uso o reutilización de cuentas bancarias personales, o de cuentas bancarias pertenecientes a otras empresas (aunque seas el único propietario) para la actividad de tu empresa puede generar serios problemas contables, especialmente cuando se mezclan transacciones personales y empresariales. También puede generar preocupaciones de <b>prevención de blanqueo de capitales (AML)</b> y derivar en consecuencias legales o regulatorias.',
  bank_ownership_modal_description_2:
    'Asegúrate de que esta cuenta se utiliza legítimamente solo para tu empresa antes de continuar. <a target="_blank" rel="noreferrer" href="https://help.companio.co/es/article/puedo-usar-la-misma-cuenta-bancaria-o-de-pagos-para-varias-empresas-1872np/">Más información</a>.',
  provide_information: 'Proporcionar información',
  provide_information_description:
    'Por favor, proporciona información adicional sobre esta cuenta bancaria.',
  bank_account_status_title: '¿Cuál es el estado actual de esta cuenta bancaria?',
  bank_account_status_description:
    'Necesitamos confirmar si esta cuenta bancaria sigue activa. Por favor, revisa los detalles de la cuenta y selecciona la opción que mejor describa su estado actual.',
  bank_account_status_banner_title: 'CONFIRMA EL ESTADO DE TU CUENTA BANCARIA:',
  bank_account_status_banner_description: 'Por favor, revisa si tu cuenta bancaria sigue activa.',
  accountant_request_bank_status_active_transactions:
    'La cuenta bancaria está activa y tiene transacciones. La volveré a conectar para asegurarme de que aparezcan.',
  accountant_request_bank_status_active_no_transactions:
    'La cuenta bancaria está activa pero no tiene transacciones recientes.',
  accountant_request_bank_status_closed: 'La cuenta bancaria ha sido cerrada y ya no está activa.',
  accountant_request_bank_status_action_loading: 'Actualizando el estado de la cuenta bancaria...',
  confirm_status: 'Confirmar estado',
  bank_account_status_modal_title: 'Sube un extracto bancario reciente',
  bank_account_status_modal_description_1:
    'Dado que esta cuenta no tiene transacciones recientes, necesitamos un extracto bancario reciente para confirmar que todo está en orden. Por favor, sube un extracto bancario desde la fecha de la última transacción hasta hoy.',
  bank_account_status_modal_description_2:
    'Lo revisaremos y te informaremos si se necesita algo más.',
  accountant_request_upload_statement:
    'Sube un archivo válido en formato PDF, PNG o JPG para comenzar',
  statement_uploaded_success_modal_title: 'Extracto subido correctamente',
  statement_uploaded_success_modal_description:
    'Hemos recibido tu extracto bancario. Lo revisaremos y te notificaremos si se necesita algo más.',
  confirm_bank_account_closure_title: 'Confirmar cierre de la cuenta bancaria',
  confirm_bank_account_closure_description_1:
    'Has indicado que esta cuenta bancaria ha sido cerrada. <strong>Por favor, confirma que la cuenta ha sido oficialmente cerrada con el banco, no solo que está inactiva o sin transacciones recientes.</strong>',
  confirm_bank_account_closure_description_2:
    'Si la cuenta sigue abierta pero sin actividad, por favor selecciona "La cuenta bancaria está activa pero no tiene transacciones recientes."',
  let_me_check_first: 'Déjame verificar primero',
  bank_account_closed_success_modal_title: 'Cuenta bancaria cerrada',
  bank_account_closed_success_modal_description:
    'La cuenta ha sido marcada como cerrada en el sistema.',
  invalid_bank_connection_type: 'Tipo de cuenta bancaria no válido',
  banks_connection_error_modal_title: 'Error de conexión bancaria',
  banks_connection_error_modal_description:
    'Ocurrió un error al conectar tu banco. Por favor, inténtalo más tarde.',
  banks_connection_error_modal_reference: 'Referencia de soporte: {{ref}}',
  non_connected_bank_account: 'Cuenta bancaria no conectada',
  missing_bank_card_description:
    '<b>Puede haber una cuenta bancaria que aún no se haya conectado.</b> Revisa los detalles y conéctala o confirma que no existen cuentas adicionales.',

  // Bank Account Description
  bank_account_configured_pre: 'Tu cuenta {{ bankName }}',
  bank_account_configured_post: ' está configurada ',
  crypto_wallet_configured_post: ' cartera crypto está configurada ',
  _and_linked: 'y la API ha sido enlazada.',
  crypto_eth_only_note: ' En esta tarjeta solo se registran los movimientos de ETH.',
  crypto_erc20_native_not_tracked_note:
    'El movimiento de la dirección nativa de ETH NO se registra en esta tarjeta.',
  _but_not_linked: ' pero no hay API disponible.',
  expired: 'Caducado',
  authorization_expires: 'La autorización expira en {{days}}.',
  bank_account_deleted: ' la cuenta fue cerrada. Ya no está disponible.',

  // Add Bank Page
  banks_add_new_title: 'Conecta tus cuentas bancarias',
  banks_add_new_description:
    'Por favor, elige un proveedor bancario para comenzar. Las soluciones bancarias que recomendamos están marcadas con una insignia verde.',
  banks_add_new_open_account_button: 'Abrir cuenta bancaria',
  banks_add_new_connect_account_button: 'Conectar cuenta',
  bank_sort_option_popular: 'Popular',
  bank_sort_option_by_country: 'Por país',
  bank_sort_option_crypto_wallets: 'Carteras Crypto',
  bank_sort_option_ethereum_based_coins: 'Monedas basadas en Ethereum',
  bank_sort_option_others: 'Otros',
  bank_provider_description_allows_bank_statements:
    '{{ bank }} nos permite leer tus extractos bancarios, pero no nos permite preparar los pagos a Hacienda.',
  bank_provider_description_crypto_wallet:
    'Solo tendremos <strong style="font-weight: bold;">acceso de lectura</strong> a su wallet: podemos ver saldos y transacciones, pero nunca mover ni controlar sus fondos.',
  bank_provider_description_no_bank_statements:
    '{{ bank }} NO nos permite leer tus extractos bancarios o preparar pagos a Hacienda.',
  bank_provider_description_exchange_api:
    'Conecta tu cuenta de {{ bank }} vía API para sincronizar automáticamente depósitos, retiros y saldos.',
  banks_connect_exchange_api_modal_title: 'Conecta tu cuenta de {{ bank }}',
  banks_connect_exchange_api_modal_description_html:
    'Ingresa tus credenciales API de {{ bank }} para conectar tu cuenta. Crea una clave API de <strong>solo lectura</strong>.',
  banks_connect_exchange_api_modal_api_key_input: 'API Key',
  banks_connect_exchange_api_modal_api_secret_input: 'API Secret',
  banks_connect_exchange_api_modal_bank_name_input: 'Nombre de la cuenta',
  banks_connect_exchange_api_modal_bank_name_helper:
    'Proporciona un nombre descriptivo y distintivo para tu cuenta de {{ bank }} para identificarla fácilmente en tu panel.',
  banks_connect_through_api_modal_cancel_button: 'Cancelar',
  banks_connect_through_api_modal_link_button: 'Enlazar',
  banks_connect_through_api_modal_title: 'Conecta tu cuenta {{ bank }}',
  banks_connect_through_api_modal_description_html:
    'Para enlazar tu cuenta {{ bank }}, necesitamos que obtengas un token que nos permita acceder a tus extractos bancarios y preparar tus pagos a hacienda. En <a href="https://help.companio.co/es/article/bancos-no-incluidos-en-open-banking-como-conectarlos-oybdzo/" target="_blank" rel="noreferrer">este tutorial</a> explicamos cómo hacerlo.',
  banks_connect_through_api_modal_token_input: 'Token API',
  banks_connect_through_api_modal_bank_name_input: 'Nombre del banco',
  banks_connect_through_api_modal_linking_title: 'Enlazando tu cuenta',
  banks_connect_through_api_modal_linking_description:
    'Estamos enlazando tu cuenta bancaria y cargando tus extractos bancarios. Esto puede tomar un par de minutos. Por favor, espera hasta que el proceso haya terminado y no cierres ni recargues esta página.',
  banks_connect_through_api_modal_success_title: '¡Ya está hecho!',
  banks_connect_through_api_modal_success_description:
    'Cuenta bancaria enlazada correctamente a tu cuenta. ¡Gracias! Por favor permite 24-48h para que las transacciones empiecen a aparecer en tu sección de Movimientos Bancarios. No olvides enlazar cualquier otra cuenta bancaria de tu empresa.',
  banks_connect_through_api_modal_success_button: 'Vale',
  banks_connect_through_api_modal_error_title: '¡Algo salió mal!',
  banks_connect_through_api_modal_error_description:
    'No pudimos conectar tu cuenta con esas credenciales de API. Verifica que la clave y el secreto sean correctos y tengan los permisos de solo lectura, e inténtalo de nuevo.',
  banks_connect_through_api_modal_error_button: 'Vale',
  banks_connect_kraken_modal_title: 'Conecta tu cuenta de Kraken',
  banks_connect_kraken_modal_description_html:
    'Para enlazar tu cuenta de Kraken necesitamos una clave API de <strong>solo lectura</strong>. En Kraken, ve a <em>Configuración → API</em>, crea una nueva clave y habilita únicamente estos permisos: <strong>Query Funds</strong>, <strong>Query Ledger Entries</strong>, <strong>Query Open Orders &amp; Trades</strong> y <strong>Query Closed Orders &amp; Trades</strong>. Después pega abajo la clave API y la clave privada (secreto). Nunca podremos operar ni retirar fondos. <a target="_blank" rel="noreferrer" href="https://help.companio.co/es/article/como-conecto-mi-cuenta-de-kraken-a-companio-g6en5i/">Más información</a>.',
  banks_connect_kraken_modal_api_key_input: 'Clave API',
  banks_connect_kraken_modal_api_secret_input: 'Clave privada (secreto)',
  banks_connect_kraken_modal_bank_name_input: 'Nombre de la cuenta',
  banks_connect_kraken_modal_cancel_button: 'Cancelar',
  banks_connect_kraken_modal_link_button: 'Conectar',
  banks_connect_kraken_modal_linking_title: 'Enlazando tu cuenta',
  banks_connect_kraken_modal_linking_description:
    'Estamos enlazando tu cuenta de Kraken y cargando tus datos. Esto puede tardar unos momentos. Por favor, no cierres ni recargues esta página.',
  banks_connect_kraken_modal_success_title: '¡Ya está listo!',
  banks_connect_kraken_modal_success_description:
    'Cuenta de Kraken enlazada correctamente. ¡Gracias! Por favor permite 24-48h para que las transacciones empiecen a aparecer en la sección de Movimientos Bancarios. Importamos los últimos 90 días de historial de transacciones desde la fecha de conexión.',
  banks_connect_kraken_modal_success_button: 'Vale',
  banks_connect_kraken_modal_error_title: '¡Algo salió mal!',
  banks_connect_kraken_modal_error_description:
    'No pudimos conectar con Kraken con esas credenciales de API. Verifica que la clave y el secreto sean correctos y tengan los permisos de solo lectura, e inténtalo de nuevo.',
  banks_connect_kraken_modal_error_button: 'Vale',
  banks_connect_through_open_banking_modal_title: 'Conecta tu cuenta {{ bank }}',
  banks_connect_through_open_banking_modal_description:
    'Proporciona un nombre descriptivo y distintivo para tu cuenta bancaria para facilitar la identificación fácil dentro de tu panel.',
  banks_connect_through_open_banking_modal_bank_name_input: 'Nombre del banco',
  banks_connect_through_open_banking_modal_cancel_button: 'Cancelar',
  banks_connect_through_open_banking_modal_link_button: 'Enlazar',
  banks_connect_through_open_banking_modal_toast_pending: 'Redirigiendo al banco...',
  banks_connect_manual_modal_title: 'Enlazando tu cuenta',
  banks_connect_manual_modal_bank_type_input: 'Nombre del banco',
  banks_connect_manual_modal_account_holder_input: 'Nombre del titular de la cuenta bancaria',
  banks_connect_manual_modal_Balances: 'Saldos',
  banks_connect_manual_modal_iban_input: 'IBAN',
  banks_connect_manual_modal_currency_input: 'Moneda',
  banks_connect_manual_modal_balance_name_input: 'Nombre del saldo',
  banks_connect_manual_modal_add_more_button: 'Añadir más',
  banks_connect_manual_modal_success_description:
    'Cuenta bancaria enlazada correctamente a tu cuenta. ¡Gracias! No olvides enlazar cualquier otra cuenta bancaria de tu empresa.',
  banks_connect_ibrit_modal_title: 'Conectar Interactive Brokers',
  banks_connect_ibrit_modal_description_html:
    'Introduce tus credenciales del servicio web IBRIT. Puedes encontrar tu Token y Query ID en tu portal de Interactive Brokers en Reporting &gt; Third-Party Reports &gt; Third-Party Data Feeds. <a target="_blank" rel="noreferrer" href="https://help.companio.co/es/article/como-conectar-interactive-brokers-con-companio-usando-tu-token-y-query-id-qx7g5d/">Más información</a>.',
  banks_connect_ibrit_modal_token_input: 'Token',
  banks_connect_ibrit_modal_query_id_input: 'Query ID',
  banks_connect_ibrit_modal_bank_name_input: 'Nombre de la cuenta bancaria',
  banks_connect_ibrit_modal_success_description:
    'Cuenta de Interactive Brokers enlazada correctamente. Tus saldos y transacciones se sincronizarán automáticamente y pueden tardar unas horas (alrededor de 2-6h) en empezar a aparecer en la sección de Movimientos Bancarios. Importamos los últimos 90 días de historial de transacciones desde la fecha de conexión.',
  banks_connect_ibrit_modal_error_description:
    'No se pudo enlazar tu cuenta de Interactive Brokers. Verifica que tu Token y Query ID sean correctos e inténtalo de nuevo.',
  banks_connect_crypto_modal_title: 'Conecta tu billetera corporativa',
  banks_connect_crypto_modal_wallet_name_input: 'Nombre de la cartera',
  banks_connect_crypto_modal_wallet_name_description:
    "Usa un nombre descriptivo y único para tu cartera para identificarla fácilmente entre otras en tu panel de control. Por ejemplo, 'Ahorros de criptomonedas' o 'Cartera de trading'.",
  banks_connect_crypto_modal_wallet_address_input: 'Dirección de la cartera',
  banks_connect_crypto_modal_wallet_address_description:
    'Esta es una cadena alfanumérica única que sirve como la ubicación virtual donde se almacena tu criptomoneda. Cada criptomoneda tiene un formato de dirección diferente, así que asegúrate de introducir la correcta que corresponde al tipo de moneda de tu cartera.',
  banks_connect_crypto_modal_wallet_cancel_button: 'Cancelar',
  banks_connect_crypto_modal_wallet_add_button: 'Enlazar',
  banks_connect_crypto_modal_wallet_next_button: 'Siguiente',
  banks_connect_crypto_modal_verification_title: 'Prueba de propiedad de la cartera',
  banks_connect_crypto_modal_verification_description:
    'Por favor, sube un documento que acredite la propiedad de esta cartera. Formatos aceptados: PDF, JPG, PNG (máx. 2 MB).',
  banks_connect_crypto_modal_verification_upload_description:
    'Suelta tu archivo aquí o haz clic para buscar',
  banks_connect_crypto_modal_verification_back_button: 'Atrás',
  banks_connect_crypto_modal_verification_submit_button: 'Enviar',
  banks_connect_crypto_modal_linking_title: 'Enlazando tu cuenta',
  banks_connect_crypto_modal_linking_description:
    'Estamos enlazando tu cartera crypto y cargando tus extractos bancarios. Esto puede tomar un par de minutos. Por favor, espera hasta que el proceso haya terminado y no cierres ni recargues esta página.',
  banks_connect_crypto_modal_success_title: '¡Ya está hecho!',
  banks_connect_crypto_modal_success_p1:
    'Cartera crypto enlazada correctamente a tu empresa. ¡Gracias!',
  banks_connect_crypto_modal_success_p2:
    'Por favor permite 24-48 horas para que las transacciones empiecen a aparecer en tu sección de Movimientos Bancarios.',
  banks_connect_crypto_modal_success_p3:
    'En esta cartera solo se registran los movimientos de ETH. Importamos tu historial disponible empezando por las transacciones más recientes; las carteras con un historial muy extenso pueden importarse parcialmente.',
  banks_connect_crypto_modal_success_p4:
    'Si esta dirección también contiene tokens ERC-20 (USDC, USDT, etc.), conecta cada token por separado en la pestaña “Ethereum Based Coins” para registrarlos como activos independientes.',
  banks_connect_crypto_modal_success_p5: 'No olvides enlazar cualquier otra cartera de tu empresa.',
  banks_connect_crypto_modal_success_button: 'Vale',
  banks_connect_crypto_modal_pending_title: 'En revisión',
  banks_connect_crypto_modal_pending_description:
    'Tu cartera crypto ha sido enviada correctamente y está actualmente en revisión. Por favor permite 24-48 horas para que verifiquemos la prueba de propiedad. Nos pondremos en contacto contigo si surge alguna pregunta; de lo contrario, tu cartera se conectará automáticamente.',
  banks_connect_crypto_modal_error_title: 'Ups! algo salió mal.',
  banks_connect_crypto_modal_error_description:
    'La dirección de criptomoneda proporcionada es inválida. Por favor verifica la dirección y vuelve a intentarlo. Las direcciones de criptomoneda deben cumplir con el formato y longitud correctos especificados para la blockchain respectiva. Asegúrate de que no haya errores tipográficos o espacios extra.',
  banks_connect_crypto_modal_error_button: 'Vale',
  bank_provider_description_erc20_wallet:
    'Solo tendremos <strong style="font-weight: bold;">acceso de lectura</strong> a tu cartera: podemos ver saldos y transacciones, pero nunca mover ni controlar tus fondos.',
  banks_connect_erc20_modal_title: 'Añadir cartera de tokens ERC-20',
  banks_connect_erc20_modal_description_html:
    'Haz seguimiento de los tokens ERC-20 de una cartera de Ethereum. Solo tendremos <strong>acceso de solo lectura</strong>: podemos ver saldos y transacciones, pero nunca podremos mover ni controlar tus fondos. <a target="_blank" rel="noreferrer" href="https://help.companio.co/es/article/que-billeteras-cripto-y-criptomonedas-admite-companio-1yzywha/">Más información</a>.',
  banks_connect_erc20_address_input: 'Dirección de la cartera ERC-20',
  banks_connect_erc20_address_description:
    'Introduce la dirección de la cartera que contiene los tokens ERC-20 que quieres registrar.',
  banks_connect_erc20_discover_button: 'Descubrir tokens',
  banks_connect_erc20_discovering_title: 'Descubriendo tokens',
  banks_connect_erc20_discovering_description:
    'Escaneando tu dirección en busca de tokens ERC-20...',
  banks_connect_erc20_no_tokens_found:
    'No se encontraron tokens ERC-20 con saldo para esta dirección.',
  banks_connect_erc20_select_token_title: 'Selecciona un token',
  banks_connect_erc20_select_token_description:
    'Elige un token para enlazarlo como una cuenta independiente.',
  banks_connect_erc20_wallet_name_input: 'Nombre de la cartera (opcional)',
  banks_connect_erc20_wallet_name_description:
    'Un nombre descriptivo para identificar esta cuenta de token.',
  banks_connect_erc20_default_wallet_name: 'Cartera {{ symbol }}',
  banks_connect_erc20_cancel_button: 'Cancelar',
  banks_connect_erc20_link_button: 'Enlazar token',
  banks_connect_erc20_linking_title: 'Enlazando tu token',
  banks_connect_erc20_linking_description:
    'Estamos creando tu cuenta de token ERC-20 y cargando tu historial de transacciones. Esto puede tomar un par de minutos. Por favor, espera hasta que el proceso haya terminado y no cierres ni recargues esta página.',
  banks_connect_erc20_success_title: '¡Token enlazado correctamente!',
  banks_connect_erc20_success_description:
    'Tu cartera de tokens ERC-20 ya está conectada. Por favor permite 24-48h para que aparezcan las transacciones. Importamos los últimos 90 días de historial de transacciones desde la fecha de conexión.',
  banks_connect_erc20_success_button: 'Vale',
  banks_connect_erc20_error_title: 'Algo salió mal.',
  banks_connect_erc20_error_description:
    'No pudimos enlazar este token. Por favor verifica la dirección e inténtalo de nuevo.',
  banks_connect_erc20_error_button: 'Vale',
  banks_add_new_get_banks_by_country_error: 'Hubo un error al recuperar los bancos del país.',
  banks_add_new_crypto_wallets_description:
    'Solo se permiten criptomonedas admitidas. Asegúrate de elegir una de la lista a continuación. ¿Necesitas una diferente? <a href="https://help.companio.co/es/" target="_blank" rel="noreferrer">Contáctanos</a>.',
  bank_connect_button_popular: 'Conectar cuenta existente',
  bank_connect_button_by_country: 'Conectar cuenta existente',
  bank_connect_button_crypto_wallets: 'Vincular nueva billetera',
  bank_connect_button_ethereum_based_coins: 'Conectar cartera',
  banks_erc20_grid_info_message:
    'Solo se permiten criptomonedas admitidas. Asegúrate de elegir una de la lista a continuación. ¿Necesitas una diferente? <a href="mailto:support@companio.co">Contáctanos.</a>',
  banks_erc20_grid_search_placeholder: 'Buscar por nombre o código ERC-20',
  banks_erc20_grid_fetch_error:
    'No hemos podido cargar la lista de tokens. Comprueba tu conexión a internet e inténtalo de nuevo.',
  bank_connect_button_others: 'Conectar cuenta existente',
  bank_connect_country_description:
    '{{bank}} permite que leamos sus extractos bancarios, pero no nos permite preparar los pagos a hacienda.',
  open_bank_account: 'Abrir cuenta bancaria',
  banks_connect_through_link_modal_title: 'Conecta tu {{ bank }} cuenta',
  banks_connect_through_link_modal_description:
    'Proporciona un nombre descriptivo y distintivo para tu cuenta bancaria para facilitar su identificación dentro de tu panel de control.',
  banks_connect_through_link_modal_bank_name_input: 'Nombre de la cuenta bancaria',
  banks_connect_through_link_modal_cancel_button: 'Cancelar',
  banks_connect_through_link_modal_link_button: 'Conectar',
  banks_create_payoneer_registration_link_loading: 'Creando enlace de registro de Payoneer...',
  banks_connect_manual_modal_balance_name_input_kraken: 'ID Público de Kraken',
  banks_connect_manual_modal_balance_name_input_interactive_brokers: 'Número de Cuenta',
  banks_connect_through_open_banking_info_modal_title: 'Antes de conectar tu cuenta de Wise',
  banks_connect_through_open_banking_info_modal_description:
    'Durante el proceso de conexión, deberás <strong>seleccionar manualmente todos los balances de divisas</strong> para que podamos acceder a los datos bancarios completos.',
  banks_connect_through_open_banking_info_modal_continue_button: 'Continuar',

  // Customers Page
  customers_title: 'Todos los clientes',
  customers_add_customer: 'Añadir cliente',
  customers_table_column_name: 'Nombre completo',
  customers_table_column_location: 'Ubicación',
  customers_table_column_tax: 'ID fiscal e IVA',
  customers_table_column_email: 'Email y teléfono',
  customers_actions_see_details: 'Ver detalles',
  customers_actions_add_new_invoice: 'Añadir nueva factura',
  customers_person: 'Individual / Persona',
  customers_company: 'Cliente empresarial',
  customers_cell_tax_id: 'ID FISCAL: {{ tax_id }}',
  customers_cell_vat: 'IVA: {{ vat }}',
  customers_deleted_pending: 'Eliminando cliente...',
  customers_deleted_success: 'Cliente eliminado correctamente.',
  customers_deleted_error: 'Hubo un error al eliminar el cliente.',
  customers_empty_state: 'No se encontraron clientes.',
  customer_modal_add_title: 'Añadir cliente',
  customer_modal_edit_title: 'Actualizar cliente',
  customer_modal_image_description:
    'Una foto del cliente te facilitará localizar este cliente en la lista. Tamaño máximo de foto 2 MB.',
  customer_modal_upload_photo: 'Subir foto',
  customer_modal_full_name_placeholder: 'Introduce el nombre del cliente',
  customer_modal_email_placeholder: 'Introduce el correo electrónico',
  customer_modal_phone_placeholder: 'Introduce el número de teléfono',
  customer_modal_tax_id_placeholder: 'Introduce el ID fiscal',
  customer_modal_vat_placeholder: 'ej. EE123456789',
  customer_modal_address_placeholder: 'Introduce la dirección',
  customer_modal_custom_payment_instructions_placeholder:
    'Introduce las instrucciones de pago personalizadas',
  customer_modal_currency_placeholder: 'Selecciona la moneda',
  customer_create_pending: 'Creando cliente...',
  customer_create_success: 'Cliente creado correctamente.',
  customer_create_error: 'Hubo un error al crear el cliente.',
  customer_edit_pending: 'Actualizando cliente...',
  customer_edit_success: 'Cliente actualizado correctamente.',
  customer_edit_error: 'Hubo un error al actualizar el cliente.',
  customer_filter_placeholder: 'Nombre, Email, País, Número de teléfono',
  customers_actions_update_customer: 'Actualizar cliente',

  // Customer Details
  customer_details_is_company: 'Este cliente es una empresa',
  customer_details_edit_customer: 'Editar cliente',
  customer_details_latest_invoices: 'Últimas facturas',
  customer_details_new_invoice: 'Nueva factura',
  customer_details_column_document: 'Nombre del documento',
  customer_details_column_date: 'Fecha',
  customer_details_column_status: 'Estado',
  customer_details_search_placeholder: 'Buscar factura',
  customer_details_latest_invoices_tooltip:
    '<strong style="font-weight: bold;">Nota:</strong> Esta lista contiene solo facturas generadas a través de los herramientas de Companio.',
  preferred_currency: 'Moneda preferida para facturas',

  // Settings Page
  settings_tab_profile: 'Perfil',
  settings_tab_team: 'Equipo',
  settings_tab_referral: 'Recomendaciones',
  settings_tab_billing: 'Facturación',
  settings_tab_automation: 'Automatización',
  settings_tab_others: 'Otros',
  settings_tab_subscription: 'Suscripción',
  settings_tab_legal_contact: 'Contacto legal',
  contact_us: 'Contáctanos',

  // Profile Page
  settings_profile_title: 'Editar perfil',
  settings_edit_user_title: 'Editar usuario',
  settings_profile_avatar:
    'Tu foto se mostrará a otros cuando envíes o respondas a mensajes. Tamaño máximo de foto 2 MB.',
  user_profile_update_pending: 'Actualizando perfil...',
  user_profile_update_success: 'Perfil actualizado correctamente.',
  user_profile_update_error: 'Hubo un error al actualizar tu perfil.',
  user_profile_create_pending: 'Creando usuario...',
  user_profile_create_success: 'Usuario creado correctamente.',
  user_profile_create_error: 'Hubo un error creando el usuario.',
  settings_email_modal_title: 'Revisa tu bandeja de entrada',
  settings_email_modal_description:
    'Te enviamos un email con un enlace de confirmación. Haz clic en él para confirmar tu nueva dirección de email.',
  add_member_title: 'Añadir Usuario',
  send_verification_code: 'Enviando código de verificación...',
  send_verification_code_success: 'Código de verificación enviado correctamente',
  send_verification_code_error: 'Se produjo un error al enviar el código de verificación',
  check_verification_code: 'Comprobando código de verificación...',
  check_verification_code_success: 'Código de verificación comprobado correctamente...',
  check_verification_code_error: 'Se produjo un error al comprobar el código de verificación',

  // Team Page
  team_table_title: 'Equipo',
  search_team_member: 'Buscar miembro del equipo',
  set_user_representative_pending: 'Actualizando usuario...',
  set_user_representative_success: 'Rol de usuario actualizado correctamente.',
  set_user_representative_error: 'Hubo un error al actualizar el rol del usuario.',
  delete_user_pending: 'Eliminando usuario...',
  delete_user_success: 'Usuario eliminado correctamente.',
  delete_user_error: 'Hubo un error al eliminar el usuario.',
  confirm_deletion_description: '¿Estás seguro de que quieres eliminar este usuario?',
  invalid_email_form_error:
    'Por favor, introduce una dirección de correo electrónico válida, por ejemplo: nombre@ejemplo.com',
  delete_user: 'Eliminar usuario',
  full_name_and_role: 'Nombre completo y cargo',
  e_residency_dates: 'Fechas de la tarjeta de e-Residency',
  contact_details: 'Datos de contacto',

  // Manage Subscription Page
  manage_subscription_title: 'Gestionar suscripción',
  manage_subscription_plan_information: 'Información del plan',
  cancelation_plan_modal_title: 'La cancelación requiere asistencia',
  cancelation_plan_modal_description:
    'Para proceder con la cancelación, por favor contacta a nuestro equipo de Atención al Cliente vía <a href="https://go.crisp.chat/chat/embed/?website_id=92ee1c03-fe47-44ef-8782-1f8593e54d6a" target="_blank" rel="noreferrer">chat</a>. Uno de nuestros agentes te ayudará con el proceso de baja.',
  one_month_from_last_change:
    '<strong>Ya tienes un cambio de plan programado para el {{date}}.</strong> Por favor, espera a que se complete o cancélalo para realizar un nuevo cambio.',
  plan_changed_too_soon:
    '<strong>Tu plan se cambió recientemente</strong>. Podrás cambiar tu plan nuevamente el <strong>{{date}}</strong>',
  plan_changed_recently: 'Plan cambiado recientemente',

  // Change Plan Page
  confirm_change_plan: 'Confirmar',
  page_title_change_plan: 'Volver a gestionar suscripción',
  plan_info_request_error: 'Error al obtener la información del plan',
  plan_description_pro:
    'Incluye contabilidad completa de empresa e informes mensuales en cumplimiento con regulaciones, con soporte para 1 cuenta bancaria y hasta 100 documentos.',
  plan_description_premium:
    'Incluye contabilidad completa de empresa e informes mensuales en cumplimiento con regulaciones, más soporte para hasta 3 cuentas bancarias y 500 documentos, junto con acceso a seguimiento de crypto e inversiones.',
  plan_description_ultra:
    'Incluye contabilidad completa de empresa e informes mensuales en cumplimiento con regulaciones, con soporte para hasta 10 cuentas bancarias y 5,000 documentos.',
  change_plan_warning:
    'Al actualizar tu plan, se cobrará un nuevo importe según el plan que selecciones. Ten en cuenta que los beneficios y características de tu suscripción cambiarán. Recomendamos revisar cuidadosamente lo que está incluido en tu nuevo plan antes de confirmar.',
  month_abreviation: 'mes',
  plan_title_pro: 'Plan Pro',
  plan_title_premium: 'Plan Premium',
  plan_title_ultra: 'Plan Ultra',
  change_plan_modal_title: '¿Estás seguro de que quieres cambiar tu plan?',
  change_plan_modal_description:
    'Se te cobrará el nuevo importe en tu próxima factura. Recuerda que esto puede cambiar las características que tenías en tu plan anterior.',
  change_plan_modal_confirm_button: `¡Vamos a ello!`,
  change_plan_modal_cancel_button: 'Cambié de opinión',
  plan_update_pending: 'Actualizando plan...',
  plan_update_error: 'Error al actualizar plan',
  update_plan_modal_title_upgrade: `¡Has actualizado tu plan!`,
  update_plan_modal_title_downgrade: `¡Has cambiado a un plan inferior!`,
  update_plan_modal_description:
    'Puedes ver los detalles en tu configuración. Pagarás el nuevo importe en tu próxima factura.',
  cannot_downgrade_modal_title: 'No puedes cambiar a un plan inferior en este momento',
  cannot_downgrade_modal_description_one:
    'Tu cuenta actualmente incluye funcionalidades que solo están disponibles en el plan Premium.',
  cannot_downgrade_modal_description_two:
    'Para cambiar a un plan inferior, estas funcionalidades deben eliminarse primero.',
  cannot_downgrade_modal_description_three:
    '<strong>Por favor, contáctanos</strong> a través del <a href="https://go.crisp.chat/chat/embed/?website_id=92ee1c03-fe47-44ef-8782-1f8593e54d6a" target="_blank" rel="noreferrer">chat</a> — estaremos encantados de ayudarte.',
  cannot_downgrade_modal_description_four:
    'Una vez que tu cuenta cumpla con los requisitos del plan seleccionado, se realizará el cambio a un plan inferior.',
  pending_plan_change_modal_title: 'Cambio de plan pendiente',
  pending_plan_change_modal_description:
    '<strong>Ya tienes un cambio de plan programado para el {{date}}</strong>. Por favor, espera a que se complete o cancélalo para realizar un nuevo cambio.',
  change_plan_modal_title_downgrade: '¿Estás seguro de que deseas cambiar a un plan inferior?',
  change_plan_modal_title_upgrade: '¿Estás seguro de que deseas cambiar a un plan superior?',
  change_plan_modal_description_downgrade_one:
    'Tu plan no se cambiará inmediatamente. Si continúas, el cambio se aplicará automáticamente <strong>después de tu próximo ciclo de facturación mensual.</strong>',
  change_plan_modal_description_downgrade_two:
    '<strong>Ten en cuenta:</strong> las funcionalidades premium como Proyectos, Workflows, OSS y otras herramientas avanzadas están incluidas en el plan Premium y se desactivarán si cambias a un plan inferior.',
  change_plan_modal_description_upgrade_one:
    'Tu plan no se actualizará inmediatamente. Si continúas, el cambio se aplicará <strong>después de tu próximo ciclo de facturación mensual.</strong>',
  change_plan_modal_description_upgrade_two:
    'Recuerda que esto puede desbloquear nuevas funcionalidades que no están incluidas en tu plan actual.',

  // Pro benefits
  total_remote_transactions: 'Hasta 1.000 transacciones',
  total_bank_accounts_remote:
    'Hasta 3 cuentas bancarias <a href="https://companio.co/supported-banks/">compatibles</a>',
  total_annual_report_remote: 'Informe anual (+€250/año)',
  total_board_member_remote: '+€89 por salario de Miembro del Consejo',
  total_incorporation_fee_remote: '€390 tarifa única de constitución de empresa',
  hire_freelancers: 'Contratar y pagar freelancers',

  // Premium benefits
  total_transactions_crypto: 'Hasta 1.000 transacciones',
  total_bank_accounts_crypto:
    'Hasta 5 cuentas bancarias <a href="https://companio.co/supported-banks/">compatibles</a>',
  total_board_member_salary_crypto: '+€59 por salario de Miembro del Consejo',
  total_annual_report_crypto: 'Informe anual (+€250/año)',
  total_incorporation_fee_crypto: '<s>€390</s> €265 tarifa única de constitución de empresa',

  // Ultra benefits
  total_transactions_ultra:
    'Transacciones ilimitadas. <a href="https://companio.co/?page_id=12450&preview=true#">Ver más</a>',
  total_bank_accounts_ultra:
    'Cuentas bancarias <a href="https://companio.co/supported-banks/#section_3">compatibles</a> ilimitadas',
  total_board_member_salary_ultra: '+€59 por salario de Miembro del Consejo',
  total_annual_report_ultra: 'Informe anual (+€250/año)',
  total_incorporation_fee_ultra: '<s>€390</s> €265 tarifa única de constitución de empresa',

  // All plan benefits
  legal_address: 'Dirección legal y persona de contacto',
  full_accounting: 'Contabilidad y cumplimiento normativo completos',
  all_in_one_dashboard: 'Panel de control todo en uno',
  automatic_bank_reconciliation: 'Conciliación bancaria automática',
  crypto_payments:
    'Pagos e inversiones en cripto en plataformas <a href="https://companio.co/supported-banks/#section_3">compatibles</a>',
  trading_and_investments:
    'Trading e inversiones en plataformas <a href="https://companio.co/supported-banks/#section_3">compatibles</a>',
  oss: 'OSS y Amazon FBA',
  hiring_international_employees:
    'Contratación de empleados internacionales (requiere <a href="https://companio.co/hiring-internationally/">complemento</a>)',

  // Referral Page
  referral_header_title: '¡Recomienda a un amigo y obtén 50€!',
  referral_header_subtitle: '¿Cómo funciona el Programa de Recomendaciones?',
  referral_header_description:
    '¿Eres un usuario feliz de Companio? ¡Esperamos que sí! Ahora puedes recomendar nuestros servicios a otros emprendedores y freelancers. Ambos obtendréis un descuento de €50. ¿Cómo funciona?',
  referral_step_1_title: 'Comparte tu enlace',
  referral_step_1_description:
    'Comparte el enlace que encontrarás a continuación en tu blog, perfil de redes sociales o canal de Youtube, o simplemente envíaselo a un amigo.',
  referral_step_2_title: '¡Obtén 50€!',
  referral_step_2_description:
    'Cada vez que alguien registre su negocio usando tu enlace, obtendrá un descuento de €50 en el precio de registro de la empresa, y tú obtendrás un descuento de €50 en tu próxima cuota mensual.',
  referral_sharing_title: '¡Empieza a compartir tu enlace!',
  referral_sharing_description:
    'Simplemente haz clic en el botón para copiar el enlace de recomendación, o usa uno de los botones de compartir en redes sociales de abajo para enviarlo directamente.',
  referral_link: 'Tu Enlace de Recomendación',
  referral_share_your_link: '¡Comparte tu enlace!',
  referral_history_button: 'Ver historial de recomendaciones',
  referral_copy_button: 'Copiar Enlace de Recomendación',

  // Referral History Page
  referral_table_title: 'Historial de recomendaciones',
  referral_type_received_discount: 'Recibido',
  referral_type_discount_applied_in_accountancy: 'Aplicado',
  referral_description_received_discount: 'Enlace de recomendación usado por',
  referral_description_discount_applied_in_accountancy: 'Descuento aplicado a servicios mensuales',
  referral_description_monthly_accountancy: 'Contabilidad mensual',
  balance: 'Saldo',
  total_earned: 'Total ganado',

  // Billing page
  add_payment_method_button: 'Añadir Nuevo Método de Pago',
  set_primary_payment_method_pending: 'Estableciendo método de pago principal...',
  set_primary_payment_method_success: 'Método de pago principal establecido correctamente.',
  set_primary_payment_method_error: 'Hubo un error al establecer el método de pago principal.',
  delete_payment_method_pending: 'Eliminando método de pago...',
  delete_payment_method_success: 'Método de pago eliminado correctamente.',
  delete_payment_method_error: 'Hubo un error al eliminar el método de pago.',
  transaction_history_title: 'Historial de transacciones',
  save_credit_card: 'Guardar tarjeta de crédito',
  card_added_success: 'Tarjeta añadida correctamente',
  suggest_sales_email_request_error: 'Error al obtener email sugerido de ventas',
  suggest_purchase_email_request_error: 'Error al obtener email sugerido de compras',
  upload_proof_of_payment: 'Subir comprobante de pago',
  customer_charged_success: '¡Se te cobró correctamente!',
  retry_payment_processing_status:
    '¡El pago se está procesando, una vez que se liquide el pago te notificaremos!',
  retry_payment_requires_action_status:
    'Tu pago requiere atención. Por favor toma la acción necesaria haciendo clic en el menú de tres puntos en esta línea de transacción.',
  error_message_title: 'Ups! algo salió mal \uD83D\uDE14',
  confirm_payment: 'Confirmar pago',
  search_reports: 'Buscar informes',
  travels_table_header_status: 'estado',
  proof_of_payment_upload_error: 'Error al subir comprobante de pago',
  transaction_table_header_status: 'Estado',
  transaction_table_title: 'Historial de transacciones',
  payment_status_processing: 'Procesando',
  payment_status_requires_action: 'Requiere acción',
  retry_payment_pending: 'Reintentando pago...',
  retry_payment_error: 'Hubo un error al procesar el reintento de pago',
  bank_card: 'Tarjeta bancaria',
  no_payment_method: 'No se encontró ningún método de pago',
  search_transactions: 'Buscar por servicio',
  plan: 'Plan',
  invoices_transaction_history: 'Facturas',
  discount: 'Descuento:',
  penalty: 'Penalización:',
  no_charge_information_available: 'No hay información de cobro disponible',
  tier_1: 'nivel 1',
  tier_1_40: 'nivel 1 - 40',
  tier_41_200: 'nivel 41 - 200',
  tier_201_500: 'nivel 201 - 500',
  tier_501_1000: 'nivel 501 - 1000',
  tier_1000_plus: 'nivel 1000+',
  confirm_delete_payment_card_modal_title: 'Estás a punto de eliminar un método de pago',
  confirm_delete_payment_card_modal_description:
    'Una vez que elimines esta tarjeta, <strong>no estará disponible para futuros pagos</strong>. Siempre puedes añadirla nuevamente si la necesitas. <br /> <br /> Usaremos automáticamente tu otra tarjeta guardada para los próximos cargos.',
  full_amount_to_pay: 'Importe total: {{amount}}',
  payment_verified_success: 'Pago verificado correctamente',
  base_amount: 'Importe base: {{baseAmount}}',
  penalty_days: 'Número de días de retraso: {{penaltyDays}}',
  penalty_amount: 'Importe de la penalización: {{penaltyAmount}}',
  blocked: 'Bloqueado',
  payment_blocked_modal_title: 'Tu método de pago está bloqueado',
  payment_blocked_modal_description:
    'El pago no pudo completarse porque esta tarjeta ha sido bloqueada por tu banco. <br /> <br /> <strong>Por favor, reemplaza el método de pago para continuar con tu compra.</strong>',
  add_payment_blocked_title: 'Este método de pago está marcado como bloqueado',
  add_payment_blocked_description:
    'Esta tarjeta fue utilizada anteriormente para un pago que fue bloqueado por tu banco. <br /> <br /> Si el problema ha sido resuelto, <strong>puedes intentar agregar la tarjeta nuevamente</strong>. De lo contrario, te recomendamos contactar con tu banco antes de continuar.',
  add_again: 'Agregar nuevamente',
  updating_blacklist_payment_methods: 'Agregando método de pago, por favor espera...',
  card_already_added:
    '¡Ups! Esta tarjeta ya ha sido agregada a tus métodos de pago. Por favor, intenta con una tarjeta diferente.',

  // Travels page
  travels_title: 'Viajes',
  travels_add_new_button: 'Añadir nuevo',
  travels_filter_arriving: 'Llegando',
  travels_filter_arrived: 'Llegado',
  travels_filter_pending_payment: 'Pago Pendiente',
  travels_filter_shipment_paid: 'Envío Pagado',
  travels_filter_sent: 'Enviado',
  travels_filter_delivered: 'Entregado',
  travels_filter_lost: 'Perdido',
  travels_filter_permission_needed: 'Permiso Necesario',
  no_access_to_page: 'No tienes permiso para acceder a esta página',
  travels_table_header_add_travel_button: 'Añadir nuevo',
  travels_table_title: 'Todos los Viajes',
  travels_table_header_employee: 'Viajero',
  deleted_employee: 'Empleado eliminado',
  travels_table_header_Locations: 'Ubicaciones',
  travels_table_header_dates: 'Fechas',
  travels_table_header_expenses: 'Gastos',
  travels_table_daily_allowance: 'Dieta diaria',
  travels_table_daily_status: 'Estado',
  travel_source: 'Origen',
  travel_destination: 'Destino',
  travel_date_from: 'Desde',
  travel_date_to: 'Hasta',
  travel_expenses_accom: 'Aloj',
  travel_expenses_travel: 'Viaje',
  travel_daily_expense_allowed: 'Permitido',
  travel_daily_expense_not_allowed: 'No permitido',
  see_travel_details: 'Ver detalles del viaje',
  download_busisness_contract: 'Descargar el informe oficial del viaje de negocios',
  add_non_deductible_receipt: 'Añadir un recibo o billete no deducible',
  daily_allowance_info: '¿Cuánto es la dieta diaria?',
  mark_as_completed: 'Marcar como completado',
  mark_as_completed_success:
    '<strong>El informe {{type}} ha sido marcado como completado.</strong> ¡Gracias por mantenerte al día con tu contabilidad!',
  SHIPMENT_PAID: 'ENVÍO PAGADO',
  board_members: 'Miembros del consejo',
  contractors_and_employees: 'Freelancers y Empleados',
  approved: 'Aprobado',
  completed: 'Completado',
  deleted: 'Eliminado',
  rejected: 'Rechazado',
  daily_allowance_info_text:
    'Si eres miembro del consejo, tienes derecho a pedir dietas diarias para tus viajes una vez que sean aprobados. La cantidad de dinero que puedes pagar a tu cuenta bancaria personal es 75 € los primeros 15 días del viaje y 32 € los días siguientes. <strong style="font-weight: bold;">Para este viaje concreto, puedes pagarte {{dailyAllowance}}</strong>',
  daily_allowance_modal_title: '¿Cuánto es la dieta diaria?',
  edit_information: 'Editar información',
  travel_start_date: 'Fecha de inicio',
  travel_end_date: 'Fecha de fin',
  travel_expenses: 'Gastos de viaje',
  accommodation_expenses: 'Gastos de alojamiento',
  daily_allowance: 'Dieta Diaria',
  trip_reason: 'Razón detallada de propósito (Min 30 caracteres)',
  travel_expenses_document: 'Documento de gastos de viaje',
  documentary_proof_of_travel: 'Prueba documental del viaje',
  travel_update_success: 'Viaje actualizado correctamente.',
  travel_update_error: 'Hubo un error al actualizar el viaje.',
  no_action: 'Sin acción',
  delete_travel_title: '¿Estás seguro de que quieres eliminar este viaje',
  travel_update_pending: 'Actualizando viaje...',
  download_report: 'Descargar informe',
  update_start_date: 'Actualizar fecha de inicio',
  update_end_date: 'Actualizar fecha de fin',
  update_origin_country: 'Actualizar país de origen',
  update_destination_country: 'Actualizar país de destino',
  travel_start_date_edit_modal_title: 'Actualizar fecha de inicio',
  travel_end_date_edit_modal_title: 'Actualizar fecha de fin',
  travel_origin_edit_modal_title: 'Actualizar país de origen',
  travel_destination_edit_modal_title: 'Actualizar país de destino',
  employee_or_contractor_option_title: 'Un empleado o freelance',
  employee_or_contractor_option_text:
    'Elige esta opción para freelancers o empleados de Companio Work que no son miembros del consejo.',
  member_of_company_option_title: 'Un miembro de la empresa',
  member_of_company_option_text:
    'Elige esto si el viajero es un miembro del consejo. El viaje será elegible para dieta diaria.',
  upload_travel_file: 'Sube un archivo de confirmación del propósito y motivo del viaje',
  get_employess_error: 'Error al obtener empleados',
  get_board_member_error: 'Error al obtener miembros del consejo',
  not_applicable: 'No aplicable',
  request_daily_allowance: 'Solicitar dieta diaria para el viaje.',
  calculate_daily_allowance_error: 'Error al calcular la dieta diaria',
  travel_create_pending: 'Creando viaje...',
  travel_create_success: 'Viaje creado con éxito',
  travel_create_error: 'Hubo un error al crear el viaje.',
  beautify_trip_purpose_pending: 'Mejorando el propósito del viaje...',
  beautify_trip_purpose_success: 'Propósito del viaje mejorado correctamente.',
  beautify_trip_purpose_error: 'Hubo un error al mejorar el propósito del viaje.',
  option_contractor: '(Freelance)',
  option_employee: '(Empleado)',
  option_board_member: '(Miembro del consejo)',
  convert_to_purchase_invoice: 'Convertir a factura de compra',
  travels_documents_table_title:
    'Documentos de viaje de negocios (informe oficial y recibos de gastos no deducibles)',
  add_receipt_button: 'Añadir recibo',
  travel_documents_list_header_document: 'Documento',
  travel_documents_list_header_date: 'Fecha',
  travel_documents_list_header_status: 'Estado',
  upload_receipt: 'Subir recibo',
  upload_receipt_description:
    'Sube tus recibos fácilmente arrastrándolos y soltándolos aquí. Haz clic para seleccionar archivos.',
  document_update_success: 'Documento actualizado correctamente',
  document_update_error: 'Hubo un error al actualizar el viaje',
  end_date_after_start_date: 'La fecha de fin debe ser mayor que la fecha de inicio',
  board_member: 'Miembro del consejo',
  contractor: 'Freelance',
  delete_travel_modal_title: '¿Estás seguro de que quieres eliminar este viaje?',
  delete_travel_modal_description: 'Por favor, ten en cuenta que esta acción no se puede deshacer.',
  mark_travel_as_complete_modal_title:
    '¿Estás seguro de que quieres marcar este viaje como completado?',
  mark_travel_as_complete_modal_description:
    'Antes de continuar, asegúrate de que se hayan subido todos los documentos, incluyendo tanto los gastos no deducibles (a través de la sección Viajes) como los gastos deducibles (a través de la sección Compras). ¿Deseas continuar?',
  who_is_traveling: '¿Quién viaja?',
  who_is_traveling_description:
    'Gestiona y notifica fácilmente los planes de viaje de los miembros de tu empresa o de empleados individuales. Calcula las dietas diarias e ingresa todos los datos necesarios para un registro completo. Agiliza el seguimiento de tus viajes y garantiza una gestión precisa y eficiente de toda la información relacionada con los viajes.',
  travel_deleted_successfully: 'El viaje ha sido eliminado correctamente.',
  document_deleted_successfully: 'El documento ha sido eliminado correctamente.',
  trip_reason_min_length: 'La razón del viaje debe tener al menos 30 caracteres',
  travel_information: 'Información del viaje',
  travel_details_title: 'Viaje de {{name}}',
  origin: 'Origen',
  trip_reason_details_page: 'Propósito detallado del viaje',
  trip_details: 'Detalles del viaje',
  business_trip_no_members_found:
    'No se encontraron miembros del consejo para tu empresa. Por favor, contacta al equipo de soporte.',
  add_business_travel: 'Añadir viaje de negocios',
  add_travel_contractor_confirmation_checkbox:
    'Confirmo que este viaje fue acordado con el contratista y que todos los gastos de viaje serán cubiertos por la empresa a través de las facturas del contratista.',

  // Add Payment Method Page
  add_payment_method_title: 'Añadir nuevo método de pago',
  add_travel_button: 'Añadir viaje',
  upload_document: 'Subir documento',

  // Automation Page
  automation_title: 'Correo electrónico de reenvío de facturas',
  automation_intro_text:
    'Automatiza tu contabilidad con direcciones de reenvío de facturas personalizadas. Puedes generar direcciones de email únicas para recibir:',
  automation_list_sales_invoices: 'Facturas de ventas de tus clientes',
  automation_list_purchase_invoices: 'Facturas de compras de tus proveedores',
  automation_list_bank_statements: 'Extractos bancarios de tu banco',
  automation_description:
    'Cualquier documento adjunto a emails enviados a estas direcciones será automáticamente procesado y añadido a tus registros contables, ahorrándote tiempo y esfuerzo manual.',
  automation_alert:
    '<strong>Ten en cuenta:</strong> para evitar el mal uso de esta función, hay un límite de un email por minuto.',
  customize_email: 'Personalizar email',
  customize_email_description:
    'Por favor introduce un nombre preferido para generar una dirección de email única para recibir tus',
  custom_email_placeholder: 'Introduce el nombre de tu empresa aquí.',
  custom_email_address_label: 'dirección de email personalizada',
  email_warning: '¡Ups! Ese email parece estar ocupado',
  new_email_option: 'Podemos añadir un ‘-{{number}}’ para crear una versión única:',
  change_email_option: 'Déjame cambiarlo',
  keep_email_option: '¡Se ve bien!',
  generated_email_success: '¡Email generado correctamente!',
  generated_email_success_description:
    'Este nuevo email se usará a partir de ahora para recibir tus',
  dropbox_email_create_pending: 'Creando email personalizado...',
  dropbox_email_create_success: 'Email personalizado creado correctamente',
  dropbox_email_create_error: 'Hubo un error al crear el email personalizado',
  dropbox_email_already_taken_error: 'Email ya en uso por otra empresa',
  invalid_email_messsage_error: 'E-mail inválido',
  confirm_delete_custom_email_modal_title: 'Eliminar email personalizado',
  confirm_delete_custom_email_modal_description:
    'Una vez que elimines esta dirección, <strong>ya no podrás usarla</strong>. Si la necesitas nuevamente, puedes crear una nueva o usar cualquier otra dirección que ya hayas generado. <br> </br> ¿Estás seguro de que deseas continuar?',
  automated_email_deleted:
    'La dirección de correo electrónico <strong>"{{email}}"</strong> ha sido eliminada de tus direcciones de reenvío.',
  this_field_is_required: 'Este campo es obligatorio',
  invoice_forwarding_email_bank_statements_description:
    'Puedes ver direcciones de correo electrónico únicas generadas para cada una de tus cuentas bancarias activas. <strong>No hay direcciones de correo electrónico para cuentas bancarias cerradas.</strong> Cualquier documento adjunto a emails enviados a estas direcciones será automáticamente añadido al dashboard.',
  invoices_automation_sales: 'Facturas de ventas',
  invoices_automation_purchases: 'Facturas de compras',

  // Other Settings Page
  other_settings_title: 'Otros',
  other_settings_invoice_payment_instructions: 'Instrucciones de pago de facturas',
  other_settings_invoice_payment_instructions_description:
    'Añade instrucciones de pago de facturas para todos tus clientes aquí. Aparecerán en todas las facturas generadas en la sección de Ventas a menos que se definan instrucciones específicas.',
  company_settings_update_pending: 'Actualizando configuración de la empresa...',
  company_settings_update_success: 'Configuración de la empresa actualizada correctamente.',
  company_settings_update_error: 'Hubo un error al actualizar la configuración de la empresa.',
  other_settings_invoice_payment_instructions_placeholder:
    'Introduce tus instrucciones de pago aquí...',
  before_you_go_modal_title: 'Antes de irte…',
  before_you_go_modal_description:
    'Hemos notado que tienes cambios sin guardar. ¿Te gustaría guardarlos o irte sin guardar?',
  leave_anyway: 'Ir de todos modos',

  // Bank Details
  bank_details_add_new_balance: 'Añadir nuevo Saldo',
  bank_details_transactions_title: 'Transacciones',
  bank_details_transactions_upload_button: 'Subir un extracto bancario',
  bank_details_transactions_header_description: 'Descripción',
  bank_details_transactions_header_type: 'Tipo',
  bank_details_transactions_header_date: 'Fecha',
  bank_details_transactions_header_matched: 'Emparejado',
  bank_details_transactions_header_amount: 'Importe',
  bank_details_transactions_header_origin: 'Origen',
  bank_details_transactions_banking_fee: 'Comisión bancaria',
  bank_details_transactions_gross: 'Bruto',
  bank_details_balances_button: 'Saldos',
  no_balances: 'No se encontraron saldos',
  bank_details_account: 'Cuenta',
  bank_details_iban: 'IBAN',
  bank_details_token_contract: 'Contrato del token',
  bank_details_transactions_statements_button: 'Extractos bancarios',
  bank_details_account_savings: 'Cuenta de Ahorro',

  // 404 Page
  not_found_title: '¿Buscando algo Sherlock?',
  not_found_description:
    'No pudimos encontrar la página que estás buscando. Tal vez las pistas estén ocultas en algún otro lugar del panel, ¡o tal vez es hora de volver a la página de inicio y comenzar una nueva investigación!',
  not_found_button: 'Volver a la página principal',

  // Document Types
  document_type_purchase_invoice: 'Factura de compra',
  document_type_sales_invoice: 'Factura de venta',
  document_type_bank_statement: 'Extracto bancario',
  document_type_non_deductible_trip_expense: 'Gasto de viaje no deducible',

  // Document Status
  document_status_uploaded: 'Subido',
  document_status_processed: 'Procesado',
  document_status_processing: 'Procesando',
  document_status_rejected: 'Rechazado',
  document_status_deleted: 'Eliminado',
  document_status_approved: 'Aprobado',

  // Invoice Status Descriptions
  document_status_description_uploaded:
    'Los datos han sido analizados por nuestro algoritmo pero aún no han sido verificados o procesados por nuestro departamento contable.',
  document_status_description_processed:
    'Los datos han sido verificados y procesados a fondo por nuestro departamento contable, asegurando su precisión y fiabilidad.',
  document_status_description_processing: '---',
  document_status_description_rejected: '---',
  document_status_description_deleted: '---',

  // Payment Status
  payment_status_failed: 'Fallido',
  payment_status_succeeded: 'Exitoso',
  payment_status_open: 'Pendiente',
  payment_status_pending: 'Pendiente',
  payment_status_paid: 'Pagado',

  // Bank Status
  bank_status_manual: 'Manual',
  bank_status_linked: 'Conectado',
  bank_status_expired: 'Desconectado',

  // Transactions Types
  debit: 'Débito',
  credit: 'Crédito',

  // Matched to
  sales_invoice: 'Factura de Venta',
  purchase_invoice: 'Factura de Compra',
  canceled: 'Cancelado',
  not_matched: 'No',

  // Report Status
  report_status_requirements: 'Requisitos',
  report_status_preparation: 'Preparación',
  report_status_done: 'Listo',
  report_status_not_started: 'No Iniciado',
  report_status_verified: 'Verificado',
  report_status_not_needed: 'No Necesario',
  report_status_prepared: 'Preparado',
  report_status_completed: 'Completado',
  report_status_in_preparation: 'En preparación',
  report_status_submitted: 'Impuestos pendientes',
  report_status_submitted_no_pay: 'Enviado',
  report_status_taxes_paid: 'Impuestos pagados',
  report_status_ready: 'Listo',
  report_status_calculating: 'Calculando',

  // User Roles
  admin: 'Administrador',
  representative: 'Representante',
  accountant: 'Contable',
  human_resources: 'Recursos humanos',
  secretary: 'Secretario',
  accountant_estonia: 'Contable',

  // Subscription Plans
  pro_plan: 'Plan Pro',
  remote_plan: 'Plan Pro',
  premium_plan: 'Plan Premium',
  crypto_plan: 'Plan Premium',
  virtual_plan: 'Plan Virtual',
  ultra_plan: 'Plan Ultra',
  pro_plan_description:
    'Incluye contabilidad completa de empresa e informes mensuales en cumplimiento con regulaciones, con soporte para 1 cuenta bancaria y hasta 100 documentos.',
  premium_plan_description:
    'Incluye contabilidad completa de empresa e informes mensuales en cumplimiento con regulaciones, más soporte para hasta 3 cuentas bancarias y 500 documentos, junto con acceso a seguimiento de crypto e inversiones.',
  virtual_plan_description:
    'Esta opción ofrece una oficina virtual, un punto de contacto dedicado y reenvío de correo postal. Excluye servicios de contabilidad.',
  ultra_plan_description:
    'Incluye contabilidad completa de empresa e informes mensuales en cumplimiento con regulaciones, con soporte para hasta 10 cuentas bancarias y 5,000 documentos.',
  premium_upgrade_loading: 'Actualizando a PREMIUM...',
  premium_upgrade_success: '¡Plan PREMIUM actualizado correctamente!',
  premium_upgrade_error: 'Ocurrió un error al actualizar a PREMIUM.',
  plan_upgrade_loading: 'Actualizando plan...',
  plan_upgrade_success: '¡Plan actualizado correctamente!',
  plan_upgrade_error: 'Ocurrió un error al actualizar el plan.',

  // Other
  filter_button: 'Filtrar',
  filter_save: 'Guardar estos filtros',
  react_select_no_options_message: 'Sin opciones',
  select_country_placeholder: 'Selecciona un país',
  drop_files_button: 'Explorar archivos',
  drop_files_delete: 'Eliminar',
  default_form_error_message: 'Por favor completa todos los campos obligatorios.',
  default_api_error_message: 'Ocurrió un error inesperado. Por favor inténtalo de nuevo más tarde.',
  download: 'Descargar',
  duplicate: 'Duplicar',
  cancel: 'Cancelar',
  delete: 'Eliminar',
  save: 'Guardar',
  discard_changes: 'Descartar cambios',
  add: 'Añadir',
  edit: 'Editar',
  search: 'Buscar',
  send_by_email: 'Enviar por email',
  invoice_preview_pdf_error: 'Ocurrió un error inesperado al intentar previsualizar la factura.',
  invoice_download_error: 'Ocurrió un error inesperado al intentar descargar la factura.',
  no_currencies_found: 'No se encontraron monedas',
  matched_by_admin: 'Emparejado por el contable',
  matched_by_customer: 'Emparejado por tu equipo',
  matched_by_automatic: 'Emparejado automáticamente',
  matched_by_unmatched: 'Sin emparejar',
  header_feedback_button: 'Comentarios',
  support_pin: 'PIN de Soporte',
  full_name: 'Nombre completo',
  first_name: 'Nombre',
  last_name: 'Apellidos',
  city: 'Ciudad',
  zip_code: 'Código postal',
  language: 'Idioma',
  role: 'Rol',
  email: 'Email',
  email_address: 'Email Address',
  address: 'Dirección',
  address_street: 'Calle',
  phone: 'Teléfono',
  phone_number: 'Número de teléfono',
  tax_id: 'ID Fiscal',
  vat_number: 'Número de IVA',
  custom_payment_instructions: 'Instrucciones de pago personalizadas',
  country: 'País',
  check_vat: 'Verificar IVA',
  check_vta_loading: 'Validando IVA...',
  check_vta_invalid:
    'Este número de IVA no parece ser válido. Por favor verifica el número y vuelve a intentarlo. Alternativamente, puedes dejar este campo vacío si el cliente no tiene número de IVA.',
  check_vta_valid: '¡El número de IVA ha sido verificado correctamente!',
  check_vta_error: 'Hubo un error al validar el número de IVA.',
  vat_number_invalid_inline: 'Este número de IVA no es válido',
  vat_number_valid_inline: 'Este número de IVA es válido',
  current_photo: 'Foto actual',
  upload_photo: 'Subir foto',
  ok: 'Vale',
  copy_error: 'Ocurrió un error al intentar copiar el texto al portapapeles.',
  copied: '¡Texto copiado al portapapeles!',
  set_primary: 'Establecer como principal',
  date: 'Fecha',
  service: 'Servicio',
  status: 'Estado',
  generate_and_copy: 'Generar y copiar',
  bank_statements: 'Extractos bancarios',
  add_member: 'Añadir usuario',
  delete_member: 'Eliminar miembro',
  view_details: 'Ver detalles',
  update_eresident_card: 'Actualizar tarjeta de e-Resident',
  cancel_subscription: 'Cancelar suscripción',
  upgrade_plan: 'Actualizar plan',
  downgrade_plan: 'Degradar plan',
  amount: 'Importe',
  type: 'Tipo',
  description: 'Descripción',
  set_representative: 'Establecer como representante',
  location: 'Ubicación',
  confirm_deletion: 'Confirmar eliminación',
  confirm: 'Confirmar',
  see_details: 'Ver detalles',
  file_size_exceeded:
    'El archivo seleccionado es demasiado grande. Por favor, sube un archivo que no supere los 2MB.',
  file_type_not_allowed: 'Tipo de archivo no permitido',
  please_check_data: 'Por favor verifica estos datos',
  details: 'Detalles',
  type_here: 'Escribe aquí',
  upload: 'Subir',
  upload_file: 'Subir un archivo',
  under_review: 'En revisión',
  yes_confirm: 'Sí, confirmar',
  document_name: 'Nombre del documento',
  transaction: 'Transacción',
  generate: 'Generar',
  options: 'Opciones',
  actions: 'Acciones',
  document_not_found: 'Documento no encontrado',
  select_an_option: 'Selecciona una opción',
  match: 'Emparejar',
  non_business_expense: 'Gasto no empresarial',
  active: 'Activo',
  terminated: 'Terminado',
  download_contract: 'Descargar contrato',
  current_photo_optional: 'Foto actual (opcional)',
  continue: 'Continuar',
  previous_step: 'Paso anterior',
  company: 'Empresa',
  uploaded: 'Subido',
  yes: 'Sí',
  no: 'No',
  select_file_and_drag_and_drop: 'Selecciona un archivo o arrastra y suelta aquí',
  upload_valid_pdf_file: 'Sube un archivo PDF válido para comenzar',
  file_added: 'Archivo añadido',
  upload_new_photo: 'Subir nueva foto',
  dismiss: 'Descartar',
  update: 'Actualizar',
  view_online: 'Ver online',
  matched: 'Emparejado',
  unmatched: 'Sin emparejar',
  loading_wait_a_moment: 'Cargando, espera un momento...',
  submit: 'Enviar',
  close: 'Cerrar',
  proceed: 'Proceder',
  got_it: 'Entendido',
  see_more: 'Ver más',
  allowed_extension_error: 'Solo se permiten archivos {{extensions}}',
  category: 'Categoría',
  from: 'De',
  subtotal: 'Subtotal',
  total: 'Total',
  business_or_member: 'Empresa o miembro',
  dates: 'Fechas',
  add_new: 'Añadir nuevo',
  interest: 'Interés',
  installments: 'Cuotas',
  select_date_range: 'Seleccionar rango de fechas',
  date_ascending: 'Fecha ascendente',
  date_descending: 'Fecha descendente',
  date_asc: 'Fecha ascendente',
  date_desc: 'Fecha descendente',
  reset: 'Reiniciar',
  i_understood: 'Entendí',
  representative_name: 'Nombre del representante',
  representative_tax_id: 'ID fiscal del representante',
  end_date: 'Fecha de fin',
  hold_on_let_me_check: 'Espera, déjame verificar',
  proceed_anyway: 'Proceder de todos modos',
  disabled: 'Desactivado',
  closed: 'Cerrada',
  bulk_actions: 'Acciones masivas',
  unmatch_all: 'Desvincular todo',
  transaction_total: 'Total de la transacción',
  transaction_date: 'Fecha de la transacción',
  recipient: 'Beneficiario',
  unknown: 'Desconocido',
  reference: 'Referencia',
  let_me_check_again: 'Déjame revisar nuevamente',
  failed: 'Fallido',
  no_results_found: 'No se encontraron resultados',
  connect: 'Conectar',
  update_now: 'Actualizar ahora',
  upload_valid_csv_file_to_begin: 'Sube un archivo CSV válido para comenzar',
  try_again: 'Intentar de nuevo',
  confirm_payment_modal_title: 'Verificación de pago seguro',
  confirm_payment_modal_description:
    'Para completar tu pago de {{amount}}, correspondiente a Contabilidad mensual, {{company_name}}, {{date}}, factura {{invoice_number}}, es necesaria una verificación de seguridad.',
  what_to_expect: 'Qué esperar:',
  confirm_payment_modal_item_1:
    '1. Se te pedirá que verifiques tu identidad, normalmente en la página segura de tu banco.',
  confirm_payment_modal_item_2:
    '2. Puede requerir introducir una contraseña, un código enviado a tu teléfono u otro método de verificación de tu banco.',
  confirm_payment_modal_item_3: '3. Es rápido y garantiza que tu pago sea seguro.',
  payment_successful: '¡Pago realizado con éxito!',
  payment_error: '¡Pago fallido!',
  confirm_payment_modal_success_description:
    'Gracias por realizar esta verificación para reducir el fraude y por tu pago.',
  confirm_payment_modal_error_description:
    'El pago ha fallado. Por favor, asegúrate de que tienes fondos suficientes para cubrir los costes.',
  processing_3d_verification_title: 'Pago verificado, procesando pago...',
  processing_3d_verification_message:
    'Gracias por verificar el pago. Está siendo procesado. Una vez que se confirme, te notificaremos de inmediato.',
  recommended: 'Recomendado',
  not_recommended: 'No recomendado',
  mark_as_concluded: 'Marcar como concluido',
  file_type_error:
    'No podemos aceptar ese tipo de archivo. Por favor, sube un archivo con una de las siguientes extensiones: {{extensions}}',
  file_size_error:
    'El archivo seleccionado es demasiado grande. Por favor, sube un archivo que no supere los {{size}}',
  too_many_files_error:
    'Has subido demasiados archivos a la vez. Por favor, selecciona un máximo de {{maxFiles}} archivos para subir.',
  stay_here: 'Quedarme aquí',
  leave: 'Salir',
  company_plan_virtual: 'Virtual',
  company_plan_remote: 'Pro',
  company_plan_crypto: 'Premium',
  company_plan_ultra: 'Ultra',
  company_status_registered: 'Cuenta abierta',
  company_status_pending_email_confirmed:
    'Pendiente de confirmación de correo electrónico en el registro',
  company_status_eresidency_requested: 'e-Residency solicitada',
  company_status_pending_company_data: 'Pendiente de datos de la empresa',
  company_status_pending_company_payment: 'Pendiente de pago de la empresa',
  company_status_pending_company_user_confirmation:
    'Esperando la firma del usuario para el contrato',
  company_status_pending_company: 'En registro',
  company_status_pending_bank_account: 'Pendiente de cuenta bancaria',
  company_status_pending_vat_number: 'Solicitando número de IVA',
  company_status_ready: 'En contabilidad',
  company_status_deleted: 'Cuenta terminada',
  company_status_off_board_requested: 'Baja solicitada',
  company_status_pending_members_signature: 'Pendiente de la firma de los miembros en el registro',
  company_status_onhold: 'En espera',
  company_status_stop: 'Cuenta terminada',
  company_status_pending_company_archives: 'Pendiente de archivos del proveedor anterior',
  company_status_pending_reinstatement: 'Pendiente de reincorporación en el Registro',
  company_status_pending_power_of_attorney: 'Pendiente de autorización de poder notarial',
  roles: 'Roles',
  capital_amount: 'Importe de capital',
  id_expiration_date: 'Fecha de caducidad del documento',
  shareholder: 'Accionista',
  id_expiration_tooltip_expired: 'El certificado ha caducado',
  id_expiration_tooltip_expiring_soon: 'El certificado está a punto de caducar',
  edit_member: 'Editar miembro',
  total_subtotal: 'Subtotal: {{subtotal}}, Total: {{total}}',
  success: 'Éxito',
  loading: 'Cargando',
  only_accept_euro_as_currency: 'Solo aceptamos el euro como moneda.',
  upload_modal_description:
    'Sube tu archivo fácilmente arrastrándolo y soltándolo aquí. Haz clic para seleccionar un archivo. Agiliza tu proceso con Companio.',
  upload_pdf_file_description: 'Sube un archivo PDF, PNG o JPG válido para comenzar.',
  result_per_page: 'Resultados por página',
  send: 'Enviar',
  phone_verification_modal_title: 'Necesitamos tener una forma alternativa de contactar contigo.',
  phone_verification_modal_description_1:
    'A veces los correos electrónicos se pierden, se bloquean o se filtran por error. Compartir tu número de teléfono <b>nos ayuda a asegurarnos de que podamos comunicarnos contigo rápidamente si surge algo importante relacionado con tu cuenta</b>.',
  phone_verification_modal_description_2:
    'Solo lo utilizaremos para comunicaciones esenciales, <b>nunca para marketing ni spam</b>.',
  confirm_phone: 'Confirmar teléfono',
  sent_sms_activation_code:
    'Hemos enviado un SMS con un código de activación a tu teléfono {{phone}}',
  phone_verified: 'Teléfono verificado',
  phone_verified_success_description:
    'Tu número ha sido confirmado y tu cuenta ahora es más segura.',
  verification_failed: 'Verificación fallida',
  phone_verified_error_description:
    'No hemos podido verificar tu número. Por favor, inténtalo de nuevo.',
  insert_the_code: 'Introduce el código',
  ill_do_it_later: 'Lo haré más tarde',
  unsupported_country_phone_error:
    'Lamentablemente, los números de teléfono de {{country_name}} no son compatibles. Por favor, usa un número de teléfono de un país o proveedor diferente.',
  formik_error_message:
    'Por favor, completa todos los campos obligatorios. El campo "{{fieldLabel}}" falta o no es válido.',
  unknown_user: 'Usuario desconocido',
  skip: 'Omitir',
  next: 'Siguiente',
  previous: 'Anterior',
  end_tour: 'Finalizar recorrido',
  phone_verification_modal_title_reminder: 'Verificación de número de teléfono requerida',
  phone_verification_modal_description_1_reminder:
    '<b>Para continuar usando el panel, necesitas verificar tu número de teléfono.<b>',
  phone_verification_modal_description_2_reminder:
    '<span>Esto nos ayuda a mantener tu cuenta segura y nos permite contactarte rápidamente si hay alguna actualización o problema importante.</span><span>Solo lo usaremos para comunicaciones esenciales — nunca para marketing ni spam.</span>',

  // Annual Report
  ar_banner_title: '¡Es hora de hacer el informe anual!',
  ar_banner_description:
    'Te guiaremos paso a paso para preparar, revisar y presentar tu informe anual — rápida y fácilmente, sin estrés.',
  ar_banner_button_text: 'Empieza ahora',
  proceed_and_pay: '¡Vamos a ello!',
  maybe_later: 'Tal vez más tarde',
  loading_wait: 'Cargando, por favor espera...',
  we_are_processing_your_payment: 'Estamos procesando tu pago',
  ok_button: 'Vale',
  annual_report_payment_approved_title: 'Tu pago ha sido aprobado',
  complete_requirements_annual_report_title: 'Completa los requisitos para tu informe anual',
  complete_requirements_annual_report_description:
    'Para proceder con tu informe anual, <b style="font-weight: bold;"> necesitamos que cumplas ciertos requisitos </b>. Esto puede incluir subir documentos, reconectar cuentas o emparejar documentos existentes.',
  check_this_later: 'Revisar esto más tarde',
  go_to_annual_report: 'Ir al Informe Anual',
  annual_report_status_title: 'Informe anual {{year}}',
  requirements: 'Requisitos',
  in_preparation: 'En preparación',
  review_needed: 'Revisión necesaria',
  ready_to_submit: 'Listo para enviar',
  pending_signature: 'Firma pendiente',
  signed: 'Firmado',
  review_your_documents_title: 'Revisa los documentos de tu informe anual',
  review_your_documents_description:
    'Tus documentos han sido preparados. <strong style="font-weight: bold">Por favor revísalos y confírmalos para avanzar.</strong>',
  sing_annual_report_ebusiness_title:
    'Firma tu informe anual en el Registro Electrónico de Empresas',
  sing_annual_report_ebusiness_text:
    'Para finalizar tu informe anual, por favor <strong style="font-weight: bold">fírmalo en el Registro Electrónico de Empresas</strong>. Puedes encontrar todos los detalles necesarios en la sección del informe anual.',
  add_signature_annual_report_title: 'Añade las Firmas de tu Informe Anual',
  add_signature_annual_report_text:
    '<strong style="font-weight: bold">Algunos de los documentos aún requieren firma</strong>. Por favor completa este paso para proceder con el envío.',
  annual_report: 'Informe Anual',
  all_reports: 'Todos los informes',
  annual_report_table_details: 'Detalles',
  annual_report_table_paid: 'Pagado',
  annual_report_table_start_date: 'Fecha de inicio',
  annual_report_table_status: 'Estado',
  annual_report_table_getting_started: 'Comenzando',
  annual_report_table_requisites: 'Requisitos',
  annual_report_table_pending: 'Pendiente',
  annual_report_table_ready_for_submission: 'Listo para envío',
  annual_report_table_signed: 'Firmado',
  annual_report_table_not_all_signed: 'No todo firmado',
  annual_report_table_not_required: 'No requerido',
  annual_report_table_not_started: 'No iniciado',
  annual_report_table_submitted: 'Enviado',
  annual_report_table_unfinished: 'Sin terminar',
  annual_report_table_review_needed: 'Revisión necesaria',
  thank_you_for_starting_annual_report: '¡Gracias por Comenzar tu Informe Anual con Nosotros!',
  gathering_requirements_description:
    'Estamos recopilando todos los requisitos necesarios para tu informe anual, y recibirás una notificación tan pronto como tengamos todo ordenado.',
  back_to_annual_report: 'Volver al Informe Anual',
  annual_report_details_step_payment: '1. Pago',
  annual_report_details_step_requisites: '2. Requisitos',
  annual_report_details_step_preparation: '3. Preparación y Confirmación',
  annual_report_details_step_signatures: '4. Firma y Envío',
  annual_report_details_step_payment_submitted: 'Enviado',
  chat_with_us: 'Chatea con nosotros',
  annual_report_requirements_description:
    'Antes de que podamos comenzar a preparar tu informe anual, necesitamos tener todos estos requisitos cumplidos.',
  annual_report_deadline_description:
    'Necesitas cumplir todos los requisitos antes del 31 de marzo',
  all_requirements_fulfilled: 'Requisitos completos',
  pending: 'Pendiente',
  done: 'Hecho',
  permission_for_the_accountant: 'Permiso para Companio',
  missing_bank_statements: 'Extractos bancarios faltantes',
  missing_documents: 'Documentos faltantes para transacciones',
  banks_reconnect: 'Verifica que tus bancos estén conectados',
  give_permission_to_accountant_description:
    'Otorga permiso al código de registro de CompanioEstonia OÜ: 14522788. Puedes aprender cómo dar permisos <a href="https://help.companio.co/es/article/como-otorgar-permiso-poa-a-companio-para-que-preparemos-tu-informe-anual-1pylpx3/" target="_blank" rel="noreferrer" style="text-decoration: none">aquí</a>.',
  i_have_already_given_the_permissions: 'Ya He Otorgado los Permisos',
  already_given_permission_to_companio:
    'El permiso para el código de registro de CompanioEstonia OÜ: 14522788, ya fue otorgado.',
  missing_bank_statements_description:
    "Sube el extracto bancario de cada banco haciendo clic en 'Subir'.",
  confirm_missing_bank_statements_description:
    'Haz clic en el botón de abajo para confirmar que has subido todos los extractos bancarios.',
  confirm_missing_bank_statements_button: 'Confirmar extractos',
  bank_statement_description: 'Extracto bancario {{currency}} {{account}} para {{date}}',
  wait_a_minute: '¡Espera un minuto!',
  changed_my_mind: 'Cambié de opinión',
  delete_requisites_association_error: 'Hubo un error al eliminar la asociación de requisitos',
  confirm_banks_reconnect_description:
    'Una vez que tus cuentas bancarias estén reconectadas, haz clic en el botón de abajo.',
  confirm_banks_reconnect_button: 'Todos los bancos conectados',
  reconnect_your_bank_account: 'Por favor reconecta tu cuenta bancaria {{bank_name}}',
  requisites_documents_approved_banner_title:
    '¡Excelentes Noticias! ¡Tus Documentos Han Sido Aprobados!',
  requisites_documents_approved_banner_text:
    'Aunque aún no están disponibles para descarga, nuestro contable ya está trabajando duro preparándolos para tu revisión. ¡Te mantendremos informado en cada paso del camino!',
  ready_to_download: 'Listo para descargar',
  document_verification: 'Verificación de documentos',
  upload_attachments: 'Subir Adjuntos',
  statement_of_financial_position: 'Estado de situación financiera',
  statement_of_profit_or_loss: 'Estado de resultados',
  decline_documents: 'Rechazar Documentos',
  confirm_documents: 'Confirmar Documentos',
  decline_documents_title: '¿Estás seguro de que quieres rechazar los documentos?',
  reasoning_rejection_documents_title: 'Por Favor Aclara el Problema',
  reasoning_rejection_documents_description:
    'Explica en detalle en el cuadro de abajo qué está incorrecto y sube un documento si es necesario.',
  submit_comment: 'Enviar Comentario',
  confirm_rejection_message_modal_title: '¡Comentario Enviado Exitosamente!',
  confirm_rejection_message_modal_description:
    'Nuestro contable revisará tu comentario y abordará cualquier posible error. Te notificaremos una vez que todo esté listo.',
  confirm_rejection_need_help_modal_footer:
    '¿Necesitas ayuda? <a href="/support" target="_blank" rel="noreferrer" style="text-decoration: none">Contacta soporte aquí</a>',
  comment_submitted: 'Comentario Enviado',
  comment_submited_description:
    'Aquí puedes encontrar el comentario que nos has dejado y el documento (si se subió).',
  preparation_alert_description:
    '¡El contable ya ha preparado el informe anual! Confirma que todo está bien',
  preparation_alert_rejection_description:
    'Lamentamos lo que pasó. Te avisaremos cuando el contable revise todo',
  profit_loss: 'Beneficio o Pérdida',
  profit_title: 'Obtuviste un beneficio de {{profit}}€',
  profit_description:
    "Por favor confirma la cantidad de beneficios que has obtenido escribiendo la misma cantidad. Si es una cantidad diferente, por favor introdúcela. Luego haz clic en 'Confirmar Beneficios'.",
  confirm_profits: 'Confirmar Beneficios',
  company_registered_before_2023_warning:
    '<b>Recordatorio:</b> Si tu empresa se registró antes de 2023, asegúrate de que el capital social haya sido <a href="https://help.companio.co/es/article/como-declaro-el-pago-o-incremento-del-capital-social-de-mi-empresa-wzxo5h/" target="_blank" rel="noopener noreferrer">registrado y desembolsado</a> en su totalidad <b>antes de distribuir cualquier dividendo.</b>',
  annual_report_admin_profit_rejection_alert:
    '<b>IMPORTANTE:</b> El importe de beneficios seleccionado requiere una actualización. Revisa nuestros comentarios y envía un nuevo importe para continuar.',
  annual_report_admin_loss_rejection_alert:
    '<b>IMPORTANTE:</b> Actualiza tu selección para continuar. La opción que elegiste no puede ser aceptada. Revisa los comentarios y selecciona otra opción.',
  invalid_profit_error:
    'Por favor introduce una cantidad positiva de dividendos a distribuir, asegurándote de que no exceda €{{profit}}.',
  confirm_documents_modal_title: '¿Estás Seguro de que Quieres Confirmar los Documentos?',
  confirm_documents_modal_description_1:
    'Antes de continuar, asegúrate de que los documentos sean correctos.',
  confirm_documents_modal_description_2:
    'Las cargas y los permisos correctos ayudarán a que nuestro sistema procese tu informe anual sin problemas.',
  annual_report_preparation_confirm_success_title: 'Documentos confirmados correctamente',
  annual_report_preparation_confirm_success_description:
    'Tus documentos se han confirmado correctamente. Serás redirigido automáticamente al siguiente paso.',
  waiting_for_submission_banner_title: '¡Nos alegra escuchar que todo está bien!',
  waiting_for_submission_banner_text:
    'Relájate y tómalo con calma mientras el contable revisa cuidadosamente los detalles.',
  loss_title: 'Tuviste una pérdida de {{loss}}€',
  loss_description:
    'Los informes financieros muestran que tu empresa tuvo pérdidas durante el año fiscal. El contable ha especificado algunas formas en las que puedes prevenir este escenario, y necesitamos que elijas una y subas el documento apropiado, firmado digitalmente con tu tarjeta e-Residency. Más información <a href="https://help.companio.co/en/article/i-have-losses-what-can-i-do-12qy9j6/" target="_blank" rel="noreferrer" style="text-decoration: none">aquí.</a>',
  intangible_assets: 'Activos intangibles',
  waive_debt: 'Condonar deudas de préstamos',
  increase_share_capital: 'Aumentar capital social',
  first_financial_year: 'Primer año fiscal',
  first_financial_year_description:
    'Al seleccionar esta opción, estás eligiendo enviar el informe anual reflejando una pérdida, ya que es el primer año fiscal de tu empresa.',
  changing_loss_document_modal_title: 'Estás a punto de cambiar tu opción',
  changing_loss_document_modal_description:
    'El documento que subiste previamente será eliminado, y necesitarás subir un nuevo documento para la nueva opción que seleccionaste. <br/><strong style="font-weight: bold">¿Quieres cambiar la selección?</strong>',
  company_has_loss_covered:
    'Aunque tu empresa experimentó pérdidas durante el año fiscal, fueron posteriormente cubiertas por beneficios, por lo que NO HAY NECESIDAD DE NINGUNA ACCIÓN ESPECIAL DE TU PARTE. Simplemente confirma el informe y los resultados para permitir que nuestros contables procedan a la siguiente etapa.',
  missing_documents_for_transactions_description:
    'Por favor selecciona una opción para cada documento. Algunas opciones requieren que subas un documento.',
  all_ready_to_sign: 'Todo listo para firmar',
  sign_annual_report_instructions:
    '¡Noticias emocionantes! Tu Informe Anual ha sido subido al Registro Estonio y está listo para tu firma. <br/>Aquí está cómo completarlo:',
  complete_steps_sign_description:
    'Una vez que hayas completado estos pasos, simplemente presiona el botón de abajo para notificarnos que tu informe ha sido enviado. Esto nos permite integrarlo en nuestro sistema contable.',
  sign_steps_final_description: '¡Gracias por tu cooperación durante todo este proceso! 🤗',
  everything_signed: 'Todo está firmado',
  verifying_signature_title: 'Nuestro contable está verificando las firmas',
  verifying_signature_description:
    'Hemos recibido tu notificación y estamos revisando el registro. Si todo está bien, enviaremos el informe. De lo contrario, podríamos pedirte que verifiques tu firma. Por favor <strong style="font-weight: bold">danos un par de días </strong> para completar este proceso.',
  not_all_signed_header:
    'Echamos un vistazo al Informe Anual pero parece que no ha sido firmado por todos los miembros de la empresa 🧐',
  not_all_signed_description:
    '¿Podrías por favor acceder al registro para asegurar que el informe anual haya sido firmado?',
  completed_annual_report_banner_title:
    '¡Felicidades! ¡Has completado el proceso del informe anual!',
  this_is_purchase_invoice_option: 'Esta es una compra, subiré una factura de compra del proveedor',
  dont_have_invoice_purchase_option:
    'No tengo la factura. Por favor clasifica esto como un Gasto No Relacionado con el Negocio (se aplica 25% de impuesto)',
  refund_money_to_customer_option: 'Reembolsé el dinero al cliente, subiré una factura de crédito',
  choose_another_matching_type_option: 'Elegiré otro tipo de emparejamiento',
  this_is_sales_invoice_option: 'Esta es una venta, subiré una factura de venta',
  will_generate_sales_invoice_option: 'Generaré una factura y la emparejaré con esta transacción',
  refund_from_supplier_option:
    'Recibí un reembolso de un proveedor, subiré una factura de crédito de ellos',
  confirm_remove_bank_transaction:
    '¿Estás seguro de que quieres eliminar el emparejamiento actual para esta transacción bancaria? Esta acción no se puede deshacer.',
  show_match_menu_options_modal_title: '¿Cuál es el tipo de esta transacción?',
  select_an_transaction_to_match: 'Por favor selecciona una transacción para emparejar',
  confirm_movements: 'Confirmar movimientos',
  missing_other_documents: 'Documentos faltantes',
  missing_other_documents_description:
    'Por favor sube los documentos (facturas, salarios, recibos, etc) que el contable solicitó.',
  profit_not_distributable_subtitle:
    '¡Felicidades! Tu empresa tuvo un beneficio el año pasado, pero no se puede distribuir hasta que se registre tu capital social.',
  profit_not_distributable:
    '⚠️<strong style="font-weight: bold">¡IMPORTANTE!</strong> Antes de distribuir dividendos, primero debes registrar el capital social de tu empresa. Actualmente, el capital social de tu negocio no ha sido registrado, por lo que los dividendos no se pueden distribuir en este momento. Puedes aprender más sobre cómo registrar tu capital social <a href="https://help.companio.co/es/article/como-declarar-el-pago-o-incremento-del-capital-social-de-tu-empresa-wzxo5h/" target="_blank" rel="noreferrer" style="text-decoration: none">aquí</a>.',
  confirm_signature_annual_report_modal_title: 'Estás a punto de confirmar esta acción',
  confirm_signature_annual_report_modal_description:
    '¿Estás seguro de que el informe anual ha sido firmado exitosamente en el registro?',
  requisites_uploaded_banner_title: '¡Gracias por Subir los Documentos!',
  requisites_uploaded_banner_description:
    'Nuestro contable ahora comenzará a verificar la información que has proporcionado para asegurar la precisión. Si requerimos documentos adicionales, te notificaremos vía email.',
  confirm_all_requisites_modal_title: '¿Listo para avanzar?',
  all_correct: 'Todo Correcto',
  i_will_review_them: 'Los revisaré',
  balances: 'Saldos',
  add_to_financial_report: 'Añadir al informe financiero',
  delete_duplicated: 'Eliminar duplicado',
  choose_other_option: 'Elegir otra opción',
  choose_one: 'Elige uno',
  today: 'Hoy',
  yesterday: 'Ayer',
  last_week: 'La semana pasada',
  this_month: 'Este mes',
  last_quarter: 'Último trimestre',
  missing_payment_documents: 'Pagos pendientes para documentos',
  missing_payments_documents_description:
    'Por favor, suba los documentos (facturas, salarios, recibos, etc.) solicitados por el contable.',
  confirm_unlink_entity_from_matching_modal_description:
    '¿Estás seguro de que quieres eliminar este documento? Esta acción no se puede deshacer. Una vez eliminado, no podrás subir el documento de nuevo, ya que nuestro sistema recuerda una huella digital del archivo para prevenir envíos duplicados.',
  transaction_unlinked_successfully: 'Transacción desvinculada correctamente',
  entity_not_found: 'Entidad no encontrada',
  bank_statement_removed_successfully: 'Extracto bancario eliminado correctamente',
  no_extra_action_required: 'No se requiere ninguna acción adicional',
  invalid_document_type: 'Tipo de documento inválido',
  select_bank_modal_title: 'Selecciona un banco',
  must_select_a_bank: 'Debes seleccionar un banco para continuar',
  bank_statement_uploaded_successfully: 'Extracto bancario subido correctamente',
  confirm_redirect_to_matching_page_modal_description:
    'Esta acción redirigirá a la página de emparejamiento de documentos. ¿Estás seguro de que quieres continuar?',
  confirm_unmatch_transaction_modal_description:
    'Esta acción eliminará el emparejamiento actual para esta transacción bancaria. Esta acción no se puede deshacer. ¿Estás seguro?',
  confirm_payments: 'Confirmar pagos',
  uploading_document: 'Subiendo documento',
  document_uploaded_successfully: 'Documento subido correctamente',
  annual_report_contract_description_1:
    'Bienvenido a Companio. Estos Términos y Condiciones (en adelante, los “Términos”) regulan la relación contractual entre el cliente (en adelante, el “Cliente”) y CompanioEstonia OÜ (en adelante, “Companio” o el “Proveedor”), una empresa registrada en Estonia con número de registro 14522788, autorizada por la Unidad de Inteligencia Financiera de Estonia (FIU000295), con sede en Lõõtsa 5, 11415, Tallin, condado de Harju, Estonia.',
  annual_report_contract_description_2:
    'Companio opera como una plataforma Business-as-a-Service (BaaS) diseñada para simplificar las operaciones empresariales de emprendedores digitales e internacionales. A través de un enfoque 100% remoto y digital, ofrece servicios de contabilidad, cumplimiento fiscal, constitución de empresas, dirección legal y servicios de contacto, oficina virtual, apoyo financiero estratégico y gestión internacional de empleados.',
  annual_report_contract_early_bird:
    'Aprovecha nuestro descuento early bird y asegura tu informe anual por solo <0>250 € + IVA</0>. Este importe se cargará a tu método de pago predeterminado en la <1>sección de Facturación</1>.',
  annual_report_tour_welcome_step_title: 'Bienvenido a tu panel de informe anual',
  annual_report_tour_welcome_step_description:
    '<p><strong>Este proceso consta de 4 etapas principales.</strong></p><p>Empezaremos por Requisitos, donde completarás las acciones necesarias para que podamos preparar tu informe anual.</p><p><strong>Dependiendo de tu actividad este año, es posible que veas varias secciones o solo algunas.</strong></p><p>Si hay algo que completar, te guiaremos paso a paso para que sepas exactamente qué hacer.</p>',
  annual_report_tour_requisites_step_title: 'Veámoslo más de cerca.',
  annual_report_tour_requisites_step_description:
    'Para comenzar, deberás hacer clic en el botón "Empezar" de cualquier sección. <strong>Cada una te guiará por los pasos específicos que necesitas completar</strong>, si son aplicables a tu caso.',
  annual_report_tour_banks_reconnect_description:
    'Cada sección incluye pasos sencillos y guiados <strong>para completar cualquier requisito que puedas tener</strong>; solo sigue las instrucciones mostradas.',
  annual_report_tour_missing_documents_step_description:
    '<p>En algunas secciones —como Documentos pendientes para transacciones— <strong>deberás revisar cada elemento y elegir una opción del desplegable</strong>.</p><p>Según lo que selecciones, puede que necesites subir un documento, vincularlo, generar una factura o simplemente confirmar que no se requiere ninguna acción en la columna “Acciones”.</p>',
  annual_report_tour_missing_documents_confirm_step_description:
    'Cuando una sección se complete por completo, el botón "Confirmar" se activará. <strong>Solo tienes que hacer clic para continuar.</strong>',
  annual_report_tour_requisites_last_step_description:
    '<p>Una vez completados todos los requisitos, se te llevará a la pantalla de resumen para comprobar que todo esté listo para que podamos comenzar a preparar tu informe.</p><p><strong>Después de esta etapa, pasarás a los tres pasos siguientes que completan tu informe anual.</strong></p><p>Te mantendremos informado por correo electrónico a medida que avance tu informe.</p>',
  why_was_this_rejected: '¿Por qué se rechazó esto?',
  annual_report_rejected_reasons_alert:
    '<b>Revisa los elementos con el icono rojo y haz clic en la flecha para ver los motivos del rechazo y corregirlos.</b>',
  delete_other_document_confirm:
    '¿Estás seguro de que deseas eliminar este documento? Esta acción no se puede deshacer.',
  annual_report_preparation_reject_success_title: '¡Comentario enviado correctamente!',
  annual_report_preparation_reject_success_description:
    'Gracias por tus comentarios. Nuestro sistema revisará tu mensaje y te notificará cuando todo esté listo.',
  annual_repot_preparation_rejected_alert:
    '<b>Hemos recibido tus comentarios y nuestro sistema los está revisando.</b> Te notificaremos por correo electrónico cuando los documentos hayan sido actualizados.',
  annual_report_preparation_rejection_reason_description:
    'Aquí puedes revisar el comentario que enviaste y cualquier documento que hayas adjuntado.',
  annual_report_confirm_documents_profit_with_dividends_title:
    'Has decidido distribuir {{dividends}} € en dividendos',
  annual_report_confirm_documents_profit_no_dividends_title:
    'Has decidido no distribuir beneficios este año',
  annual_report_confirm_documents_loss_title:
    'Has decidido declarar las pérdidas como {{loss_option}}',
  annual_report_confirm_documents_profit_with_dividends_description:
    'Antes de continuar, comprueba que el importe introducido sea correcto.<br/><br/>Nuestro sistema continuará una vez que lo confirmes.',
  annual_report_confirm_documents_profit_no_dividends_description:
    'Por favor, confirma que esta es la opción con la que deseas continuar.<br/><br/>Nuestro sistema continuará una vez que lo confirmes.',
  annual_report_confirm_documents_loss_description:
    'Por favor, confirma que <b>has leído la descripción de la opción y has adjuntado el documento</b>.<br/><br/>Una vez confirmado, nuestro sistema continuará con el siguiente paso de tu informe anual.',
  annual_report_information_submitted_banner_title: 'Tu información se ha enviado correctamente.',
  annual_report_information_submitted_banner_description:
    'Revisaremos todo cuidadosamente y te notificaremos por correo electrónico en cuanto el siguiente paso esté listo.',
  annual_report_reviewing_loss_banner_title: 'Estamos revisando tu opción de gestión de pérdidas',
  annual_report_reviewing_loss_banner_description:
    'Estamos verificando la acción que has elegido para gestionar las pérdidas de tu empresa. Confirmaremos el resultado y los próximos pasos por correo electrónico una vez que la revisión esté completa.',
  amount_of_confirmed_profits: 'Importe de beneficios confirmados',
  reason_for_revision: 'Motivo de la revisión',
  balance_sheet_and_income_statement: 'Balance y cuenta de resultados',
  financial_reports: 'Informes financieros',
  deprecated_employee_banner_title: 'Antiguo empleado estonio (obsoleto)',
  confirm_resolve_ticket_modal_description:
    '¿Estás seguro de que tu incidencia se ha resuelto? Si ahora todo funciona correctamente, puedes confirmarlo.',
  ticket_resolved_success:
    '<b>¡Tu incidencia ha sido marcada como resuelta!</b><br />Nos alegra saber que todo vuelve a funcionar correctamente.',
  balance_sheet_preview_description:
    'Esta es una muestra de los informes (Cuenta de pérdidas y ganancias (Esquema 1) y Estado de situación financiera), para que puedas ver los datos aproximados incluidos en tu informe anual.',
  balance_sheet_final_preview_description:
    'Este es el informe anual final presentado ante el registro. Puedes verlo y descargarlo en cualquier momento.',
  period_start_date: 'Fecha de inicio del período',
  period_end_date: 'Fecha de fin del período',
  submission_date: 'Fecha de presentación',
  statement_of_profit_or_loss_scheme: 'Cuenta de pérdidas y ganancias (Esquema 1)',
  revenue: 'Ingresos',
  total_profit_loss: 'Resultado total (beneficio/pérdida)',
  profit_loss_before_income_tax: 'Resultado antes del impuesto sobre la renta',
  net_profit_loss_for_financial_year: 'Resultado neto del ejercicio',
  assets: 'Activos',
  current_assets: 'Activos corrientes',
  cash_and_cash_equivalents: 'Efectivo y equivalentes de efectivo',
  receivables_and_prepayments: 'Cuentas a cobrar y pagos anticipados',
  trade_receivables: 'Clientes',
  receivables_from_connected_parties: 'Cuentas a cobrar de partes vinculadas',
  tax_prepayments_and_receivables: 'Anticipos y créditos fiscales',
  other_receivables: 'Otras cuentas a cobrar',
  total_current_assets: 'Total activos corrientes',
  total_fixed_assets: 'Total activos no corrientes',
  total_assets: 'Total activos',
  current_liabilities: 'Pasivos corrientes',
  trade_payables: 'Proveedores',
  tax_payables: 'Impuestos a pagar',
  issued_capital: 'Capital emitido',
  profit_loss_for_the_year: 'Resultado del ejercicio (beneficio/pérdida)',
  total_current_liabilities: 'Total pasivos corrientes',
  total_liabilities: 'Total pasivos',
  total_liabilities_and_owners_equity: 'Total pasivos y patrimonio neto',
  annual_report_final_file_submitted: 'Archivo final del informe anual presentado',
  final_annual_report_submission: 'Presentación final del informe anual',
  financial_investments: 'Inversiones financieras',
  total_receivables_and_prepayments: 'Total cuentas a cobrar y pagos anticipados',
  inventories: 'Inventarios',
  total_inventories: 'Total inventarios',
  fixed_assets: 'Activos no corrientes',
  tangible_assets: 'Activos tangibles',
  total_property_plant_and_equipment: 'Total propiedades, planta y equipo',
  intangible_fixed_assets: 'Activos intangibles',
  loan_liabilities: 'Pasivos por préstamos',
  total_loan_commitments: 'Total compromisos de préstamos',
  payables_and_prepayments: 'Cuentas a pagar y pagos anticipados',
  total_payables_and_prepayments: 'Total cuentas a pagar y pagos anticipados',
  non_current_liabilities: 'Pasivos no corrientes',
  total_non_current_liabilities: 'Total pasivos no corrientes',
  equity: 'Patrimonio neto',
  uncalled_capital: 'Capital no desembolsado',
  unregistered_share_capital: 'Capital social no registrado',
  retained_earnings_deficit: 'Resultados acumulados (déficit)',
  total_owners_equity: 'Total patrimonio de los propietarios',
  liabilities_and_owners_equity: 'Pasivos y patrimonio de los propietarios',

  // Contractors
  contractors: 'Freelancers',
  position: 'Posición',
  salary: 'Salario',
  pending_employee_signature: 'Firma pendiente',
  termination_requested: 'Terminación solicitada',
  all_contractors: 'Todos los Freelancers',
  new_contractor: 'Nuevo Freelance',
  personal_data: '1. Datos Personales',
  contract_data: '2. Datos del Contrato',
  payment_information: '3. Información de Pago',
  add_contractor: 'Añadir Freelance',
  contractor_avatar_description:
    'La foto te ayudará a diferenciar tus empleados. Tamaño máximo de foto 1 MB.',
  contractor_address_description:
    '* Este campo representa el país donde el freelance está registrado para efectos fiscales, típicamente su país de origen o un país donde está registrado como freelance o equivalente. Esto es esencial para su elegibilidad para trabajar como freelance en ese país.',
  activity: 'Posición de trabajo',
  generated_by_ai_description:
    'Esta posición de trabajo ha sido generada por IA. Por favor siéntete libre de ajustarla a tus necesidades',
  currency: 'Moneda',
  work_hours_per_week: 'Horas de trabajo/semana',
  start_date: 'Fecha de inicio',
  end_date_optional: 'Fecha de fin (opcional)',
  yearly_vacation_days: 'Días de vacaciones anuales',
  notice_period_in_days: 'Días de aviso',
  gross_salary: 'Salario bruto',
  add_contractor_step_footer_description:
    'El monto final sería diferente del salario bruto debido a impuestos y nuestras comisiones. Nuestro Socio EOR te contactará en los próximos días para notificarte del monto total para tu revisión. El monto puede variar cada mes.',
  please_select_currency: 'Por favor selecciona una moneda',
  iban_contractor: 'IBAN/Número de cuenta',
  bic_contractor: 'BIC/SWIFT/Número de ruta',
  contractors_documents_required: 'Documentos requeridos',
  contractors_documents_required_description:
    'Introduce un justificante de domicilio, el DNI o el permiso de residencia del empleado.',
  ai_generating_job_description:
    'Estamos generando la descripción del trabajo a través de IA... Siéntete libre de modificarla según sea necesario.',
  please_select_notice_period:
    'Por favor selecciona los días de aviso de cancelación/fin de contrato',
  creating_contractor: 'Creando freelance...',
  contractor_created: 'Freelance creado exitosamente',
  back_to_contractors: 'Volver a Freelancers',
  account_wage_payments: 'Cuenta de pagos mensuales',
  retry_pending_payment: 'Reintentar pago pendiente',
  terminate_contractor_contract: 'Terminar contrato',
  payrolls_not_started: 'Nóminas no iniciadas',
  invoices_stopped: 'Facturas detenidas',
  invoices_scheduled: 'Facturas programadas',
  payrolls_stopped: 'Nóminas detenidas',
  update_info: 'Actualizar info',
  replace_contract: 'Reemplazar el contrato',
  regenerate_contract: 'Re-generar el contrato',
  payrolls: 'Nóminas',
  invoice_not_matched: 'Factura no emparejada',
  invoice_matched: 'Factura pagada y emparejada',
  invoices: 'Facturas',
  match_invoice: 'Emparejar factura',
  see_transaction: 'Ver transacción',
  has_not_matched_invoices:
    '<strong>Hay facturas que no han sido emparejadas.</strong> Por favor procede a emparejarlas.',
  all_invoices_are_matched:
    'Todas las facturas procesadas. Gracias por mantener el seguimiento de los pagos mensuales de tu freelance.',
  pending_signature_alert:
    '<strong>Necesitamos que el freelance firme el acuerdo de servicios para continuar el proceso.</strong>',
  terminate_contract_modal_title: '¿Estás seguro de que quieres cancelar este contrato?',
  terminate_contract_modal_description:
    '<strong style="font-weight: bold">Importante:</strong> El contrato finalizará el {{terminationDate}}. Esto significa que el estado del contrato cambiará a "En terminación" y, mientras tanto, el contratista podrá subir su última factura, por lo que esta acción no es inmediata. ¿Aún quieres continuar?',
  terminate_contract_successfully_modal_title: 'Cancelación de freelance iniciada',
  terminate_contract_successfully_modal_description:
    'Cancelación de empleado iniciada: Nuestro equipo está revisando la solicitud y se pondrá en contacto tanto contigo como con el empleado en breve. El proceso de cancelación puede requerir la participación de ambas partes: el empleador (tú) y el empleado.',
  termination_requested_alert:
    '<strong>Terminación solicitada. Permite un tiempo de un mes mientras el contrato es terminado.</strong>',
  terminated_alert:
    '<strong>El acuerdo de servicios de este freelance fue terminado el {{terminationDate}}.</strong>',
  replace_contract_modal_title: 'Reemplazar el contrato',
  replace_contract_modal_description:
    'Por favor sube el nuevo contrato para el freelance. Esto reemplazará el anterior, así que asegúrate de que el nuevo contrato incluya todos los detalles necesarios antes de enviarlo.',
  confirm_regenerate_contract_modal_title: '¿Estás seguro de que quieres regenerar el contrato?',
  confirm_regenerate_contract_modal_description:
    'Esta acción regenerará el contrato. Cualquier contrato existente será eliminado, y se generará un nuevo contrato basado en los datos actuales. Por favor confirma antes de proceder.',
  contract_regenerated_successfully_modal_title: 'Contrato regenerado',
  contract_regenerated_successfully_modal_description:
    'El contrato anterior ha sido reemplazado y guardado en el sistema.',
  edit_contractor: 'Editar freelance',
  regenerate: 'Regenerar',
  contractor_updated_successfully_modal_title: 'La información del freelance ha sido actualizada',
  contractor_updated_successfully_modal_description:
    'Antes de irte, ¿te gustaría regenerar el contrato del freelance o subir uno nuevo?',
  pending_contractor_updated_successfully_modal_title:
    'La información del freelance ha sido actualizada',
  pending_contractor_updated_successfully_modal_description:
    'La información del freelance ha sido actualizada y el contrato ha sido regenerado exitosamente.',
  reupload_contract: 'Resubir contrato',
  want_upload_my_own_contract_label:
    'Quiero subir mi propio documento de contrato (de lo contrario, generaremos uno para ti).',
  contractor_created_successfully_modal_title: '¡Freelancer notificado!',
  contractor_created_successfully_modal_description:
    'Hemos solicitado a tu freelance que revise y firme el contrato. Una vez completado, el acuerdo será activado.',
  contractor_termination_pending_modal_title: 'Rescisión de freelancer pendiente',
  contractor_termination_pending_modal_description:
    'Un freelancer con este correo electrónico tiene una rescisión pendiente. ¿Deseas completar el proceso de rescisión y continuar creando un nuevo freelancer?',
  one_week: 'Una semana',
  fifteen_days: 'Quince días',
  one_month: 'Un mes',
  two_months: 'Dos meses',
  terminated_alert_without_date: 'El acuerdo de servicios de este freelance fue terminado.',
  contract_replaced_successfully: 'Contrato reemplazado exitosamente',
  contract_attached_successfully_modal_title: 'Contrato Adjuntado Exitosamente',
  contract_attached_successfully_modal_description:
    'Hemos extraído información clave de tu contrato y pre-llenado algunos de los campos del formulario para ti.',
  download_invoice: 'Descargar factura',
  link_invoice: 'Enlazar factura',
  terminating_contractor_contract_loading: 'Terminando contrato de freelancer, por favor espera...',
  wage: 'Pago mensual',
  confirm_terminate_contractor_modal_title: '¿Cancelar el perfil del contratista?',
  confirm_terminate_contractor_modal_description_one:
    'Estás a punto de cancelar el perfil de este freelance. Como el acuerdo de servicios no ha sido firmado, no se requiere ninguna acción adicional.',
  confirm_terminate_contractor_modal_description_two:
    '<strong style="font-weight: bold">Esta acción es permanente y eliminará este freelance de la lista</strong>. También significa que no habrá colaboración con este freelance a través de Companio.',
  pending_contract_terminated_successfully: 'El freelance ha sido eliminado correctamente.',
  active_contractor_edit_alert:
    'Algunos campos están bloqueados porque este freelance tiene un contrato activo. Aún puedes actualizar la información financiera y de contacto.',
  contractor_active_contract_updated_modal_title: 'Los términos del contrato han sido actualizados',
  contractor_active_contract_updated_modal_description:
    'El freelance ha sido notificado y recibirá un nuevo contrato para revisar y firmar.',

  // Employees
  employees: 'Empleados',
  all_employees: 'Todos los Empleados',
  new_employee: 'Nuevo Empleado',
  pending_registration_payment: 'Pago de Reg. Pendiente',
  in_registration: 'En Registro',
  resend_signature_request: 'Reenviar solicitud de firma',
  cancel_hiring: 'Cancelar contratación',
  cant_cancel_anymore: 'No se puede cancelar más',
  see_details_payrolls: 'Ver detalles y nóminas',
  terminate_employment: 'Terminar empleo',
  termination_in_progress: 'Terminación en progreso',
  add_employee: 'Añadir Empleado',
  employee_address_description:
    '* Este campo representa el país donde el empleado es residente para efectos fiscales, típicamente su país de origen o un país donde está viviendo ahora. Esto es esencial para su elegibilidad para trabajar como empleado en ese país.',
  work_engagement_type: 'Tipo de compromiso laboral',
  please_select_work_engagement_type: 'Por favor selecciona el tipo de compromiso laboral',
  full_time: 'Tiempo completo',
  part_time: 'Tiempo parcial',
  remote: 'Remoto',
  on_site: 'En sitio',
  hybrid: 'Híbrido',
  work_location_mode: 'Modo de ubicación de trabajo',
  probation_period_in_months: 'Período de prueba',
  three_months: 'Tres meses',
  four_months: 'Cuatro meses',
  five_months: 'Cinco meses',
  six_months: 'Seis meses',
  notice_period_in_months: 'Período de aviso',
  please_select_work_location_mode: 'Por favor selecciona el modo de ubicación de trabajo',
  please_select_probation_period_in_months: 'Por favor selecciona el período de prueba',
  please_select_notice_period_in_months: 'Por favor selecciona el período de aviso',
  please_upload_employees_id: 'Por favor sube la identificación del empleado',
  employee_created_successfully_modal_title: '¡Solicitud de empleo recibida!',
  employee_created_successfully_modal_description:
    'Prepararemos una cotización para contratar al empleado, incluyendo el salario bruto, impuestos aplicables y comisiones, y te la enviaremos pronto.',
  eor_quote_provided: 'Cotización Proporcionada',
  eor_quote_rejected: 'Rechazada',
  eor_quote_requested: 'Cotización Solicitada',
  terminate_employee_contract_modal_title: '¿Estás seguro de que quieres cancelar este contrato?',
  terminate_employee_contract_modal_description:
    'Esta acción es irreversible y terminará el contrato entre tú y tu empleado.',
  resend_employee_signature_email_success:
    'El email de firma ha sido reenviado exitosamente al empleado.',
  resend_employee_signature_email_loading: 'Reenviando email de firma...',
  terminate_contract_reason_modal_title: 'Cancelación de contrato',
  terminate_contract_reason_modal_description: 'Necesitamos algunos datos antes de proceder',
  termination_date: 'Fecha de terminación',
  reason_cancelation_employee_contract_label: 'Introduce una razón detallada para tu solicitud',
  has_company_assets_label:
    'Este empleado actualmente posee equipo de la empresa y/o documentación que necesita ser devuelta.',
  termination_initiated_modal_title: 'Cancelación de empleado iniciada',
  termination_initiated_modal_description:
    'Cancelación de empleado iniciada: Nuestro equipo está revisando la solicitud y se pondrá en contacto tanto contigo como con el empleado en breve. El proceso de cancelación puede requerir la participación de ambas partes: el empleador (tú) y el empleado.',
  terminate: 'Terminar',
  resignation_requested: 'Renuncia solicitada',
  resigned: 'Renunció',
  back_to_employees: 'Volver a empleados',
  account_salary_payments: 'Cuenta para pagos de salarios',
  payrolls_scheduled: 'Nóminas programadas',
  contract_cancelled: 'Contrato cancelado',
  cancel_employment_request: 'Cancelar la solicitud de empleo',
  quote_requested_alert:
    '<strong>Hemos recibido tu solicitud y te enviaremos una cotización tan pronto como sea posible.</strong>',
  salary_for: 'Salario para {{date}}',
  salary_paid: 'Salario pagado',
  pending_payrolls_alert:
    '<strong>Hay nóminas pendientes. Por favor sube los documentos de nómina para el empleado.</strong>',
  all_payrolls_paid_alert:
    '<strong>Todas las nóminas procesadas. Gracias por mantener el seguimiento de los pagos de salarios de tu empleado.</strong>',
  pending_bonus: 'Bono Pendiente',
  bonus_provided: 'Bono Proporcionado',
  preparing: 'Preparando',
  pending_company_payment: 'Pago de Co. Pendiente',
  pending_eor_partner_payment: 'Pago EOR Pendiente',
  pending_payslip: 'Nómina Pendiente',
  payroll_preparing: 'En preparación',
  cancel_quote: 'Cancelar cotización',
  accept_quote: 'Aceptar cotización',
  pay_invoice: 'Pagar factura',
  accept_employment_quote: 'Aceptar cotización de empleo',
  quote_provided_alert:
    'Por favor revisa y acepta la cotización de empleo para iniciar el proceso de contratación.',
  quote_details: 'Detalles de la cotización',
  contract_details: 'Detalles del contrato',
  contract_start_date: 'Fecha de inicio del freelance',
  contract_type: 'Tipo de contrato',
  fixed_date: 'Fecha fija',
  entity: 'Entidad',
  job_title: 'Título del trabajo',
  payment_details: 'Detalles de pago',
  rate: 'Tasa',
  montly: 'Mensual',
  invoice_cicle_ends: 'Ciclo de factura termina',
  last_day_of_the_month: 'Último día del mes',
  payment_due: 'Pago vencido',
  same_day: 'Mismo día',
  pay_ahead_weekend: 'Pagar antes del fin de semana',
  on: 'En',
  social_taxes: 'Impuestos sociales',
  fee: 'Comisión',
  setup_fee: 'Comisión de configuración',
  first_payment: 'Primer pago',
  quote_rejected: 'Cotización Rechazada',
  delete_employment_request: 'Eliminar solicitud de empleo',
  quote_rejected_banner_title: 'Esta cotización ha sido rechazada',
  quote_rejected_banner_description:
    'No puedes editar estos detalles. Si quieres reincorporar a este empleado o cambiar los datos del presupuesto, ponte en contacto con nuestro equipo de Atención al Cliente a través del <a href="https://go.crisp.chat/chat/embed/?website_id=92ee1c03-fe47-44ef-8782-1f8593e54d6a" target="_blank" rel="noreferrer">chat</a> para actualizar la información del contrato.',
  quote_rejected_banner_button: 'Ver razones',
  review_quote: 'Revisar cotización',
  quote_available_banner_title: 'Cotización Disponible',
  quote_available_banner_description:
    '¡Excelentes noticias! Hemos generado la cotización para el registro del empleado y costos mensuales. Por favor tómate un momento para revisar todos los detalles cuidadosamente. Una vez que estés listo, podemos proceder con el proceso de registro.',
  cannot_edit_contract_quote_alert:
    'No puedes editar los detalles del contrato. Ponte en contacto con nuestro equipo de Atención al Cliente a través del <a href="https://go.crisp.chat/chat/embed/?website_id=92ee1c03-fe47-44ef-8782-1f8593e54d6a" target="_blank" rel="noreferrer">chat</a> para actualizar la información del contrato.',
  quote_provided: 'Cotización Proporcionada',
  contract: 'Contrato',
  contract_session_details:
    'Por favor asegúrate de descargar el contrato y leerlo cuidadosa y completamente. Es importante revisar a fondo todos los detalles contenidos dentro del documento.',
  payment_due_on_weekend: 'Si el pago vence en fin de semana, paga el viernes.',
  monthly_payment: 'Pago mensual',
  monthly_payment_description:
    'Esta es la cantidad aproximada que tu empresa pagará cada mes por el empleado. El monto final incluye no solo el salario bruto, sino también los impuestos sociales y la comisión de servicio. El monto puede variar ligeramente cada mes debido a cómo se calculan los impuestos durante el año fiscal. <a href="https://help.companio.co/es/article/cuanto-tengo-que-pagar-por-un-empleado-de-companio-work-1ston5c/" target="_blank" rel="noreferrer">¿Por qué es eso?</a>',
  total_monthly_payment: 'Monto total a pagar cada mes',
  first_payment_description:
    'Importante: Tu primer pago será diferente del pago mensual especificado arriba. Incluirá el pago regular más una comisión de configuración y un depósito de seguridad. La comisión de configuración cubre los costos iniciales del contrato, mientras que el depósito de seguridad protege el acuerdo. Ten la seguridad de que el depósito de seguridad será completamente reembolsado al final del contrato, sujeto a cumplir todos los términos y condiciones.',
  regular_monthly_fee: 'Comisión mensual regular',
  security_deposit: 'Depósito de seguridad',
  total_first_payment: 'Monto total a pagar el primer mes',
  do_not_agree: 'No estoy de acuerdo',
  approve_sign: 'Aprobar y firmar',
  employee_sign_modal_title: 'Acuerdo del empleado',
  customer_signature: 'Firma del cliente',
  your_signature: 'Tu firma',
  agree_sign: 'Aceptar y firmar',
  enter_your_signature: 'Introduce tu nombre completo ({{- customerName}})',
  quote_signed_successfully_modal_title: '¡La cotización de empleo ha sido aprobada!',
  quote_signed_successfully_modal_description:
    'El empleado ahora será invitado a firmar el contrato. Una vez que ambas partes hayan firmado, procederemos con el registro y te notificaremos cuando el empleado esté activo.',
  confirm_decline_quote_modal_title: '¿Estás seguro de que quieres rechazar esta cotización?',
  confirm_decline_quote_modal_description:
    'Antes de proceder, por favor confirma tu decisión de rechazar la cotización. Se te pedirá que proporciones una razón para tu rechazo para que nuestro equipo pueda revisarla y sugerir cualquier posible ajuste si es necesario.',
  reason_decline_quote_modal_title: 'Dinos por qué estás rechazando esta cotización',
  reason_decline_quote_modal_description:
    'Por favor proporciona una razón para tu rechazo para que nuestro equipo pueda revisarla y sugerir cualquier posible ajuste si es necesario.',
  decline_quote_successfully_modal_title: 'Tu comentario ha sido enviado',
  decline_quote_successfully_modal_description:
    'Tu razón para rechazar la cotización ha sido enviada exitosamente. Revisaremos tu comentario y te contactaremos si se necesita aclaración adicional o ajustes.',
  confirm_sign_quote_modal_title: '¿Quieres aprobar la aplicación?',
  confirm_sign_quote_modal_description:
    'Al aprobar esta cotización, se te pedirá que firmes el acuerdo del empleado. Una vez que hayas firmado, enviaremos el contrato al empleado para su revisión y firma. <strong style="font-weight: bold">¿Quieres continuar?</strong>',
  resend_signature_banner_title: '¡Falta la firma del empleado!',
  resend_signature_banner_description:
    'Necesitamos que el empleado firme el contrato de empleo para continuar el proceso. Si necesitas recordárselo, introduce su email abajo y reenvíale la información.',
  resend_signature_banner_input_placeholder: 'Introduce el email aquí',
  resend_signature_banner_button: 'Re-enviar invitación',
  invalid_email_error: 'Por favor introduce un email válido',
  resend_signature_email_loading: 'Enviando email de firma...',
  resend_signature_email_success: 'El email de firma ha sido reenviado exitosamente al empleado.',
  in_registration_alert:
    '<strong>Por favor espera mientras registramos al empleado con las autoridades locales.</strong>',
  terminate_employee_contract: 'Terminar contrato del empleado',
  add_bonus: 'Añadir bono',
  retry_payment: 'Reintentar pago',
  download_payroll: 'Descargar nómina',
  download_payslip: 'Descargar recibo de pago',
  actions_for_remaining_days_label: 'Acción para días de vacaciones restantes',
  enjoy_unused_vacation_days: 'Disfrutar de los días de vacaciones no utilizados',
  get_paid_unused_vacation_days: 'Ser pagado por los días de vacaciones no utilizados',
  select_remaining_vacation_days: 'Por favor selecciona los días de vacaciones restantes',
  termination_date_less_than_30_days_warning:
    'La fecha de terminación seleccionada es menos de un mes y debe ser negociada con el empleado. <strong style="font-weight: bold">Aún puedes proceder, pero la fecha necesita confirmación</strong>.',
  terminate_employee_less_than_30_days_successfully_modal_title: 'Acción Solicitada a nuestro RRHH',
  terminate_employee_less_than_30_days_successfully_modal_description:
    'Nuestro RRHH ha sido notificado y actualmente está manejando la terminación del empleado.',
  terminate_employee_less_than_30_days_modal_disclaimer:
    'DESCARGO DE RESPONSABILIDAD: Por favor no discutas esta terminación directamente con el empleado bajo ninguna circunstancia. Nuestros expertos en RRHH manejarán todo el proceso para asegurar una experiencia de desvinculación fluida y tu tranquilidad.',
  unable_to_load_employee_data: 'No se puede cargar datos del empleado',
  updating_employee_photo: 'Actualizando foto del empleado...',
  employee_photo_updated_successfully: 'La foto del empleado ha sido actualizada exitosamente',
  edit_employee: 'Editar empleado',
  employee: 'Empleado',
  will_send_confirmation_email:
    'Enviaremos un email de confirmación para asegurar que la dirección sea válida.',
  updating_employee_data: 'Actualizando datos del empleado...',
  employee_updated_successfully: 'El empleado ha sido actualizado exitosamente',
  detailed_reason: 'Razones detalladas',
  cancel_contract_pending: 'Cancelando contrato de empleado...',
  confirm_delete_employee_modal_title: '¿Estás seguro de que quieres eliminar este empleado?',
  confirm_delete_employee_modal_description:
    'Este empleado será removido de tu lista. Esta acción es irreversible.',
  employee_deleted_successfully: 'El empleado ha sido eliminado exitosamente.',
  add_bonus_modal_title: 'Añadir bono',
  add_bonus_this_month: 'Añadir bono este mes',
  no_bonus_this_month: 'Sin bono este mes',
  has_bonus_radio_label: 'Confirmar bono antes del 4 de este mes',
  bonus_description: 'Descripción del bono',
  eor_partner_paid: 'Socio pagado',
  bonus_added_successfully_modal_title: '¡Bono añadido exitosamente!',
  bonus_added_successfully_modal_description:
    'El bono ha sido añadido a la próxima nómina de este empleado. Por favor nota que se reflejará en el próximo recibo de pago.',
  add_employee_step_footer_description:
    'El monto final sería diferente del salario bruto debido a impuestos y nuestras comisiones. Nuestro Socio EOR te contactará en los próximos días para notificarte del monto total para tu revisión. El monto puede variar cada mes. <a href="#" target="_blank" rel="noreferrer" style="text-decoration: none">¿Por qué es eso?</a>',
  request_salary_update: 'Solicitar actualización de salario',
  requested_salary_update_modal_title: 'Solicitud de actualización de salario recibida',
  requested_salary_update_modal_description_one:
    'Gracias por actualizar el salario de tu empleado. Por favor nota que los cambios de salario no se aplican inmediatamente.',
  requested_salary_update_modal_description_two:
    '<strong style="font-weight: bold">Necesitamos coordinar esta actualización con nuestro socio EOR para ajustar el contrato de empleo, salario, impuestos, contribuciones de seguro y otras obligaciones relacionadas.</strong>',
  requested_salary_update_modal_description_three:
    'Una vez que la actualización sea confirmada por nuestro socio, te notificaremos y aplicaremos los cambios en consecuencia.',
  know_more: 'Saber más',
  migrate_country_warning_modal_title:
    'Un empleado no puede simplemente ser "migrado" a un nuevo país.',
  migrate_country_warning_modal_description_one:
    'Para asegurar el cumplimiento y precisión al cambiar el país de un empleado, por favor sigue los pasos delineados abajo:',
  migrate_country_warning_modal_description_two:
    '<strong style="font-weight: bold">Terminar Contrato Actual</strong>: Iniciar terminación en el país actual, adhiriéndose a las leyes laborales.',
  migrate_country_warning_modal_description_three:
    '<strong style="font-weight: bold">Comenzar Nuevo Contrato de Empleo</strong>: Comenzar un nuevo contrato en el nuevo país, asegurando cumplimiento con regulaciones locales.',
  migrate_country_warning_modal_description_four:
    'Al adherirse a estos procedimientos, podemos asegurar que la transición del empleado al nuevo país de residencia se lleve a cabo en total cumplimiento con las leyes y regulaciones laborales locales.',
  migrate_country_warning_modal_description_five:
    '<strong style="font-weight: bold">Para asistencia, contacta a nuestro equipo. Gracias por tu cooperación.</strong>',
  salary_update_under_input_description:
    'Las actualizaciones de salario necesitan aprobación de nuestro equipo de RRHH.',
  payment_failed_banner_title: '¡Ups! El pago no fue exitoso',
  payment_failed_banner_description:
    'El pago para esta solicitud de empleo falló. Para completar el proceso, por favor haz clic en el botón de abajo para intentar el pago de nuevo.',
  payment_processing_banner_title: 'Pago de nómina siendo procesado',
  payment_processing_banner_description:
    'El pago de nómina del mes actual para este empleado está siendo procesado actualmente en nuestra pasarela de pagos. Te notificaremos tan pronto como el pago se liquide.',
  contract_not_found: 'Contrato no encontrado',
  contract_type_info_modal_title: '¿Qué significa "Tipo de Contrato"?',
  contract_type_info_modal_description_one:
    'Esto se refiere al tipo de relación laboral del empleado con tu empresa.',
  contract_type_info_modal_description_two:
    '<b>Jornada completa:</b> El empleado trabaja el número de horas estándar definido como jornada completa en tu empresa o jurisdicción.',
  contract_type_info_modal_description_three:
    '<b>Jornada parcial:</b> El empleado trabaja menos horas que en un puesto a jornada completa, según los términos definidos en el contrato.',
  delete_employee_pending: 'Eliminando empleado...',
  payroll_history_unavailable_message:
    'Podrás ver el historial de nóminas cuando el empleado esté registrado.',
  enter_bank_details_employee: 'Por favor, introduce los datos bancarios de este empleado.',
  upload_valid_pdf_or_image: 'Sube un archivo PDF o una imagen válidos para comenzar.',
  job_position: 'Puesto de trabajo',
  job_description: 'Descripción del puesto',
  view_more: 'Ver más',
  view_less: 'Ver menos',
  needs_migration: 'Necesita migración',
  deprecated_employee_banner_description:
    'Con el lanzamiento de Companio Work, vamos a migrar a todos los empleados que actualmente utilizan el antiguo esquema de empleo a contratistas o empleados regulares dentro del marco de Companio Work. El antiguo esquema de empleo ahora está obsoleto, y el soporte para estos empleados se interrumpirá en un futuro próximo. Para migrar a tu empleado, cancela este contrato y añade un nuevo empleado ya sea como contratista o como empleado de Companio Work.',
  search_by_name_email_position: 'Buscar por nombre, email y puesto',
  gross_salary_warning_description_1:
    '<b>IMPORTANTE — LEE ANTES DE INTRODUCIR EL SALARIO:</b> El importe introducido aquí es el salario <b>BRUTO, NO el NETO</b> que recibirá el empleado. El salario <b>BRUTO</b> es el salario contractual antes de impuestos y cotizaciones sociales. El salario <b>NETO</b> (el importe que el empleado recibe realmente en su cuenta bancaria) será inferior.',
  gross_salary_warning_description_2:
    'Los contratos laborales siempre se definen utilizando el salario BRUTO, porque el importe NETO depende de varios factores personales, como: estado civil, número de hijos, lugar de residencia, deducciones fiscales, etc. Por esta razón, el salario NETO final no puede calcularse con precisión sin el perfil fiscal completo del empleado.',
  read_more_about_gross_vs_net_salary:
    '👉 <a href="https://help.companio.co/es/article/como-registro-un-nuevo-empleado-con-companio-work-1jyfjid/" target="_blank" rel="noreferrer">Leer más sobre salario BRUTO vs NETO</a>',
  gross_salary_warning_description_3:
    'Si deseas estimar el salario BRUTO necesario para alcanzar el salario NETO deseado, por favor <a href="https://go.crisp.chat/chat/embed/?website_id=92ee1c03-fe47-44ef-8782-1f8593e54d6a" target="_blank" rel="noreferrer">contacta con nuestro equipo</a> y te ayudaremos.',
  effective_date: 'Fecha efectiva',

  // Feedback
  feedback_modal_title: '¿Qué te gustaría compartir?',
  feedback_modal_description:
    'Cuéntanos qué piensas — ya sea algo positivo o algo que podamos mejorar, <b>tu opinión marca la diferencia</b>.',
  feedback_input_label: 'Habla con libertad',
  positive_feedback_modal_title: '¡Gracias por tus comentarios!',
  positive_feedback_modal_description:
    'Si estás contento con nuestros servicios, agradeceríamos si pudieras escribir una reseña en <strong style="font-weight: bold">Google My Business</strong> o el <strong style="font-weight: bold">Trustpilot</strong>. Te tomará solo un minuto.',
  marketplace: 'Mercado',
  trustpilot: 'Trustpilot',
  google_my_business: 'Google Business',
  negative_feedback_modal_title: 'Gracias por tus comentarios — estamos en ello',
  negative_feedback_modal_description:
    'Lamentamos escuchar que tu experiencia no cumplió tus expectativas. <strong style="font-weight: bold">Revisaremos tus comentarios cuidadosamente para entender qué salió mal y cómo podemos mejorar</strong>. <br/><br/>Gracias por ayudarnos a hacerlo mejor.',
  let_us_know_more: 'Cuéntanos más',
  whats_happening: '¿Qué está pasando?',
  optional: 'Opcional',
  thanks_for_your_feedback: '¡Gracias por tu opinión!',
  feedback_modal_success_description:
    'Hemos recibido tu mensaje y lo revisaremos en breve. Si es necesario, nos pondremos en contacto contigo. Puedes seguir utilizando la plataforma mientras lo revisamos.',

  // Notifications
  notifications: 'Notificaciones',
  notifications_clean_all: 'Limpiar Todo',
  notification_payment: 'Pago Requerido',
  notification_payment_text:
    'Tienes un pago pendiente que requiere tu atención. Complétalo para continuar usando nuestros servicios.',
  notification_invoice_missing: 'Factura Faltante',
  notification_invoice_missing_text:
    'Necesitamos la factura para una de tus transacciones recientes. Por favor súbela para completar tu contabilidad.',
  notification_invoice_unclear: 'Aclarar Detalles de Factura',
  notification_invoice_unclear_text:
    'Una de tus facturas necesita más información para ser procesada. Por favor revisa y actualiza los detalles.',
  notification_transfer_missing: 'Factura de Transferencia Faltante',
  notification_transfer_missing_text:
    'Necesitamos una factura para una de tus transferencias. Por favor sube el documento para completar la transacción.',
  notification_transfer_unclear: 'Aclarar Información de Transferencia',
  notification_transfer_unclear_text:
    'Necesitamos más detalles sobre una transferencia reciente para procesarla correctamente.',
  notification_transfers_missing: 'Transacciones Pendientes',
  notification_transfers_missing_text:
    'Tienes más de 20 transacciones pendientes desde hace más de dos meses. Por favor, completa las transacciones.',
  notification_report_ready: 'Tu Informe Está Listo',
  notification_report_ready_text:
    'Tu informe contable {{report}} ahora está disponible para revisión y descarga.',
  notification_pending_package: 'Dirección de Entrega de Paquete Pendiente',
  notification_pending_package_text:
    'Hemos recibido un paquete para tu empresa. Por favor indica la dirección donde debemos reenviarlo.',
  notification_ticket_answered: 'Respuesta de Soporte Recibida',
  notification_ticket_answered_text:
    'Nuestro equipo de soporte ha respondido a tu solicitud. Revisa el mensaje para más detalles.',
  notification_sales_invoice_automation_failed: 'Fallo en la automatización de facturas de venta',
  notification_sales_invoice_automation_failed_text:
    'Un flujo de automatización de facturas de venta no pudo generar una factura para un pago coincidente. Abre Flujos de trabajo para revisarlo.',
  vat_report: 'IVA',
  oss_report: 'OSS',
  tsd_report: 'TSD',
  no_notifications: '¡Nada que ver aquí!',
  notifications_see_all: 'Ver todo',

  // Notificaciones / Centro de comunicaciones
  page_title_notifications: 'Notificaciones',
  page_subtitle_notifications:
    'Actualizaciones importantes sobre tu negocio, todo en un solo lugar.',
  notifications_tab_unread: 'No leídos ({{count}})',
  notifications_tab_read: 'Leídos',
  notifications_tab_archived: 'Archivado',
  notifications_search_placeholder: 'Buscar',
  notifications_type_email: 'Correo',
  notifications_type_notification: 'Notificación',
  notifications_filter_status: 'Filtro',
  notifications_pinned_notification: 'Notificación fijada',
  notifications_status_sent: 'Enviado',
  notifications_status_processed: 'Procesado',
  notifications_status_opened: 'Abierto',
  notifications_status_failed: 'Fallido',
  notifications_status_outbound: 'Saliente',
  notifications_status_action_required: 'Acción requerida',
  notifications_inbox_empty_title: 'Tu bandeja de entrada está vacía',
  notifications_inbox_empty_description:
    'Aquí aparecerán las actualizaciones importantes, recordatorios y mensajes de Companio.',
  notifications_archived_empty_title: 'No hay mensajes archivados',
  notifications_archived_empty_description: 'Ningún mensaje coincide con tus filtros actuales.',
  notifications_empty_hint: 'Vuelve más tarde para ver novedades.',
  notifications_archived_banner:
    '<strong>Importante:</strong> Las notificaciones archivadas se eliminan permanentemente después de 90 días.',
  notifications_message_unavailable:
    'No se ha podido cargar este mensaje. Inténtalo de nuevo más tarde.',
  notifications_mark_unread: 'Marcar como no leído',
  notifications_mark_read: 'Marcar como leído',
  notifications_archive: 'Archivar',
  notifications_download: 'Descargar',
  notifications_action_coming_soon: 'Próximamente',

  // Support page
  get_help_support_tab: 'Obtener ayuda',
  my_tickets_support_tab: 'Mis tickets',
  page_title_support: 'Soporte',
  articles_card_title: 'Echa un vistazo a nuestros artículos más buscados',
  articles_card_description: `¿No puedes encontrar la solución que buscas en estos artículos? ¡No te preocupes! Visita nuestra base de conocimientos para una amplia gama de artículos. ¡Seguramente encontrarás la solución que buscas!`,
  e_residency_article_link: 'e-Residency de Estonia: 5 Pasos Simples para Solicitarla',
  annual_report_article_link: 'Envío de Informe Anual en 5 Pasos Con Companio',
  grant_permission_article_link: 'Cómo Otorgar Permiso para Preparar el Informe Anual',
  change_legal_address_article_link: '¿Cómo Cambiar la Dirección Legal de Tu Empresa?',
  knowledge_base: 'Base de conocimientos',
  chat_card_title: '¡Chatea con nosotros!',
  chat_card_description: `Puedes contactar a nuestros agentes de atención al cliente de 09:00 a 18:00 CET. ¿Te preguntas por qué deberías usar el chat? Déjanos compartir 3 razones convincentes:`,
  live_answers_title: '✅ Respuestas en vivo: ',
  live_answers_description: `Siempre estamos disponibles para responder tus preguntas en vivo (y es mucho más rápido que abrir un ticket).`,
  saves_times_title: '✅ Ahorra tiempo:',
  saves_times_description: `Tenemos mucha actividad de tickets, por lo que podrías no obtener una respuesta rápida. Ese es tiempo que podrías usar para algo más, por eso el chat es la mejor opción.`,
  chat_with_human_title: '✅ Chatea con un humano:',
  chat_with_human_description: `Detrás del chat, hay un ser humano que responderá tus preguntas de manera amigable y rápida para que puedas resolver tus dudas.`,
  lets_chat_button: `¡Vamos a chatear!`,
  tickets_table_title: 'Todos los tickets',
  ticket_table_header_details: 'Detalles del ticket',
  ticket_table_header_customer_name: 'Nombre del cliente',
  ticket_table_header_date: 'Fecha',
  ticket_table_status: 'Estado',
  see_ticket_details: 'Ver detalles',
  mark_ticket_as_solved: 'Marcar como resuelto',
  ticket_update_pending: 'Actualizando ticket...',
  ticket_update_success: 'Ticket actualizado exitosamente.',
  ticket_update_error: 'Hubo un error al actualizar el ticket.',
  confirm_solve_ticket_title: 'Confirmar actualización',
  confirm_solve_ticket_description: '¿Estás seguro de que quieres resolver este ticket?',
  page_title_ticket_details: 'Volver a soporte',
  support_rate_modal_title: '¿Cómo fue nuestro soporte?',
  support_rate_modal_text:
    '¿Podrías por favor tomarte un momento para calificar nuestro soporte? Siéntete libre de añadir cualquier comentario. <b>¡Tus comentarios nos ayudan a mejorar!</b>',
  create_feedback_pending: 'Registrando tus comentarios...',
  feedback_create_success: 'Comentarios registrados exitosamente',
  feedback_create_error: 'Error al registrar comentarios ',
  thank_you_feedback_title: '¡Gracias por tus comentarios!',
  thank_you_description:
    'Si estás contento con nuestros servicios, agradeceríamos si pudieras escribir una reseña en <bold>Google My Business</bold> o el <bold>Mercado e-Residency</bold>. Te tomará solo un minuto.',
  marktplace_button: 'Mercado',
  google_business_button: 'Google Business',
  we_are_on_it_title: 'Gracias por tus comentarios — estamos en ello',
  we_are_on_it_description:
    'Lamentamos escuchar que tu experiencia no cumplió tus expectativas. <bold>Revisaremos tus comentarios cuidadosamente para entender qué salió mal y cómo podemos mejorar</bold>. <br /> <br />Gracias por ayudarnos a hacerlo mejor.',
  send_message_button: 'Enviar mensaje',
  resolved: 'Resuelto',
  ticket_message_create_success: 'Mensaje enviado exitosamente',
  create_ticket_message_pending: 'Creando mensaje de ticket...',
  ticket_filter_open: 'Pendiente',
  ticket_filter_processing: 'En Proceso',
  ticket_filter_solved: 'Resuelto',
  translate_english: 'Traducir al inglés',
  translate_spanish: 'Traducir al español',
  confirm_resolve_ticket_modal_title: 'Confirmar resolución',
  support_rate_modal_textarea_placeholder: 'Añade tu comentario aquí...',
  ticket_table_last_message_date: 'el {{date}}',
  replied: 'Respondido',
  unanswered: 'Sin respuesta',

  // Agreements Page
  agreement_from_company: 'Préstamo de la empresa',
  agreement_to_company: 'Préstamo a la empresa',
  agreement_from_member: 'Préstamo del miembro',
  agreement_created: 'Creado',
  agreement_started: 'Iniciado',
  agreement_in_progress: 'En Progreso',
  agreement_concluded: 'Concluido',
  agreement_deleted: 'Eliminado',
  all_agreements: 'Todos los Acuerdos',
  matched_payments: 'Pagos conciliados',
  matched_payments_empty: 'Aún no se han conciliado pagos con este acuerdo de préstamo.',
  matched_payments_filter_payment_type: 'Tipo de pago',
  agreement_deleted_pending: 'Eliminando acuerdo de préstamo...',
  agreement_deleted_success: 'Acuerdo de Préstamo eliminado exitosamente.',
  agreement_deleted_error: 'Hubo un error eliminando el Acuerdo de Préstamo.',
  agreement_delete_confirmation_modal_title:
    '¿Estás seguro de que quieres eliminar este acuerdo de préstamo?',
  agreement_delete_confirmation_modal_description:
    'Esta acción no se puede deshacer. Todos los datos relacionados con este acuerdo serán eliminados permanentemente.',
  documents: 'Documentos',
  document: 'Documento',
  add_agreement_warning_modal_title: 'Antes de añadir un nuevo préstamo…',
  add_agreement_warning_modal_description_html:
    'Por favor, sigue los montos exactos del préstamo establecidos en tu acuerdo. Para asegurar una contabilidad precisa, <b>todos los pagos relacionados con el préstamo deben coincidir exactamente con los montos definidos allí</b>. <a href="https://help.companio.co/en/article/why-do-i-need-to-follow-the-loan-amounts-exactly-as-stated-in-the-agreement-x6nnnl/?bust=1745330681766" target="_blank" rel="noreferrer">Leer más</a>.',
  agreement_active: 'Activo',
  date_can_be_set_one_year: 'La fecha puede ser establecida hasta un año en el futuro.',
  no_members_found: 'No se encontraron miembros',
  why_is_this_date_fixed:
    '¿Por qué esta <a href="https://help.companio.co/es/article/como-funcionan-los-prestamos-en-companio-puedo-prestar-dinero-a-mi-empresa-sh8rt6/" target="_blank" rel="noreferrer">fecha es fija</a>?',
  maximum_installments_12: 'La cantidad máxima de cuotas es 12.',
  agreement_payment_dates_tooltip:
    'Un acuerdo de préstamo puede durar hasta un año. El último pago se realiza un mes después del último mes del acuerdo.',
  agreement_dates: 'Fechas del acuerdo',
  agreement_end_date: 'Fecha de finalización del acuerdo',
  end_date_installments: 'Fecha de finalización de los plazos',

  // Add Agreement
  add_agreement_title: 'Añadir Acuerdo de Préstamo',
  add_agreement_description:
    'Añade nuevos acuerdos según sea necesario y mantén un seguimiento de los existentes con facilidad.<b> Por favor nota: Los préstamos de tu empresa a individuos no están permitidos, y las empresas sin una licencia FFA no pueden prestar a individuos.</b>',
  add_agreement_lend_to_company: 'Prestar Dinero a Empresa',
  add_agreement_lend_to_company_description: 'Quiero que mi empresa preste dinero a otra empresa',
  add_agreement_borrow_from_company: 'Pedir Prestado de una Empresa',
  add_agreement_borrow_from_company_description:
    'Quiero que otra empresa preste dinero a mi negocio',
  add_agreement_member_lend_to_business: 'Miembro Prestando al Negocio',
  add_agreement_member_lend_to_business_description:
    'Un miembro de la empresa quiere prestar dinero al negocio',
  name_of_borrower_business: 'Nombre del negocio del prestatario',
  borrower_business_information: 'Información del negocio del prestatario',
  lender_business_information: 'Información del negocio del prestamista',
  member_information: 'Información del miembro',
  financial_data_of_loan: 'Datos financieros del préstamo',
  amount_to_lend: 'Cantidad a prestar',
  amount_to_borrow: 'Cantidad a pedir prestado',
  final_interest_amount: 'Monto de la cuota',
  installments_amount: 'Monto de la cuota',
  starting_date_installments: 'Fecha de inicio de Cuotas',
  agreement_date: 'Fecha del acuerdo',
  loan_total: 'Total del préstamo',
  calculate_loan: 'Calcular Préstamo',
  loan_calculation_in_progress: 'Cálculo de Préstamo en Progreso',
  loan_calculation_in_progress_description:
    'Por favor permite unos minutos para que este proceso se complete.',
  loan_interest_1_to_20: 'Tasa de Interés (de 0 a 20%)',
  loan_confirm_modal_title: '¿Estás seguro de que quieres añadir este préstamo?',
  loan_confirm_modal_description:
    'Por favor, comprueba que todo esté en orden antes de confirmar. <b>Una vez que se adjunte cualquier pago a este acuerdo de préstamo, no podrá eliminarse</b> y los datos contables se calcularán en base a la información guardada.',
  agreement_created_modal_title: '¡Acuerdo de Préstamo creado exitosamente!',
  agreement_created_modal_description:
    'Puedes descargar el Acuerdo de Préstamo y enviarlo por correo electrónico a {{lender_name}}, simplemente ingresa el correo electrónico de la empresa a continuación.',
  agreement_send_email_pending: 'Enviando email con el acuerdo...',
  agreement_send_email_success: 'Email con el acuerdo ha sido enviado exitosamente.',
  agreement_send_email_error: 'Hubo un error enviando el email con el acuerdo.',
  name_of_lender_business: 'Nombre del negocio del prestamista',
  download_agreement: 'Descargar acuerdo',
  number_of_installments: 'Número de cuotas',

  // Projects Page
  page_title_projects: 'Todos los proyectos',
  projects_table_header_project_name: 'Nombre del proyecto',
  projects_table_header_creation_date: 'Fecha de creación',
  projects_table_header_responsible_person: 'Persona responsable',
  projects_table_header_budget_goals: 'Presupuesto y objetivos',
  projects_table_header_status: 'Estado',
  projects_table_title: 'Todos los proyectos',
  projects_table_header_add_project_button: 'Añadir proyecto',
  project_create_success: 'Proyecto creado con éxito',
  project_create_error: 'Hubo un error al crear el nuevo proyecto',
  add_project: 'Añadir Proyecto',
  project_name_placeholder: 'Escribe aquí...',
  project_name: 'Nombre del Proyecto',
  responsible_person: 'Persona responsable',
  project_responsible_person_placeholder: 'Elige uno',
  project_email_placeholder: 'Selecciona usuario primero',
  project_email: 'Email',
  project_budget_placeholder: 'Escribe aquí...',
  project_budget: 'Presupuesto',
  project_sales_goal_placeholder: 'Escribe aquí...',
  project_sales_goal: 'Objetivo de ventas',
  project_expenses_budget: 'Presupuesto de gastos',
  page_title_project_details: 'Volver al proyecto',
  responsible_person_label: 'Persona responsable',
  responsible_person_email_label: 'Correo electrónico',
  expenses_stats: 'Estadísticas de gastos',
  sales_stats: 'Estadísticas de ventas',
  change_budget: 'Cambiar presupuesto',
  change_sales_goal: 'Cambiar objetivo de ventas',
  budget_value: 'Presupuesto',
  sales_goal_value: 'Objetivo de ventas',
  reached: 'Alcanzado',
  remaining: 'Restante',
  sales: 'Ventas',
  purchases: 'Compras',
  other_document: 'Otro documento',
  processing: 'Procesando',
  processed: 'Procesado',
  project_documents_table_title: 'Lista de facturas',
  project_documents_table_header_add_invoice_button: 'Añadir factura',
  document_date: 'Fecha',
  document_type: 'Tipo',
  document_amount: 'Importe',
  delete_invoice_title: '¿Estás seguro de que quieres eliminar esta factura?',
  remove_invoice_from_project: 'Eliminar del proyecto',
  change_project_budget_title: 'Cambiar presupuesto',
  project_current_budget_label: 'presupuesto actual',
  project_new_budget_label: 'nuevo presupuesto',
  project_update_budget_pending: 'Actualizando presupuesto...',
  project_update_budget_success: 'Presupuesto actualizado con éxito',
  project_update_budget_error: 'Hubo un error al actualizar el presupuesto',
  project_email_settings: 'Configuración de email (Opcional)',
  early_budget_alerts: 'Alertas tempranas de presupuesto',
  early_budget_alerts_description:
    'Recibe alertas tempranas vía email cuando el presupuesto de tu proyecto se esté acercando a su límite (80%), y una notificación final una vez que el presupuesto sea completamente alcanzado.',
  early_sales_goals_alerts: 'Alertas tempranas de objetivo de ventas',
  early_sales_goals_alerts_description:
    'Recibe alertas tempranas vía email cuando el objetivo de ventas de tu proyecto se esté acercando a su límite (80%), y una notificación final una vez que el objetivo de ventas sea completamente alcanzado',
  delete_project_title: '¿Estás seguro de que quieres eliminar este proyecto?',
  change_project_sales_goal_title: 'Cambiar objetivo de ventas',
  project_current_sales_goal_label: 'objetivo de ventas actual',
  project_new_sales_goal_label: 'nuevo objetivo de ventas',
  project_update_sales_goal_pending: 'Actualizando objetivo de ventas...',
  project_update_sales_goal_success: 'Objetivo de ventas actualizado con éxito',
  project_update_sales_goal_error: 'Hubo un error al actualizar el objetivo de ventas',
  mark_concluded_project_title: '¿Estás seguro de que deseas marcar este proyecto como concluido?',
  mark_project_concluded_pending: 'Marcando el proyecto como concluido...',
  mark_project_concluded_success: 'Proyecto marcado como concluido con éxito',
  mark_project_concluded_error: 'Hubo un error al marcar el proyecto como concluido',
  delete_project_pending: 'Eliminando proyecto...',
  delete_project_success: 'Proyecto eliminado con éxito',
  delete_project_error: 'Hubo un error al eliminar el proyecto',
  project_option_higher_1:
    '<span style="color: #00AE6E;font-weight: 600;">+25%</span> por encima del promedio',
  project_option_higher_2:
    '<span style="color: #00AE6E;font-weight: 600;">25%</span> más alto que el promedio',
  project_option_higher_3:
    'Por encima del promedio en un <span style="color: #00AE6E;font-weight: 600;">25%</span>',
  project_option_lower_1:
    '<span style="color: #FE2142;font-weight: 600;">-15%</span> por debajo del promedio',
  project_option_lower_2:
    '<span style="color: #FE2142;font-weight: 600;">15%</span> más bajo que el promedio',
  project_option_lower_3:
    'Por debajo del promedio en un <span style="color: #FE2142;font-weight: 600;">15%</span>',
  project_option_average_1: 'En el promedio',
  project_option_average_2: 'Igual al promedio',
  project_option_average_3: '100% del promedio',
  welcome_to_projects_title: '¡Bienvenido a Proyectos!',
  welcome_to_projects_description:
    'Con Proyectos, ahora puedes tomar el control de las finanzas de tu negocio con un enfoque más organizado y basado en proyectos. Ya sea que trabajes en múltiples proyectos de clientes o gestiones iniciativas internas, Proyectos te ayudará a mantenerte al tanto de tu presupuesto, beneficios y gastos en cada iniciativa específica.',
  why_use_projects_title: '¿Por qué usar Proyectos?',
  set_budget_description:
    '<bold>Establece presupuestos:</bold> Define un presupuesto para cada proyecto y recibe alertas tempranas cuando te acerques a tu límite, ayudándote a mantenerte en el camino correcto.',
  track_profit_description:
    '<bold>Controla beneficios:</bold> Clasifica y supervisa fácilmente los beneficios por proyecto, asegurándote de saber exactamente cómo cada proyecto contribuye a tus resultados.',
  organize_finance_description:
    '<bold>Organiza las finanzas:</bold> Divide y gestiona los gastos y las ventas según proyectos específicos, para que tu contabilidad se mantenga limpia, organizada y transparente.',
  projects_premium_warning: 'Proyectos es una función Premium.',
  projects_note:
    '<bold>Nota:</bold> Proyectos no afecta a la contabilidad ni divide la contabilidad en proyectos separados. Esta función es solo para ofrecer claridad financiera y propósitos organizativos.',
  projects_premium_upgrade_description:
    "Para gestionar y controlar los proyectos de tu empresa directamente desde el panel, necesitas actualizarte a nuestro plan Premium. Esta función no está disponible en el plan Pro. Para más detalles sobre los precios mensuales, consulta nuestra <a href='https://companio.co/pricing/' target='_blank' rel='noreferrer'>página de precios</a>. ¿Estás listo para continuar con la actualización?",
  closure: 'Cierre: {{closeDate}}',
  closure_date_label: 'Fecha de cierre (Opcional)',
  remove_invoice_from_project_modal_title:
    '¿Estás seguro de que quieres eliminar esta factura del proyecto?',
  remove_invoice_from_project_modal_description:
    'La factura será eliminada del proyecto, sin embargo puedes agregarla de nuevo si lo deseas.',
  invoice_deleted_successfully: 'Factura eliminada del proyecto con éxito.',
  back_to_projects_list: 'Volver a los proyectos',
  remove_invoice_from_project_bulk_action_modal_title:
    '¿Estás seguro de que quieres eliminar estas facturas del proyecto?',
  remove_invoice_from_project_bulk_action_modal_description:
    'Las facturas serán eliminadas del proyecto, sin embargo puedes agregarlas de nuevo si lo deseas.',
  add_invoices_to_project_api_error_description:
    'No pudimos agregar las facturas seleccionadas porque <strong style="font-weight: bold;">{{errorMessage}}</strong>. Si crees que esto es un error, por favor contacta a nuestro equipo de soporte a través del <a href="https://go.crisp.chat/chat/embed/?website_id=92ee1c03-fe47-44ef-8782-1f8593e54d6a" target="_blank" rel="noreferrer">chat</a>. Nuestro equipo estará encantado de ayudarte.',

  // Transactions Page
  transactions: 'Transacciones',
  transaction_status_booked: 'Contabilizada',
  transaction_status_pending: 'Pendiente',
  match_with_purchase_invoice: 'Relacionar con factura de compra subida',
  match_with_sales_invoice: 'Relacionar con factura de venta subida',
  automate_sale_invoice_generation: 'Automatizar la generación de factura de venta',
  this_is_internal_transfer: 'Esta es una transferencia interna entre cuentas',
  this_is_non_business_expense: 'Este es un gasto no relacionado con la actividad empresarial',
  other_matching_options_modal_title: '¿Qué es esta transacción?',
  other_matching_options_modal_description:
    "Elige una opción para conocer más sobre los tipos de vinculación disponibles o <a href='https://help.companio.co/en/article/matching-options-for-transactions-and-how-to-choose-the-right-one-g1twsa/' target='_blank' rel='noreferrer'>haz clic aquí para leer más</a>.",
  bank_fee: 'Comisión bancaria',
  state_fee: 'Tasa estatal',
  share_capital: 'Capital social',
  dividends: 'Dividendos',
  interest_paid: 'Intereses pagados',
  none_of_the_above: 'Ninguna de las anteriores',
  unmatching_bulk_transactions_pending: 'Desvinculando transacciones...',
  unmatching_bulk_transactions_success: 'Transacciones desvinculadas con éxito.',
  unmatching_bulk_transactions_error: 'Se ha producido un error al desvincular las transacciones.',
  unmatching_bulk_documents_pending: 'Desvinculando documentos...',
  unmatching_bulk_documents_success: 'Documentos desvinculados con éxito.',
  unmatching_bulk_documents_error: 'Se ha producido un error al desvincular los documentos.',
  match_internal_transactions_pending: 'Conciliando transacciones internas...',
  match_internal_transactions_success: 'Transacciones internas conciliadas correctamente.',
  match_internal_error: 'Ha ocurrido un error al conciliar las transacciones internas.',
  match_bank_transaction: 'Conciliar transacción bancaria',
  upload_and_match_purchase_invoice: 'Subir y Enlazar factura de gasto',
  upload_and_match_sales_invoice: 'Subir y Enlazar factura de venta',
  match_with_amazon_vat_declaration: 'Conciliar declaración de IVA (Amazon)',
  pending_transaction_label: '[🔒Pendiente]',
  whats_pending_link: '¿Qué significa pendiente?',
  pending_transaction_info_modal_title: 'Sobre las transacciones pendientes',
  pending_transaction_info_modal_description:
    '<p>Esta transacción se encuentra actualmente pendiente. Ha sido iniciada por el banco, pero aún no ha sido registrada ni confirmada, lo que significa que todavía puede ser revertida o cancelada.</p><p>Por lo tanto, no puede conciliarse y se muestra solo con fines informativos y para verificar la exactitud de los saldos.</p>',
  transaction_search_filter_placeholder: 'Buscar por descripción',
  see_matching_details: 'Ver detalles de la conciliación',
  add_document_to_this_matching: 'Agregar documento a esta conciliación',
  add_transaction_to_this_matching: 'Agregar transacción a esta conciliación',
  transactions_page_empty_table_description:
    'No hay cuentas bancarias activas disponibles porque estás ocultando las cuentas cerradas. <p>¿Necesitas un consejo? <0>Mostrar cuentas cerradas</0></p>',
  no_eligible_banks: 'No hay bancos elegibles',
  connect_bank_due_no_bank_account_connected:
    'Para proporcionarte información sobre las transacciones, conecta al menos una cuenta bancaria y sube tus extractos bancarios.',
  connect_your_bank_account: 'Conecta tu cuenta bancaria',
  connect_your_bank_account_description:
    'Necesitamos que conectes al menos una cuenta bancaria para continuar',
  connect_now: 'Conectar ahora',
  provide_transaction_information:
    'Para proporcionarte información sobre las transacciones, conecta al menos una cuenta bancaria y sube tus extractos bancarios.',

  // Statements Page
  back_to_banks: 'Back to banks',
  back_to_bank: 'Volver a {{bankName}}',
  statements_table_title: 'Extractos',
  statements_table_header_name: 'Nombre del documento',
  statements_table_column_from: 'De: {{from}}',
  statements_table_options_download: 'Descargar',
  statements_table_options_change_type: 'Cambiar tipo',
  statements_table_options_move_to: 'Mover a {{date}}',
  statements_table_options_edit_name: 'Editar nombre',
  statements_table_options_edit_description: 'Editar descripción',
  statements_table_options_delete: 'Eliminar',
  statements_table_header_bulk_actions: 'Acciones masivas',
  all_banks: 'Todos los bancos',
  statements_table_header_date: 'Fecha de subida',
  statements_table_header_status: 'Estado',
  no_bank_accounts_connect_message:
    'No se han encontrado cuentas bancarias vinculadas a tu empresa. Para conciliar movimientos bancarios con facturas, nóminas o viajes, o para obtener estadísticas de ingresos y gastos de tu negocio, <0>vincula tu primera cuenta bancaria ahora</0>.',
  statements_table_upload_button: 'Subir',
  statements_upload_modal_title: 'Subir extracto',
  bank_account: 'Cuenta',
  statements_upload_pdf_image: 'Sube un archivo PDF, PNG, JPG o CSV válido para comenzar',
  select_bank_account_to_statement: 'Selecciona una cuenta bancaria para subir el extracto',
  show_all_banks: 'Mostrar todos los bancos',

  // My business page
  general_tab: 'General',
  registry_tab: 'Registro',
  digital_products_tab: 'Productos Digitales (OSS)',
  poa_tab: 'Autorización (PoA)',
  other_documents_tab: 'Otros Documentos',
  digital_products_page_header_title: '¿Ofreces productos o servicios digitales (OSS)?',
  digital_products_page_description:
    'Activa esta opción si tus clientes pueden descargar, acceder o disfrutar de tus productos digitales de forma automática, sin tu intervención: por ejemplo, descargas de e-books, servicios de streaming o una plataforma en la que los vendedores envían los productos directamente mientras tú cobras una comisión. Si es tu caso, registraremos tu empresa como proveedor OSS.',
  offer_digital_products_checkbox:
    'Sí, ofrezco productos o servicios digitales que pueden ser adquiridos, descargados o disfrutados por mis clientes sin mi intervención',
  oss_up_to_date_checkbox: 'El registro OSS y los datos están actualizados en el registro estonio',
  oss_registration_status: 'Estado de registro OSS',
  oss_registered: 'registrado',
  oss_registered_description:
    'El registro OSS y los datos están actualizados en el registro estonio',
  oss_unregistered: 'no registrado',
  oss_pending_registration: 'registro pendiente',
  digital_products_countries_list:
    'Lista de países (separados por comas) con establecimientos o instalaciones',
  digital_products_products_list: 'Lista de productos OSS (separados por comas)',
  other_vats: 'Otros IVA',
  other_vats_description:
    'Si tu empresa estonia tiene números de IVA en otros países, por favor infórmanos añadiéndolos aquí',
  digital_products_vats_list: 'Lista de IVA de otros países (separados por comas)',
  company_bank_information: 'Información de la cuenta bancaria de la empresa',
  digital_products_iban_list: 'IBAN',
  digital_products_swiftCode_list: 'Código SWIFT',
  oss_status_changing_warning:
    'Ten en cuenta que cambiar tu estado OSS requerirá modificaciones en el registro OSS de tu empresa. Procesar estos cambios puede llevar algo de tiempo.',
  digital_products_update_error: 'Hubo un error al actualizar los productos digitales',
  oss_confirm_submit_title: '¿Estás seguro de que quieres enviar esta información?',
  oss_confirm_submit_description_html:
    'Una vez enviada, no podrás editar estos campos hasta que se complete tu registro OSS. <b>Por favor, asegúrate de que todo es correcto antes de continuar.</b>',
  oss_changes_submitted_toast: 'Cambios enviados. Tu contable los revisará en breve',
  oss_deregister_title: '¿Estás seguro de que quieres darte de baja del OSS?',
  oss_deregister_description_html:
    'Al desactivar esta opción se iniciará el proceso de cancelación de tu registro OSS ante la autoridad fiscal. <b>Revisaremos tu solicitud y actualizaremos tu estado una vez confirmada.</b>',
  oss_deregister_success_toast:
    'Solicitud de baja enviada. Actualizaremos tu estado una vez confirmada.',
  oss_pending_registration_alert:
    'Estamos revisando tu registro OSS. Te avisaremos cuando se complete, <b>hasta entonces, tu información no se puede modificar</b>',
  oss_pending_deregistration_alert:
    '<b>Nuestro equipo de contabilidad está procesando tu solicitud de baja del OSS.</b> Te avisaremos cuando se complete, hasta entonces no se pueden realizar cambios.',
  dropshipping_ecommerce_business: 'Negocio de dropshipping / eCommerce',
  automated_platform_or_saas: 'Plataforma automatizada o SaaS',
  countries_of_establishment: 'Países de establecimiento',
  oss_products: 'Productos OSS',
  other_vat_numbers: 'Otros números de IVA',
  iban_swift: 'IBAN / SWIFT',
  oss_registration_request_received_title: 'Hemos recibido tu solicitud de registro OSS',
  oss_registration_request_received_description:
    'Nuestro equipo revisará tu solicitud y actualizará tu estado en consecuencia. Este proceso puede llevar algún tiempo, te avisaremos en cuanto haya un cambio.',
  oss_premium_upgrade_title: '¡Actualiza a PREMIUM para desbloquear el registro OSS!',
  oss_premium_upgrade_representative_description_html:
    "Para registrar y gestionar tu estado OSS, incluyendo el envío de tus datos y el seguimiento de la aprobación, necesitas actualizarte a nuestro plan PREMIUM. Consulta nuestra <a href='https://companio.co/pricing/' target='_blank' rel='noreferrer'>página de precios</a> para más detalles. ¿Listo para actualizar?",
  oss_premium_upgrade_non_representative_description:
    'El registro OSS está disponible en nuestro plan PREMIUM y superiores. Solo el representante de tu empresa puede actualizar la suscripción, por favor ponte en contacto con él para continuar.',
  annual_report_poa_modal_title: 'Necesitamos un Poder Notarial para presentar tu informe anual',
  annual_report_poa_modal_description:
    "Necesitamos que nos concedas un Poder Notarial, como requisito estándar para operar con las autoridades estonias. <strong>Por favor, pulsa el botón 'Conceder PoA' para continuar.</strong>",
  accounting_poa_modal_title: 'Necesitamos un Poder Notarial para hacer tu contabilidad',
  accounting_poa_modal_description:
    "Necesitamos que nos concedas un Poder Notarial, como requisito estándar para operar con las autoridades estonias. <strong>Por favor, pulsa el botón 'Conceder PoA' para continuar.</strong>",
  stats_poa_modal_title:
    'Necesitamos un Poder Notarial para enviar la información de tu empresa al portal eSTAT',
  stats_poa_modal_description:
    "Como empresa estonia, debes enviar información sobre tu empresa a través del portal online eSTAT. Si deseas concedernos permiso para hacerlo en tu nombre, pulsa el botón 'Conceder PoA'.",
  remind_me_later: 'Recuérdamelo más tarde',
  review_account: 'Revisar cuenta',
  grant_poa: 'Conceder PoA',
  card_description_label: '¿Cómo concedernos un Poder Notarial?',
  accounting_card_description_text:
    'Para hacer tu contabilidad, necesitamos que concedas un Poder Notarial a uno de nuestros contables. Es un requisito estándar para operar sin problemas con las autoridades estonias. Puedes ver cómo hacerlo paso a paso <0>aquí</0>.',
  annual_report_card_description_text:
    'Para presentar tu informe anual, necesitamos que nos concedas un Poder Notarial. Es un requisito estándar para operar sin problemas con las autoridades estonias. Puedes ver cómo hacerlo paso a paso <0>aquí</0>.',
  stats_card_description_text:
    'Como empresa estonia, debes enviar información sobre tu empresa a través del portal online eSTAT. Si deseas conceder permiso a uno de nuestros contables para enviar esta información en tu nombre, puedes ver cómo hacerlo paso a paso <0>aquí</0>.',
  accounting_poa: 'PoA de contabilidad',
  annual_report_poa: 'PoA de informe anual',
  stats_poa: 'PoA de estadísticas',
  not_requested: 'no solicitado',
  mark_as_granted: 'Marcar como concedido',
  requested_date: 'Fecha de solicitud',
  granted_date: 'Fecha de concesión',
  poa_grant_confirm_modal_title: '¿Se ha concedido y verificado este Poder Notarial?',
  poa_grant_confirm_modal_description:
    'Asegúrate de que el Poder Notarial se ha comprobado en el registro electrónico de empresas antes de marcarlo como concedido.',
  poa_grant_confirm_modal_cancel: 'Lo comprobaré de nuevo',
  poa_status_update_pending: 'Actualizando Poder Notarial...',
  poa_status_update_success: 'Poder Notarial actualizado con éxito',
  poa_status_update_error: 'Hubo un error al actualizar el Poder Notarial',
  digital_products_modal_title: '¿Estás seguro de que quieres cambiar esta información?',
  digital_products_modal_description:
    'Nuestro contable recibirá una notificación para revisar esta nueva información con el registro para su aprobación. <b>Puede tardar un poco, pero ¿aun así deseas continuar?</b>',
  registry_date_registered: 'fecha de registro',
  registry_vat_number: 'Número de IVA (opcional)',
  registry_vat_since_date: 'Sujeto a IVA desde la fecha',
  current_members: 'Miembros actuales',
  need_to_make_changes: '¿Necesitas hacer cambios aquí?',
  registry_support_text:
    'Si has hecho cambios en el registro o deseas realizarlos, por favor contacta con nuestro equipo de soporte a través de <0>el chat</0>.',
  general_support_text:
    'Si realizaste cambios en la configuración general o deseas hacerlos, por favor contacta a nuestro equipo de soporte a través de <0>el chat</0>.',
  company_data_update_pending: 'Actualizando los datos de la empresa...',
  company_data_update_success: 'Datos de la empresa actualizados con éxito',
  company_data_update_error: 'Hubo un error al actualizar los datos de la empresa',
  general_data_title: 'Datos de la empresa',
  general_data_company_name: 'nombre de la empresa',
  general_data_company_plan: 'plan',
  general_data_company_status: 'estado',
  general_data_company_support_pin: 'PIN de soporte',
  general_data_company_email: 'correo electrónico',
  general_data_company_phone_number: 'número de teléfono',
  general_data_company_registry_number: 'código de registro',
  general_data_company_registered_since: 'registrada desde',
  general_data_company_vat_number: 'número de IVA',
  general_data_company_vat_number_since: 'número de IVA desde',
  general_data_company_share_capital: 'capital social',
  general_data_company_share_capital_date: 'capital social registrado',
  general_data_company_in_accounting_date: 'en contabilidad desde',
  general_data_company_other_vats: 'otros IVA',
  general_data_company_street_address: 'dirección (calle)',
  general_data_company_city_address: 'ciudad',
  general_data_company_zip_address: 'código postal',
  general_data_company_country_address: 'país',
  general_data_company_activity: 'actividad',
  board_member_type: 'Miembro del consejo',
  shareholder_type: 'Accionista',
  both_type: 'Ambos',
  edit_info: 'Editar información',
  company_member_update_pending: 'Actualizando perfil...',
  company_member_update_success: 'Perfil actualizado correctamente.',
  company_member_update_error: 'Se produjo un error al actualizar tu perfil.',
  all_types: 'Todos los tipos',
  all_statuses: 'Todos los estados',
  other_documents_title: 'Otros documentos',
  other_documents_table_header_add_invoice_button: 'Subir documento',
  document_type_other: 'Otro',
  document_type_passport_pic: 'Foto del pasaporte',
  document_type_company_data: 'Datos de la empresa',
  document_type_contract: 'Contrato',
  document_type_company_registration: 'Registro de la empresa',
  document_type_business_trip_doc: 'Documento de viaje de negocios',
  document_type_scanned_letter: 'Carta escaneada',
  document_type_employment_contract: 'Contrato laboral',
  document_type_member_residence_proof: 'Comprobante de residencia del miembro',
  document_type_statement_profit_losses_archive: 'Archivo de pérdidas y ganancias',
  document_type_balance_sheets_archive: 'Archivo de balances',
  document_type_general_ledger_archive: 'Archivo del libro mayor',
  document_type_bank_statements_archive: 'Archivo de estados bancarios',
  document_type_accounts_payable_receivable_archive: 'Archivo de cuentas por pagar y por cobrar',
  upload_other_documents_modal_title: 'Subir documentos',
  upload_other_documents_modal_dismiss_button: 'Cerrar',
  upload_other_documents_modal_description:
    'Por favor, selecciona el tipo de documento que vas a subir, luego elige el archivo y haz clic en el botón para proceder con la subida.',
  type_of_document: 'Tipo de documento',
  select_type_of_document: 'Selecciona el tipo de documento',
  upload_other_documents_modal_drop_files_description: 'También puedes soltar tus archivos aquí',
  other_documents_upload_pdf_csv_image:
    'Sube un archivo válido en formato PDF, DOC, DOCX, PNG, JPG o CSV para comenzar',
  upload_other_documents_modal_uploading_files:
    'Subiendo 1 - {{filesUploaded}} de {{filesToUpload}} cargados con éxito',
  upload_other_documents_modal_uploaded_files:
    '{{filesUploaded}} de {{filesToUpload}} cargados con éxito',
  upload_other_documents_modal_uploaded_files_failed: '- {{filesFailed}} fallidos',
  other_documents_table_header_bulk_actions: 'Acciones masivas',
  delete_other_document_modal_title: 'Confirmar eliminación',
  delete_other_document_modal_description_multiple:
    'Por favor, confirma que deseas eliminar los siguientes documentos:',
  delete_other_document_modal_description_single:
    '¿Estás seguro de que deseas eliminar este documento? Esta acción no se puede deshacer. Una vez eliminado, no podrás volver a subir el documento, ya que nuestro sistema recuerda una huella digital del archivo para evitar envíos duplicados.',
  delete_other_document_modal_cancel_button: 'Cancelar',
  delete_other_document_modal_confirm_button: 'Confirmar',
  invoice_photo_description:
    'Esta foto se mostrará en las facturas generadas. Tamaño máximo de la foto 1 MB.',
  company_email_updated_successfully: 'Correo electrónico actualizado correctamente.',
  user_email_updated_successfully: 'Correo electrónico actualizado correctamente.',
  power_of_attorney_grant_sent_to_accountant_success:
    '<strong>Se ha enviado una notificación al contador</strong>. <br /> Te avisaremos si necesitamos algo más.',
  business_info_email_note:
    'Este es el correo electrónico de tu empresa, no tu email de acceso como usuario. Si quieres cambiar el correo con el que accedes a Companio, ve a la sección de Perfil.',
  oss_question_1:
    '1. ¿Tu negocio es una tienda de dropshipping/eCommerce en la que tu proveedor envía los productos directamente a tus clientes?',
  oss_question_2:
    '2. ¿Operas una plataforma automatizada o SaaS (por ejemplo, Netflix o Airbnb), en la que los clientes compran y consumen tus servicios sin tu intervención directa?',
  company_updated_successfully: 'Datos de la empresa actualizados correctamente.',

  // Companion page
  page_title_companion: 'Companion®',
  what_is_companion_title: '¿Qué es un Companion®?',
  what_is_companion_description:
    'Un Companion® es un profesional dedicado que ofrecemos exclusivamente a nuestros clientes VIP para ayudar en la gestión empresarial y tareas contables. Piensa en él como un entrenador personal para tu negocio, enfocado en tus necesidades y objetivos únicos. Con experiencia en contabilidad, fiscalidad y administración, los Companions son más que asistentes: son aliados estratégicos. Como parte del equipo de Companio, ofrecen acceso directo a nuestros recursos y expertos, garantizando que tu empresa esté respaldada en todo momento. ¿Quieres saber más sobre cómo un Companion® puede ayudarte? <0>Haz clic aquí para obtener más información</0>.',
  why_having_companion_title: '¿Por qué tener un Companion®?',
  accounting_support_description:
    '<bold>Asistencia integral en contabilidad, administración y finanzas</bold>. Tu Companion® es un experto en finanzas y administración dedicado a tu empresa, por una fracción del coste de contratar personal a tiempo completo.',
  administration_description:
    '<bold>Administración sencilla y total flexibilidad</bold>. Nos encargamos de las tareas complejas de RR. HH., ofreciendo una selección de candidatos formados listos para aportar a tu empresa. Si no estás satisfecho, sustituiremos a tu Companion® sin coste adicional.',
  issue_resolution_description:
    '<bold>Resolución rápida de problemas con acceso directo a Companio</bold>. Tu Companion® trabaja estrechamente con los equipos de contabilidad y atención al cliente de Companio, asegurando una solución ágil y una coordinación fluida.',
  get_your_companio_button: '¡Consigue tu Companion® ahora!',
  companion_name: 'Nombre',
  companion_assigned_hours: 'Horas asignadas por defecto',
  active_since: 'Activo desde',
  cancel_companion_service: 'Cancelar servicio de Companion®',
  companion_modal_title: '¿Estás seguro de que quieres cancelar el servicio de Companion®?',
  companion_creating_pending: 'Creando el servicio de Companion®...',
  companion_creating_success: 'Servicio de Companion® creado con éxito',
  companion_creating_error: 'Hubo un error al crear el servicio de Companion®',
  companion_ticket_table_header_details: 'Detalles del ticket',
  companion_ticket_table_header_date: 'Fecha de creación',
  companion_ticket_table_header_closed: 'Fecha de cierre',
  companion_ticket_table_status: 'Estado',
  page_title_companion_ticket_details: 'Volver a los chats',
  companion_table_header_add_ticket: 'Añadir nuevo',
  ticket_create_pending: 'Creando conversación...',
  ticket_create_success: 'Conversación creada con éxito',
  ticket_create_error: 'Hubo un error al crear la conversación',
  companion_ticket_subject: 'Asunto',
  companion_ticket_topic: 'Tema',
  companion_ticket_description: 'Descripción',
  new_companion_ticket_modal_title: 'Añadir nueva conversación',
  companion_update_pending: 'Actualizando Companion® service...',
  companion_update_success: 'Companion® service actualizado con éxito',
  companion_update_error: 'Hubo un error al actualizar Companion®',
  companion_files_table_title: 'Todos los archivos',
  companion_files_table_header_document_name: 'Nombre del documento',
  companion_files_table_header_document_created: 'Fecha de creación',
  companion_files_table_header_add_document_button: 'Añadir archivos',
  add_companion_files_modal_title: 'Subir archivos',
  confirm_companion_document_title:
    '¿Está seguro de que quiere eliminar este documento? Esta acción no se puede deshacer.',
  activate_companion_modal_title: 'Activa Companion® como un servicio adicional en tu plan actual',
  activate_companion_modal_description:
    'Para habilitar Companion®, <bold>se añadirá una tarifa mensual de 799 € (IVA no incluido)</bold> a tu suscripción actual. ¿Deseas continuar con la activación de este servicio?',
  companion_activation_sucess_modal_title: 'Companion® activado correctamente',
  companion_activation_success_modal_description:
    'El servicio Companion® se ha añadido a tu suscripción mensual.',
  companion_activation_error_modal_title: 'Error en la activación',
  companion_activation_error_modal_description:
    'No pudimos activar el servicio Companion®. Por favor, inténtalo de nuevo y, si el problema persiste, contacta con nuestro equipo de atención al cliente a través del <0>chat</0>. Estaremos encantados de ayudarte.',
  chat: 'Chat',
  files: 'Archivos',

  // Marketplace page
  marketplace_page_title: 'Marketplace',
  marketplace_list_your_business: 'Añadir tu negocio',
  marketplace_category_all: 'Todas las ofertas',
  marketplace_category_banking_payments: 'Banca',
  marketplace_category_legal: 'Legal',
  marketplace_category_marketing: 'Marketing',
  marketplace_category_tech_development: 'Tecnología',
  marketplace_category_other: 'Otros',
  marketplace_load_error:
    'Algo salió mal al cargar el marketplace. Por favor, inténtalo de nuevo más tarde.',
  marketplace_empty: 'No hay ofertas disponibles en esta categoría todavía.',
  partners: 'Socios',
  wise_card_title:
    'Envía y recibe dinero globalmente con comisiones bajas y tipos de cambio reales.',
  wise_card_description:
    'Gestiona cuentas multimoneda, recibe pagos como un local y paga facturas globales con comisiones mínimas y total transparencia desde una sola plataforma.',
  wise_card_alert:
    '👉 Transfiere hasta 10.000 EUR sin comisiones usando nuestro enlace exclusivo para clientes Companio',
  create_account: 'Crear cuenta',
  payoneer_card_title:
    'Plataforma de pagos global diseñada para freelancers, startups y negocios digitales',
  payoneer_card_description:
    'Recibe pagos globales, gestiona múltiples ingresos y retira fondos en tu moneda local, todo desde una cuenta sin comisiones mensuales.',
  payoneer_card_alert:
    '👉 Accede fácilmente a una cuenta global y recibe pagos internacionales sin costos ocultos',
  revolut_card_title:
    'Transfiere dinero en más de 30 divisas, incluyendo criptomonedas y monedas locales',
  revolut_card_description:
    'Crea cuentas multimoneda, haz transferencias locales gratis y controla tus gastos desde una app simple, rápida y segura para negocios.',
  revolut_card_alert:
    '👉 Disfruta 1 mes gratis de Revolut Business con herramientas exclusivas y sin compromiso',

  // Accounting reports
  page_title_reports: 'Informes contables',
  accounting_reports_table_title: 'Todos los informes',
  accounting_reports_table_description: 'Descripción',
  accounting_reports_table_status: 'Estado',
  accounting_reports_table_date: 'Fecha de creación',
  accounting_reports_table_taxes: 'Impuestos a pagar',
  accounting_table_dropdown_view: 'Ver detalles',
  accounting_reports_table_description_column: 'Informe {{type}} {{month}}/{{year}}',
  accounting_reports_table_description_column_quarter: 'Informe {{type}} T{{quarter}}',
  back_to_accounting_reports: 'Volver a los informes',
  accounting_report_details_step_in_preparation: '1. En preparación',
  accounting_report_details_step_prepared: '2. Preparado',
  accounting_report_details_step_submitted: '3. Presentado',
  accounting_report_details_step_taxes_paid: '4. Impuestos pagados',
  report_details_in_preparation_title: '¡Su informe está en progreso!',
  report_details_in_preparation_description:
    'Nuestro sistema contable está revisando sus datos para preparar el informe. Si necesitamos documentos adicionales o aclaraciones, recibirá un correo con los próximos pasos.',
  accountancy_completed_title: 'Contabilidad completada',
  accountancy_completed_description:
    'Como resultado de los cálculos del {{reportType}} de sus actividades durante ese período, debe pagar un {{reportType}} por un importe de {{amount}}{{currency}} a la Oficina Tributaria de Estonia.',
  payment_deadline: 'Fecha límite de pago',
  accounting_report_instructions: 'Instrucciones',
  accounting_report_instructions_1:
    'Verifique su número de referencia <a href="https://apps.emta.ee/saqu/public/reference?lang=en" target="_blank">aquí</a> mediante su código de registro de empresa.',
  accounting_report_instructions_2:
    'Consulte la información de la cuenta bancaria de la Oficina Tributaria <a href="https://www.emta.ee/en/business-client/taxes-and-payment/payment-arrears/payment-taxes#bank-transfer" target="_blank">aquí</a>.',
  accounting_report_instructions_3:
    'Utilice el número de referencia de su empresa {{reference}} para realizar el pago.',
  tax_office: 'Oficina Tributaria',
  tax_office_bank: 'Banco: {{bank}}',
  tax_office_bank_account: 'Cuenta bancaria IBAN: {{iban}}',
  tax_office_bic_swift: 'BIC/Swift: {{bicSwift}}',
  tax_office_reference: 'Referencia: {{reference}}',
  tax_office_concept: 'Concepto: {{concept}} impuestos {{date}}',
  thank_you_for_keeping_it_fair: '¡Gracias por cumplir con sus obligaciones! 🙌',
  report_document_table_title: 'Documento del informe',
  report_document_table_description: 'Descripción',
  report_document_table_date: 'Fecha',
  paid_taxes: 'Impuestos pagados',
  download_reports: 'Descargar Informes',
  confirm_paid_taxes_modal_title: 'Estás a punto de confirmar esta acción',
  confirm_paid_taxes_modal_description:
    '¿Has pagado los impuestos correspondientes a la cuenta bancaria de la oficina tributaria?',
  report_details_submitted_title: 'Informe {{type}} para: {{date}}',
  updating_report_status_loading: 'Actualizando estado del informe...',
  updating_report_status_success: 'Estado del informe actualizado con éxito',
  choose_a_bank_first: 'Por favor, elija un banco primero',
  report_details_prepared_title: 'Su informe está listo!',
  report_details_prepared_description:
    'Nuestro sistema contable ha terminado de revisar sus datos para preparar el informe. Sin embargo, necesitamos tiempo para presentarlo a la autoridad tributaria y le informaremos pronto sobre los resultados. Si necesitamos documentos adicionales o aclaraciones, recibirá un correo con los próximos pasos.',
  accountancy_completed_description_no_taxes:
    'El resultado de este informe es que <strong style="font-weight: bold">su empresa no necesita pagar impuestos.</strong>',
  oss_report_quarter_concept: 'Concepto: {{concept}} impuestos T{{quarter}} {{year}}',
  report_details_submitted_title_oss: 'Informe {{type}} para: T{{quarter}} {{year}}',
  mark_as_paid: 'Marcar como pagado',
  report_details_download: 'Descargar',
  report_details_vat_to_pay: '{{type}} a pagar',
  report_details_vat_paid: '{{type}} pagado',
  report_details_submitted_date: 'Fecha de envío',
  report_details_what_to_do: '¿Qué debes hacer?:',
  report_details_no_pay_instruction_1:
    'Buenas noticias — <strong>no hay impuestos pendientes para este período.</strong>',
  report_details_no_pay_instruction_2:
    'Marca el informe como completado usando el botón de arriba.',
  report_details_instruction_1:
    'Verifica el número de referencia de tu empresa {{reference}} <a href="https://apps.emta.ee/saqu/public/reference?lang=en" target="_blank" rel="noopener noreferrer">aquí</a> y úsalo para pagar el importe ({{currency}}{{amount}}).',
  report_details_instruction_2:
    'Verifica la información de la cuenta bancaria de la oficina tributaria <a href="https://www.emta.ee/en/business-client/taxes-and-payment/payment-arrears/payment-taxes#bank-transfer" target="_blank" rel="noopener noreferrer">aquí</a>.',
  report_details_instruction_3:
    'Marca el pago como completado usando el botón en la parte superior.',
  report_details_payment_details: 'Detalles de pago:',
  report_details_bank: 'Banco',
  report_details_iban: 'IBAN',
  report_details_bic_swift: 'BIC/Swift',
  report_details_reference: 'Referencia',
  report_details_concept: 'Concepto',
  report_details_compliance_note:
    'Tu informe de {{type}} está listo. Un paso más para estar al día con tus obligaciones fiscales. 🙌',
  report_details_not_started_banner_title: 'Informe no iniciado',
  report_details_not_started_banner_description:
    'Nuestro sistema está revisando si este informe necesita iniciarse. Si es así, lo pondremos en marcha en breve y empezaremos a recopilar toda la información necesaria, incluidos los documentos o datos que podamos necesitar de ti.',

  // Accounting
  accounting_tab_overdue: 'Vencido',
  accounting_tab_rejected: 'Rechazado',
  accounting_tab_current: 'Actual ({{currentFiscalDate}})',
  accounting_tab_next_month: 'Próximo mes',
  accounting_tab_matched: 'Conciliado',
  accounting_current_month_info:
    '<strong>IMPORTANTE:</strong> Por favor concilie sus transacciones y suba sus documentos antes del {{date}}',
  accounting_current_month_title: 'Movimientos de {{month}}',
  accounting_description: 'Descripción',
  accounting_type: 'Tipo',
  accounting_date: 'Fecha',
  accounting_upload_or_match: 'Subir o conciliar',
  accounting_amount: 'Monto',
  back_to_accounting: 'Volver a contabilidad',
  matching_explanation_none_of_the_above:
    "Los tipos de conciliación no admitidos se declararán como 'Gastos no comerciales'. Esto puede incurrir en obligaciones tributarias con las autoridades fiscales locales.",
  matching_explanation_sales_invoice:
    'Concilia transacciones con facturas de servicios digitales o bienes entregados por tu empresa a clientes. Por ejemplo, si has proporcionado servicios de diseño web a un cliente, conciliarías el pago recibido con la factura de venta correspondiente.',
  matching_explanation_purchase_invoice:
    'Concilia transacciones con facturas de bienes o servicios entregados a ti. Por ejemplo, si has comprado material de oficina a un proveedor, conciliarías el pago realizado con la factura de compra recibida.',
  matching_explanation_bank_fee:
    'Identifica los cargos bancarios mensuales por mantenimiento de cuenta o tarjeta. Por ejemplo, si tu banco deduce una tarifa mensual por mantener tu cuenta empresarial, la categorizarías como una comisión bancaria.',
  matching_explanation_state_fee:
    'Indica las tasas pagaderas al gobierno estonio por actividades con el registro de e-Business o pago de impuestos a la Oficina Tributaria (Tax Office).',
  matching_explanation_daily_allowance:
    'Identifica los reembolsos por gastos diarios durante viajes de negocios, una vez que haya sido aprobado. Por ejemplo, si te has pagado una dieta diaria para comidas durante un viaje de negocios, lo categorizarías como dieta diaria.',
  matching_explanation_internal:
    'Indica transferencias entre cuentas empresariales. Por ejemplo, si has transferido fondos desde tu cuenta corriente empresarial a tu cuenta de ahorros empresarial, lo categorizarías como un movimiento interno de fondos. No lo uses para transacciones entre tu empresa estonia y otra empresa, incluso si eres propietario de ambas.',
  matching_explanation_other:
    'Movimiento que no puede clasificarse en ninguna de las otras categorías',
  matching_explanation_share_capital:
    'Declara pagos por aportaciones de capital social. Por ejemplo, si un accionista agrega fondos adicionales a la empresa después de aumentar el capital social, lo categorizarías como una aportación de capital social.',
  matching_explanation_dividends:
    'Distribuye ganancias a los accionistas. Por ejemplo, si la empresa distribuye ganancias a sus accionistas después de la presentación del informe anual si la empresa tuvo beneficios, lo categorizarías como dividendos.',
  matching_explanation_card_verification:
    'Identifica pequeños cargos por verificación de tarjeta. Por ejemplo, si un comerciante cobra una tarifa nominal para verificar tu tarjeta de crédito, lo categorizarías como verificación de tarjeta. Generalmente 0€, pero ocasionalmente puede ser una pequeña cantidad, como 0,01€.',
  matching_explanation_bank_cashback:
    'Regresa cashbacks por intereses ganados. Por ejemplo, si tu cuenta bancaria empresarial ofrece recompensas de cashback por mantener un saldo mínimo, lo categorizarías como cashback bancario.',
  matching_explanation_received_interest:
    'Identifica ingresos por intereses. Por ejemplo, si tu empresa obtiene intereses de inversiones en plataformas reguladas, lo categorizarías como intereses recibidos.',
  matching_explanation_non_business_expense:
    'Identifica gastos como comida, bebidas, almuerzos o ropa pagados con fondos corporativos. Por ejemplo, si has usado la tarjeta de crédito de la empresa para pagar un café o un almuerzo, lo categorizarías como un gasto no comercial.',
  matching_explanation_personal_expense_refund:
    'Un miembro de la empresa realizó un gasto personal con los fondos corporativos de la empresa y luego reembolsó el dinero a la empresa. Se te pedirá que elijas la transacción a conciliar. El reembolso debe provenir de la cuenta bancaria personal de uno de los miembros de la empresa.',
  matching_explanation_refunded_sale:
    'Un cliente recibió un pago (transacción entrante) que posteriormente fue reembolsado en su totalidad (transacción saliente). Ambas transacciones deben tener exactamente el mismo importe, involucrar al mismo tercero y pertenecer al mismo mes contable. No se requiere factura.',
  matching_explanation_refunded_purchase:
    'Se realizó un pago a un proveedor (transacción saliente) que posteriormente fue reembolsado en su totalidad (transacción entrante). Ambas transacciones deben tener exactamente el mismo importe, involucrar al mismo tercero y pertenecer al mismo mes contable. No se requiere factura.',
  matching_explanation_state_refund:
    'Esto es un reembolso del estado, por ejemplo, una devolución de impuestos de EMTA (Agencia Tributaria y Aduanera Estona). Este reembolso debe provenir del gobierno estonio o de una institución estonia oficial (como el Registro de e-Business o la Oficina Tributaria).',
  matching_explanation_commission_earnings:
    'Esta es una pequeña comisión o tarifa obtenida de un banco o proveedor de servicios por algún tipo de registro de afiliado o referencia. Esta comisión debe ser pequeña y ocasional. Si la actividad principal de la empresa se basa en enlaces de afiliados o referencias de productos o servicios, necesitas pedir una factura a las agencias con las que trabajas.',
  matching_explanation_inner_trading:
    'La actividad de trading no declarable se refiere a transacciones que ocurren dentro de una plataforma de inversión donde la empresa ha añadido fondos para invertir. Estas transacciones internas, como comprar y vender valores dentro de la plataforma, no son relevantes para la contabilidad de la empresa. La adición inicial de fondos a la plataforma de inversión y la posterior retirada no deben conciliarse como Actividad de Trading No Declarable.',
  matching_explanation_investment_add_funds:
    'Esta transacción representa la adición de fondos a una plataforma de inversión. La empresa ha añadido dinero a la plataforma para invertir en valores u otros instrumentos financieros. Esta es una transacción saliente, lo que significa que el dinero se deduce del saldo de la cuenta.',
  matching_explanation_investment_withdraw_funds:
    'Esta transacción representa la retirada de fondos de una plataforma de inversión. La empresa ha retirado dinero de la plataforma, normalmente después de vender valores u otros instrumentos financieros. Esta es una transacción entrante, lo que significa que el dinero se añade de nuevo al saldo de la cuenta.',
  matching_explanation_principal:
    'El monto del principal debe ser mayor que 0 y no puede ser mayor que {{transaction_amount}}.',
  matching_explanation_interest:
    'El monto de interés debe ser mayor que 0 y no puede ser mayor que {{transaction_amount}}.',
  matching_explanation_fees:
    'El monto de la tarifa debe ser 0 o más y menos de {{transaction_amount}}.',
  matching_explanation_amount:
    'El total de principal, interés y tarifas debe ser igual a {{transaction_amount}}.',
  matching_explanation_interest_paid:
    'Intereses pagados por préstamos o líneas de crédito. Por ejemplo, si una empresa paga intereses sobre un préstamo o línea de crédito, se categoriza como intereses pagados.',
  matching_explanation_repayment_installment:
    'Un pago regular realizado para pagar un préstamo. Por ejemplo, si una empresa tiene un préstamo, cada pago programado es una cuota para su reembolso.',
  matching_explanation_initial_principal_payment:
    'Este tipo de conciliación representa la transferencia inicial de fondos del prestamista al prestatario cuando se concede un préstamo. Refleja el desembolso del importe principal del préstamo al prestatario, no la devolución del mismo.',
  matching_explanation_held_fund_reserve:
    'Un proveedor de pagos o banco retiene parte de un cobro recibido como garantía, para cubrir posibles riesgos futuros como devoluciones o reembolsos. El dinero queda “bloqueado” temporalmente y no está disponible para la empresa hasta que se libere.',
  matching_explanation_released_fund_reserve:
    'El banco o proveedor de pagos devuelve a la empresa los fondos que estaban retenidos previamente como garantía, pasando a estar disponibles en la cuenta.',
  accounting_upload_purchase_invoice: 'Subir nueva factura de compra',
  accounting_upload_sales_invoice: 'Subir nueva factura de venta',
  accounting_table_current_empty_table:
    '¡Felicidades, todos tus documentos para este período están conciliados!',
  need_connect_back_title: 'Cuentas bancarias desconectadas',
  need_connect_back_description: 'Por favor, conecte su cuenta bancaria',
  missing_bank_statement_title: 'Extractos bancarios faltantes',
  missing_bank_statement_description: 'Suba su extracto de {{bankName}} para {{month}} {{year}}',
  accounting_bank_statements_info:
    'Para proporcionarle información de transacciones, por favor conecte sus cuentas bancarias y suba sus extractos bancarios.',
  accounting_matched_title: 'Conciliado',
  accounting_matched: 'Conciliado',
  accounting_dropdown_upload_match_extra_document: 'Subir y conciliar documento adicional',
  accounting_dropdown_add_extra_document: 'Añadir documento de conciliación adicional',
  accounting_dropdown_see_transaction: 'Ver transacción',
  no_transaction_id_found: 'No se encontró ID de transacción. Por favor, intente nuevamente.',
  no_document_type_found: 'No se encontró tipo de documento. Por favor, intente nuevamente.',
  accounting_request_fix_invoice_modal_title_unavailable:
    'Título no disponible. Por favor, intente nuevamente.',
  accounting_request_fix_invoice_modal_description_unavailable:
    'Descripción no disponible. Por favor, intente nuevamente.',
  request_info_modal_title: 'Proporcionar Detalles para Categorización de Transacción',
  request_info_modal_description:
    'Para ayudarnos a categorizar su transacción con precisión, por favor proporcione detalles adicionales cuando se le solicite. Esto ayudará a nuestro equipo de contabilidad si hay alguna incertidumbre respecto a la transacción.',
  notify_personal_expense_modal_title: 'Acción Requerida: Notificación de Gasto Personal',
  notify_personal_expense_modal_description:
    'Creemos que esta transacción podría ser un gasto de negocio. Por favor, tome una de las siguientes acciones:',
  notify_personal_expense_modal_action_1:
    'Suba una factura adecuada si es un gasto de negocio deducible.',
  notify_personal_expense_modal_action_2:
    'Procese un reembolso y categorice la transacción como reembolso de gasto personal.',
  notify_personal_expense_modal_action_3: 'Concílielo como gasto no empresarial.',
  accounting_no_accounting_request_found:
    'No se encontró solicitud de contabilidad. Por favor, intente nuevamente.',
  accounting_dropdown_unmatch: 'Desconciliar',
  accounting_info_not_matched_warning:
    'Los gastos no conciliados durante 2 meses se clasificarán como gastos no empresariales. Revisa las transacciones vencidas y concílialas.',
  accounting_rejected_title: 'Documentos Rechazados',
  accounting_status: 'Estado',
  accounting_rejection_status_detected: 'Rechazo detectado',
  accounting_rejection_status_verification_requested: 'Apelación solicitada',
  accounting_rejection_status_solved: 'Rechazo resuelto',
  accounting_rejection_status_confirmed: 'Rechazo confirmado',
  accounting_rejection_status_description_detected: 'Por el sistema',
  accounting_rejection_status_description_verification_requested: 'Cliente apela',
  accounting_rejection_status_description_solved: 'Por el contador',
  accounting_rejection_status_description_confirmed: 'Por el contador',
  accounting_rejection_reasons: 'Motivos de rechazo',
  accounting_rejected_summary_purchase: 'Compra',
  accounting_rejected_summary_sale: 'Venta',
  accounting_rejected_summary_contractor: 'Contratista',
  accounting_table_download: 'Descargar',
  accounting_table_appeal: 'Apelar rechazo',
  accounting_table_why_rejected: '¿Por qué fue rechazado?',
  accounting_table_options_replace: 'Reemplazar con documento correcto',
  accounting_table_options_delete: 'Eliminar',
  accounting_table_open_document: 'Abrir documento',
  accounting_upload_or_match_placeholder: 'Conciliar',
  accounting_option_match_with_purchase_invoice: 'Conciliar con factura de compra',
  accounting_option_match_with_sales_invoice: 'Conciliar con factura de venta',
  accounting_option_upload_purchase_invoice: 'Subir factura de compra',
  accounting_option_upload_sales_invoice: 'Subir factura de venta',
  accounting_option_state_fee: 'Tasa estatal',
  accounting_option_non_business_expense: 'Gasto no empresarial',
  accounting_option_daily_allowance: 'Dieta de viaje',
  accounting_option_internal_transfer: 'Transferencia interna',
  accounting_option_other_option: 'Otra opción',
  accounting_upload_or_match_default_option_error:
    'Opción no encontrada o no permitida. Por favor, intente nuevamente.',
  transaction_matched_as: 'Transacción conciliada como {{option}}.',
  from_table_header: 'De',
  match_personal_expense_refund_pending: 'Conciliación de reembolso de gasto personal pendiente',
  match_personal_expense_refund_success: 'Conciliación de reembolso de gasto personal exitosa',
  match_refunded_sale_pending: 'Conciliación de venta reembolsada pendiente',
  match_refunded_sale_success: 'Conciliación de venta reembolsada exitosa',
  match_refunded_purchase_pending: 'Conciliación de compra reembolsada pendiente',
  match_refunded_purchase_success: 'Conciliación de compra reembolsada exitosa',
  select_company_member: 'Seleccionar miembro de la empresa',
  accounting_overdue_title: 'Transacciones vencidas',
  select_an_agreement: 'Seleccionar un convenio',
  no_loan_agreements_found: 'No se encontraron convenios de préstamo',
  accounting_reset_all_banks: 'Reiniciar todos los bancos',
  accounting_banks_count: 'Seleccionado ({{count}})',
  accounting_bank_filter_last_option_selected:
    'Por favor, mantenga al menos una cuenta bancaria seleccionada',
  reset_all_banks: 'Reiniciar todos los bancos',
  reset_all_balances: 'Reiniciar todos los balances',
  all_balances: 'Todos los saldos',
  transaction_tooltip_description:
    '<strong style="font-weight: bold">Descripción:</strong> {{description}}',
  accounting_info_rejected_warning:
    'Algunos de tus documentos han sido rechazados. Haz clic en el menú de tres puntos para ver el motivo, subir el documento correcto o presentar una apelación.',
  cannot_be_matched: 'No se puede conciliar',

  // Workflows Page
  page_title_workflows: 'Flujos de trabajo',
  workflows_table_title: 'Todos los flujos de trabajo',
  workflows_table_header_add_workflow_button: 'Añadir flujo de trabajo',
  workflows_add_option_categorization_title: 'Categorización automática',
  workflows_add_option_categorization_description:
    'Categoriza automáticamente las transacciones o facturas que cumplan un conjunto de condiciones.',
  workflows_add_option_sales_invoice_title: 'Automatización de facturas de venta',
  workflows_add_option_sales_invoice_description:
    'Genera una factura de venta automáticamente cuando una transacción cumple tus condiciones.',
  sales_invoice_workflow_title: 'Automatizar la generación de facturas de venta',
  sales_invoice_workflow_subtitle:
    'Configura una condición con dos partes: cuándo debe activarse y qué factura debe generar automáticamente.',
  sales_invoice_workflow_step_conditions: 'Paso 1 — Condiciones del flujo de trabajo',
  sales_invoice_workflow_step_invoice: 'Paso 2 — Factura a generar',
  sales_invoice_workflow_provider_label: 'Pagos de este proveedor',
  sales_invoice_workflow_provider_placeholder: 'Nombre del proveedor',
  sales_invoice_workflow_amount_range_label: 'Rango de importe (opcional)',
  sales_invoice_workflow_amount_min: 'Mín €',
  sales_invoice_workflow_amount_max: 'Máx €',
  sales_invoice_workflow_amount_range_helper:
    'Déjalo vacío para que coincida con cualquier importe de este proveedor.',
  sales_invoice_workflow_bank_label: 'Cuenta bancaria (opcional)',
  sales_invoice_workflow_bank_helper:
    'Déjalo vacío para que coincida con transacciones de cualquiera de tus cuentas conectadas.',
  sales_invoice_workflow_initial_date_label: 'Empezar a generar facturas el',
  sales_invoice_workflow_customer_label: 'Cliente',
  sales_invoice_workflow_calculate_vat_title: 'Calcular el IVA automáticamente',
  sales_invoice_workflow_calculate_vat_subtitle: 'Según el país y el estado de IVA del cliente.',
  sales_invoice_workflow_vat_type_label: 'Tipo de IVA',
  sales_invoice_workflow_custom_vat_required: 'Requerido',
  sales_invoice_workflow_use_description_title: 'Usar la descripción de la transacción',
  sales_invoice_workflow_use_description_subtitle:
    'Desactívalo para definir una descripción personalizada para todas las facturas generadas.',
  sales_invoice_workflow_description_label: 'Descripción / concepto',
  sales_invoice_workflow_description_placeholder: 'Descripción para todas las facturas generadas',
  sales_invoice_workflow_submit: 'Automatizar',
  sales_invoice_workflow_update: 'Actualizar',
  sales_invoice_workflow_updated: 'Flujo de automatización de facturas de venta actualizado.',
  error_update_workflow: 'No se pudo actualizar el flujo de trabajo.',
  sales_invoice_workflow_back_to_transactions: 'Volver a transacciones',
  sales_invoice_workflow_auto_invoice_title: 'Creación automática de facturas',
  sales_invoice_workflow_auto_invoice_description:
    'Esto creará automáticamente una factura y la subirá a tus facturas de venta, según los datos que hayas rellenado arriba. Previsualízala abajo para ver un ejemplo.',
  sales_invoice_workflow_preview_invoice: 'Previsualizar factura',
  sales_invoice_workflow_created: 'Flujo de automatización de facturas de venta creado.',
  sales_invoice_vat_option_none: 'No incluir IVA en la factura (cliente fuera de la UE)',
  sales_invoice_vat_option_reverse_charge:
    'Añadir IVA de inversión del sujeto pasivo 0% (B2B en la UE, cliente con IVA)',
  sales_invoice_vat_option_estonian:
    'Añadir IVA estonio (cliente B2C en la UE, o B2B en la UE sin IVA)',
  sales_invoice_vat_option_custom: 'Añadir IVA personalizado (OSS, dropshipping, etc.)',
  sales_invoice_preview_modal_title: 'Vista previa de la factura',
  sales_invoice_preview_modal_subtitle:
    'Este es un ejemplo de cómo se verá tu próxima factura, según la información rellenada hasta ahora.',
  sales_invoice_preview_transaction: 'Transacción',
  sales_invoice_preview_generated_invoice: 'Factura generada',
  sales_invoice_preview_legend: 'Valores extraídos de la transacción y asignados a esta factura',
  sales_invoice_preview_unavailable: 'Vista previa no disponible.',
  sales_invoice_preview_payment: 'Pago',
  sales_invoice_preview_amount: 'Importe',
  sales_invoice_preview_from: 'De',
  sales_invoice_preview_to: 'Para',
  sales_invoice_preview_date: 'Fecha',
  sales_invoice_preview_bank: 'Banco',
  sales_invoice_preview_description: 'Descripción',
  sales_invoice_preview_description_example: 'Pago de un cliente',
  sales_invoice_preview_invoice: 'Factura',
  sales_invoice_preview_invoice_number: 'N.º de factura',
  sales_invoice_preview_issue_date: 'Fecha de emisión',
  sales_invoice_preview_item: 'Descripción',
  sales_invoice_preview_qty: 'Cant.',
  sales_invoice_preview_value: 'Importe',
  sales_invoice_preview_vat: 'IVA',
  sales_invoice_preview_total: 'Total',
  sales_invoice_preview_subtotal: 'Subtotal',
  error_create_workflow: 'No se pudo crear el flujo de trabajo.',
  workflow_name: 'Nombre',
  workflow_type: 'Tipo',
  workflow_status: 'Estado',
  workflow_created_date: 'Fecha de creación',
  workflow_categorized_invoices: 'N.º de facturas categorizadas',
  workflow_number_of_invoices: 'N.º de facturas',
  workflow_qualifier_generated: 'generadas',
  workflow_qualifier_categorized: 'categorizadas',
  update_workflow: 'Actualizar',
  disable_workflow: 'Desactivar',
  enable_workflow: 'Activar',
  delete_workflow: 'Eliminar',
  delete_workflow_modal_title: 'Eliminar flujo de trabajo',
  delete_workflow_modal_description:
    '¿Estás seguro de que quieres eliminar este flujo de trabajo? Esta acción no se puede deshacer.',
  workflow_deleted: 'Flujo de trabajo eliminado correctamente',
  add_workflow: 'Añadir flujo de trabajo',
  categorize_as: 'Categorizar como',
  conditions_for_workflow: 'Condiciones para el flujo de trabajo',
  workflow_choose_type: 'Elige un tipo',
  tag_category: 'Categoría de etiqueta',
  workflow_clients_input: 'Clientes / Proveedores',
  workflow_description_input: 'Descripción',
  transaction_description: 'Descripción de la transacción',
  transaction_type: 'Tipo de transacción',
  both: 'Ambos',
  only_debit: 'Solo débito',
  only_credit: 'Solo crédito',
  apply_to_month_invoices: 'Aplicar flujo de trabajo a las facturas de este mes',
  add_condition_workflow: 'Añadir condición',
  workflow_create_pending: 'Creando flujo de trabajo...',
  workflow_create_success: 'Flujo de trabajo creado con éxito',
  workflow_create_error: 'Hubo un error al crear el flujo de trabajo',
  workflow_update_pending: 'Actualizando flujo de trabajo...',
  workflow_update_success: 'Flujo de trabajo actualizado con éxito',
  workflow_update_error: 'Error al actualizar el flujo de trabajo',
  workflows_premium_upgrade_description:
    "Para crear y optimizar los flujos de trabajo de tu empresa en el panel, necesitas actualizarte a nuestro plan Premium. Esta función no está disponible en el plan Pro. Para más detalles sobre los precios mensuales, consulta nuestra <a href='https://companio.co/pricing/' target='_blank' rel='noreferrer'>página de precios</a>. ¿Estás listo para continuar con la actualización?",
  go_back: 'Volver',
  categorize_as_input_placeholder: 'Elige uno',
  create_workflow_modal_title: '¡Flujo de trabajo creado con éxito!',
  create_workflow_modal_description:
    'Tu nuevo flujo de trabajo está listo y activo. Categorizará automáticamente tus facturas o transacciones según las condiciones que hayas establecido. Puedes actualizarlo en cualquier momento desde la lista de flujos de trabajo.',
  invoice_description: 'Descripción de la factura',
  invoice_type: 'Tipo de factura',
  choose_category_first: 'Elige una categoría primero',
  sales_invoice_workflow_select_customer_helper: 'Selecciona un cliente para detectar el IVA.',

  // Add invoices page
  parsed_invoices_table_header_name: 'Nombre del documento',
  parsed_invoices_table_header_date: 'Fecha',
  parsed_invoices_table_header_status: 'Estado',
  parsed_invoices_table_header_transaction: 'Transacción',
  parsed_invoices_table_header_category: 'Etiqueta',
  add_invoices_sales_tab: 'Ventas',
  add_invoices_purchases_tab: 'Compras',
  parsed_invoices_sales_table_title: 'Facturas de ventas',
  parsed_invoices_purchases_table_title: 'Facturas de compras',
  documents_table_header_add_document_button: 'Confirmar selección',
  parsed_invoices_sales_column: 'Ventas',
  parsed_invoices_purchases_column: 'Compras',
  assign_invoice_pending: 'Asignando factura al proyecto...',
  project_update_success: 'Proyecto actualizado con éxito.',
  project_update_error: 'Hubo un error al actualizar el proyecto.',
  invoices_assigned_success_title: 'Las facturas se han añadido al proyecto',
  invoices_assigned_success_description:
    'Puedes descargar las facturas o eliminarlas desde la pantalla de detalles del proyecto.',
  invoices_assigned_error_title: '¡Ups! Algo salió mal',
  invoices_assigned_error_description:
    'No pudimos añadir las facturas seleccionadas debido a un problema de conexión. Por favor, inténtalo de nuevo y, si el problema persiste, contacta con nuestro equipo de Atención al Cliente a través del <a href="https://go.crisp.chat/chat/embed/?website_id=92ee1c03-fe47-44ef-8782-1f8593e54d6a" target="_blank" rel="noreferrer">chat</a>. Nuestro equipo estará encantado de ayudarte.',
  parsed_documents_warning:
    '<strong>Solo se muestran las facturas que ya han sido procesadas.</strong> Si no ves una factura concreta, no te preocupes: aparecerá en cuanto nuestro sistema termine de analizarla. ',
  closure_date_optional: 'Fecha de cierre (opcional)',
  closure_date: 'Fecha de cierre',
  dividend_calculation_initial_message:
    'Pagarás €0 en impuestos y recibirás €0 como dividendo neto.',
  dividend_calculation_message:
    'Pagarás €{{tax_amount}} en impuestos y recibirás €{{net_dividend}} como dividendo neto.',
  confirm_unmatch_invoice:
    'Esto eliminará la vinculación actual de esta factura. Esta acción no se puede deshacer. ¿Estás seguro?',
  upload_file_optional: 'Subir un archivo (opcional)',
  choose_an_option_first: 'Elige una opción primero',
  let_me_check: 'Déjame comprobarlo',
  annual_report_charge_title: '¡Empieza con tu informe anual!',
  annual_report_charge_description:
    'Aprovecha nuestro descuento por reserva anticipada y asegura tu informe anual por solo {{ price }} €. Este importe se cargará en tu método de pago designado en la <a href="/settings/billing" target="_blank" rel="noreferrer">sección de facturación</a>.',
  we_are_processing_your_payment_description:
    'Estamos confirmando tu pago. En cuanto se complete, comenzaremos a preparar tu informe anual.\n <b>Si necesitamos algo de tu parte, te avisaremos por correo electrónico.</b>',
  annual_report_payment_approved_description:
    'Tu pago se ha realizado correctamente. <b>Ahora nuestro sistema comenzará a preparar tu informe anual</b> — te mantendremos informado a medida que avancemos.',
  annual_report_payment_error_title: 'No se pudo completar el pago',
  annual_report_payment_error_description:
    'Parece que tu pago no se ha completado. Por favor, revisa tu método de pago o asegúrate de que haya fondos suficientes disponibles. Puedes actualizar tus datos en cualquier momento en <a href="/settings/billing" target="_blank" rel="noreferrer">Facturación</a>.',
  go_to_billing: 'Ir a facturación',
  annual_report_requisites_pending_user_subtitle:
    'Por favor, proporciona la <b>información necesaria</b> o completa las <b>acciones requeridas</b> para que podamos continuar preparando tu informe anual.',
  annual_report_requisites_in_preparation_subtitle:
    'Estamos recopilando los datos necesarios para comenzar tu informe anual. <b>Te avisaremos cuando necesitemos tu intervención.</b>',
  annual_report_verifying_requisites_subtitle:
    '<b>Estamos revisando los requisitos enviados.</b> Te avisaremos cuando la verificación esté completa o si necesitamos información o acciones adicionales por tu parte.',
  annual_report_accounting_preparing_reports_subtitle:
    'Estamos preparando los informes necesarios para tu informe anual.',
  annual_report_reports_pending_approval_subtitle:
    '<b>Tus informes están listos para su revisión</b>. Por favor, confírmalos para continuar con tu informe anual.',
  annual_report_pending_payment_subtitle:
    'Tu informe anual aún no puede procesarse. Por favor, completa el pago para continuar con la presentación.',
  annual_report_ready_to_signed_subtitle:
    'Tu informe anual está <b>listo para su presentación</b>. Por favor, revisa los detalles y completa el proceso de firma en el Registro Mercantil electrónico.',
  annual_report_not_all_signed_subtitle:
    'Algunos documentos <b>aún requieren tu firma</b>. Completa este paso para finalizar tu informe anual.',
  annual_report_signed_subtitle:
    'Todos los documentos han sido firmados. <b>Estamos verificándolo todo para finalizar tu informe anual.</b>',
  annual_report_submitted_subtitle:
    'Tu informe anual se ha presentado correctamente ante las autoridades estonias.',
  pending_payment: 'Pago pendiente',
  requisites: 'Requisitos',
  confirm_document_deletion:
    '¿Estás seguro de que deseas desvincular este documento? Esta acción no se puede deshacer.',
  review_documents_first:
    'Por favor, revisa cuidadosamente el Balance de Situación y la Cuenta de Pérdidas y Ganancias. Si no estás seguro de qué es el Balance de Situación, haz clic <a href="https://help.companio.co/es/article/entendiendo-mi-informe-anual-nt8fpr/" target="_blank" rel="noreferrer">aquí</a>, y si necesitas aclaraciones sobre la Cuenta de Pérdidas y Ganancias, haz clic <a href="https://help.companio.co/es/article/entendiendo-mi-informe-anual-nt8fpr/" target="_blank" rel="noreferrer">aquí</a>.',
  decline_documents_description:
    'Si deseas rechazar los documentos, <b>indícanos el motivo</b> para que podamos revisarlo y solucionarlo rápidamente.',
  intangible_assets_description:
    'Una opción es clasificar determinados gastos como activos intangibles, lo que significa que se tratan como inversiones en la empresa y no como gastos. Por ejemplo, la propiedad intelectual, así como los gastos de desarrollo y diseño, pueden considerarse activos intangibles si se invirtieron realmente en el desarrollo o la construcción de la infraestructura tecnológica de la empresa.<br/><br/>En estos casos, necesitarás una carta firmada digitalmente por los socios explicando que los gastos corresponden a los activos intangibles X e Y y que su valor está intrínsecamente invertido en la empresa y su plataforma tecnológica.<br/><br/>Esta opción no eliminará la pérdida, pero puede ayudar a evitar una situación similar a la quiebra que se produce cuando una empresa tiene pérdidas que no puede justificar o cubrir.<br/><br/>Descarga la plantilla <a href="/assets/docs/intangible_assets.docx" download target="_blank" rel="noreferrer">aquí</a>, complétala, fírmala digitalmente con DigiDoc y sube el documento .asice. <b>Si eliges esta opción, deberás subir el documento firmado.</b>',
  waive_debt_description:
    'Si concediste un préstamo a la empresa y esta no lo ha devuelto, también puede dar lugar a una quiebra. Para evitarlo, puedes renunciar a tu derecho a reclamar el reembolso a tu empresa. En ese caso, también necesitaremos una carta firmada digitalmente por todos los socios expresando dicha renuncia.<br/><br/>Descarga la plantilla <a href="/assets/docs/waive_debt.docx" download target="_blank" rel="noreferrer">aquí</a>, complétala, fírmala digitalmente con DigiDoc y sube el documento asice. <b>Si eliges esta opción, deberás subir el documento firmado.</b>',
  increase_share_capital_description:
    "Una de las opciones más sencillas es aumentar el capital social de la empresa y realizar el pago correspondiente. Si tienes preguntas sobre cómo pagar (y, opcionalmente, aumentar) el capital social, lee <a href='https://help.companio.co/es/article/capital-social-en-estonia-como-se-incrementa-1n5wz49/' target='_blank' rel='noreferrer'>este artículo</a>. Si eliges esta opción, se te pedirá que subas el comprobante bancario del pago del capital social aumentado, firmado digitalmente con DigiDoc (documento asice). <b>Si eliges esta opción, deberás subir el documento firmado.</b>",
  sign_annual_report_step_one:
    '<b>Inicia sesión en el <a href="https://ariregister.rik.ee/eng/" target="_blank" rel="noreferrer">Registro Mercantil electrónico</a></b> y selecciona «Presentación del informe anual».',
  sign_annual_report_step_two:
    '<b>Elabora el informe:</b> revisa el resumen y asegúrate de que toda la información sea correcta.',
  sign_annual_report_step_three: '<b>Revisa los detalles</b> para garantizar su exactitud.',
  sign_annual_report_step_four:
    '<b>Firma el informe:</b> añade la fecha si es necesario y fírmalo digitalmente con tu tarjeta de e-Residency.',
  annual_report_submission_final_description_1:
    'Si necesitas ayuda con el proceso de firma, puedes consultar nuestra <a href="https://help.companio.co/en/article/how-to-sign-my-annual-report-step-4-and-how-to-download-it-1tj4api/" target="_blank" rel="noreferrer">guía paso a paso</a> en nuestra Base de Conocimiento.',
  annual_report_submission_final_description_2:
    '<b>Una vez que hayas firmado el informe, vuelve al panel y haz clic en el botón</b> para confirmar que la presentación se ha completado.',
  annual_report_submission_final_description_3:
    '¡Gracias por tu colaboración durante todo este proceso!',
  completed_annual_report_banner_description:
    'Tu informe anual se ha presentado correctamente ante las autoridades estonias.<br/>Recibirás en breve un correo electrónico de confirmación con los detalles de la presentación.',
  confirm_all_requisites_modal_description_1:
    'Antes de continuar, asegúrate de haber completado todos los requisitos.',
  confirm_all_requisites_modal_description_2:
    'Las cargas correctas y los permisos adecuados ayudarán a que nuestro sistema procese tu informe anual sin problemas.',
  choose_one_option: 'Elige una opción',
  will_write_debit: 'Me gustaría dar de baja esta deuda.',
  will_pay_next_year: 'La pagaré el próximo año.',
  will_upload_purchase_credit_note:
    'Subiré una nota de crédito de compra que me envió el proveedor.',
  it_is_paid_purchase:
    'La factura fue pagada desde la cuenta bancaria de la empresa. Subiré un extracto o confirmación de pago como justificante.',
  was_paid_out_of_pocket: 'He pagado esta factura. Subiré el justificante bancario del pago.',
  will_upload_sales_credit_note: 'Subiré una nota de crédito de venta.',
  will_get_payment_next_year: 'Recibiré el pago el próximo año.',
  it_is_paid_sales: 'Está pagada. Subiré el justificante bancario del pago.',
  there_is_bank_transactions_already_i_will_match:
    'Ya hay una transacción bancaria en el panel. Quiero vincularla.',
  annual_report_requirements_banking_fee: 'Comisión bancaria',
  annual_report_requirements_gross: 'Bruto',
  annual_report_contract: 'Contrato del informe anual',
  accept_our_terms_and_conditions: 'Acepta nuestros <0>Términos y Condiciones</0>.',
  before_processing_with_the_payment: 'Antes de continuar con el pago',
  preparation: 'Preparación',
  preparation_and_confirmation: 'Preparación y confirmación',
  profit_or_loss: 'Pérdidas o ganancias',
  signature_and_submission: 'Firma y presentación',
  annual_report_requisites_header_title:
    'Todos los requisitos deben completarse antes del 31 de marzo',
  annual_report_requisites_header_description:
    'Por favor, revisa los requisitos a continuación y completa cualquier acción pendiente. <b>Nuestro sistema te guiará en cada paso</b> hasta que todo esté listo para comenzar tu informe anual.',
  annual_report_requisites_permission_for_accountant_title: 'Permiso para el contable',
  annual_report_requisites_permission_for_accountant_description:
    'Concede acceso al ID {{id}}, {{name}}. Consulta cómo hacerlo <a href="https://help.companio.co/en/article/how-to-grant-permission-to-prepare-the-annual-report-1ohq0d6/" target="_blank">aquí</a>.',
  annual_report_requisites_banks_connected_title: 'Comprueba que tus bancos estén conectados',
  annual_report_requisites_banks_connected_description:
    'Total de bancos desconectados: {{disconnected_banks}}',
  annual_report_requisites_bank_statements_title: 'Extractos bancarios pendientes',
  annual_report_requisites_bank_statements_description:
    'Total de extractos pendientes: {{bank_statements}}',
  annual_report_requisites_documents_for_transactions_title:
    'Documentos pendientes para transacciones',
  annual_report_requisites_documents_for_transactions_description:
    'Total de documentos pendientes: {{documents}}',
  annual_report_requisites_payments_for_documents_title: 'Pagos pendientes para documentos',
  annual_report_requisites_payments_for_documents_description:
    'Total de pagos pendientes: {{payments}}',
  annual_report_requisites_other_documents_title: 'Otros documentos pendientes',
  annual_report_requisites_other_documents_description:
    'Total de otros documentos pendientes: {{other_documents}}',
  granted: 'Concedido',
  review: 'Revisar',
  start: 'Empezar',
  back_to_requisites: 'Volver a requisitos',
  reconnect_your_bank_accounts: 'Reconecta tus cuentas bancarias',
  upload_bank_statements_from_each_bank:
    "Sube el extracto bancario de cada banco haciendo clic en 'Subir'.",
  proceed_to_invoicing_modal_title: 'Estás a punto de abrir la herramienta de facturación',
  proceed_to_invoicing_modal_description_1:
    'Esta acción te llevará a nuestra herramienta de facturación para que puedas crear tu factura.',
  proceed_to_invoicing_modal_description_2:
    'Una vez finalizado, <b>serás redirigido automáticamente aquí para continuar.</b>',
  creating_invoice_for_annual_report_alert:
    'Estás generando una factura para vincularla con una transacción del Informe Anual: "{{transaction_name}}"',
  invoicing_from_annual_report_value_error:
    'El importe total de la factura debe ser igual al importe total de la transacción.',
  hold_on_wait_a_minute: '¡Espera un momento!',
  confirm_annual_report_signature_modal_title: '¿Has firmado tu informe anual?',
  confirm_annual_report_signature_modal_description:
    'Por favor, confirma que la firma se ha completado en el Registro Mercantil electrónico para que podamos finalizar el proceso.',
  verifying_signature_banner_title: 'Estamos verificando la firma',
  verifying_signature_banner_description:
    'Hemos recibido tu notificación y estamos revisando el registro. Si todo es correcto, tu informe anual se presentará automáticamente. De lo contrario, nos pondremos en contacto contigo si es necesaria alguna acción adicional. Por favor, permite un par de días para que este proceso se complete.',
  not_all_signed_annual_report_alert:
    '<b>IMPORTANTE:</b> Parece que el informe anual aún no ha sido firmado por todos los miembros de la empresa. Asegúrate de que todas las firmas requeridas estén completas antes de continuar.',
  rounded_amounts_annual_report_alert:
    'Los importes mostrados en el Registro de Empresas de Estonia pueden ser redondeados por su sistema con fines de reporte, <b>por lo que los totales pueden no coincidir exactamente con la suma de las cifras contables individuales mostradas en el panel</b> (las diferencias pueden ser de alrededor de 1 euro). Los informes finales presentados siguen siendo correctos tanto en los registros contables como en el Registro de Empresas.',
  please_upload_or_match_missing_documents:
    'Por favor, sube o vincula los documentos pendientes (facturas, nóminas, recibos, etc.) relacionados con estos pagos.',
  please_upload_confirmation_documents_from_bank:
    'Por favor, sube los documentos de confirmación del banco o vincúlalos con las opciones relacionadas con estas facturas.',
  annual_report_other_documents_description_2:
    'Por favor, sube los documentos pendientes de los elementos que se muestran a continuación. Si no dispones de un documento, deja un breve comentario para que sepamos cómo proceder.',
  document_request: 'Solicitud de documento',
  i_will_upload_it: 'Lo subiré',
  dont_have_it_leave_comments: 'No lo tengo. Dejaré comentarios.',
  edit_comment: 'Editar comentario',
  add_comment: 'Añadir comentario',
  add_your_comment: 'Añade tu comentario',
  annual_report_getting_started_banner_title:
    '¡Gracias por comenzar tu informe anual con nosotros!',
  annual_report_getting_started_banner_december_description:
    '¡Gracias por pagar con antelación! Los Informes Anuales comienzan oficialmente a principios de año. Como uno de los primeros en pagar, tu informe ya está en la cola de prioridad y será uno de los primeros que iniciemos. Por favor, ten paciencia: nos ocuparemos del tuyo en cuanto comience la temporada.',
  annual_report_getting_started_banner_early_january_description:
    'La temporada de Informes Anuales acaba de comenzar y estamos revisando todas las cuentas y preparando los documentos necesarios para su presentación. Recibirás un correo electrónico con las instrucciones en cuanto los requisitos de tu informe estén listos.',
  annual_report_getting_started_banner_mid_january_description:
    '¡Gracias por tu reciente pago! Estamos revisando tus datos contables y recopilando los requisitos para tu Informe Anual. Este proceso puede tardar unos días. Si no tienes noticias nuestras en una semana, no dudes en ponerte en contacto.',
  annual_report_getting_started_banner_late_january_description:
    'Damos prioridad a los Informes Anuales según la fecha de pago, y el tuyo ya está en la cola. Si ha pasado más de una semana desde que pagaste y aún no has tenido noticias nuestras, no dudes en ponerte en contacto: estamos aquí para ayudarte.',
  annual_report_requisites_fulfilled_banner_title: '¡Gracias por completar tus requisitos!',
  annual_report_requisites_fulfilled_banner_description_1:
    'Nuestro sistema revisará ahora la información que has proporcionado para garantizar que todo sea correcto.',
  annual_report_requisites_fulfilled_banner_description_2:
    'Si se requieren documentos o información adicionales, te lo notificaremos por correo electrónico.',
  annual_report_requisites_approved_banner_title:
    '¡Buenas noticias! Tus requisitos han sido aprobados',
  annual_report_requisites_approved_banner_description_:
    'Estamos preparando tus documentos para su revisión. Estarán disponibles para su descarga en breve y te mantendremos informado por correo electrónico en cada paso del proceso.',
  annual_report_missing_requisites_alert:
    '<b>ALGUNOS requisitos requieren atención:</b> Por favor, revisa las secciones a continuación para completar o actualizar cualquier elemento pendiente o rechazado.',
  annual_report_has_profit_of: 'Has obtenido un beneficio de {{profit}} €',
  annual_report_has_loss_of: 'Tu empresa ha tenido una pérdida de {{loss}} €',
  annual_report_profit_description:
    'Indica el importe del beneficio que deseas distribuir como dividendos. Si decides no distribuir ningún beneficio, introduce 0 y haz clic en Confirmar.',
  annual_report_loss_description:
    '<b>Según tus informes financieros, tu empresa ha registrado una pérdida este año.</b> Hemos identificado algunas opciones para evitar esta situación. Selecciona una de las opciones a continuación y sube el documento requerido, firmado digitalmente con tu tarjeta de e-Residency. Más información <a href="https://help.companio.co/en/article/i-have-losses-what-can-i-do-12qy9j6/?bust=1765966522848" target="_blank" rel="noreferrer">aquí</a>.',
  upload_file_choose_pdf: 'Subir un archivo (Elegir un PDF)',
  waive_loan_debt: 'Renunciar a la deuda del préstamo',
  proceed_to_payment: 'Proceder al pago',
  // Passport page
  street_address: 'Dirección',
  zipcode: 'Código postal',
  passport_table_title:
    '<p><bold>Por favor, revisa estos datos</bold></p><p class="subtitle">Sube una versión actualizada del pasaporte o del documento nacional de identidad de la UE para los siguientes miembros y confirma sus países de residencia.</p>',
  upload_passport_success_title: 'Carga completada',
  upload_passport_success_description:
    'Gracias por subir tus documentos. Serás redirigido a tu panel de control en unos momentos.',
  upload_passport_warning_title: 'Verificación de identidad requerida',
  upload_passport_warning_description:
    'Para cumplir con los protocolos de prevención de blanqueo de capitales exigidos por las autoridades, necesitamos que nos proporciones cierta información. No te preocupes, ¡solo te llevará 2 minutos!',
  upload_passport: 'Sube tu pasaporte',
  passport_uploaded_successfully: 'Pasaporte subido correctamente',
  transaction_locked_by_annual_report_title: 'Acción requerida en el Informe Anual',
  transaction_locked_by_annual_report:
    'Esta transacción forma parte del proceso del Informe Anual {{year}} y no puede conciliarse desde el flujo estándar. Por favor, revísala directamente en el Informe Anual y selecciona la opción correspondiente.',
  export: 'Exportar datos',
  export_csv: 'Exportar como CSV',
  export_pdf: 'Exportar como PDF',
  export_loading: 'Exportando, por favor espera...',
  export_modal_title: 'Exportar {{pageType}} como {{format}}',
  export_modal_description:
    'Elige el período de tiempo que quieres exportar. El archivo incluirá todas las transacciones que coincidan con el rango seleccionado.',
  export_period_placeholder: 'Seleccionar período',
  export_period_month_to_date: 'Mes hasta la fecha',
  export_period_previous_month: 'Mes anterior',
  export_period_current_quarter: 'Trimestre actual',
  exporting: 'Exportando...',
  export_error: 'Ocurrió un error al exportar. Por favor, inténtalo de nuevo.',
  export_queued_title: 'Estamos preparando tu archivo',
  export_queued_description:
    'Tu archivo contiene una gran cantidad de información, por lo que lo estamos preparando en segundo plano. Una vez que esté listo, te lo enviaremos a tu correo en el formato seleccionado.',
  filter_section_bank_account: 'Cuenta bancaria',
  filter_section_balances: 'Balances',
  filter_section_display_options: 'Opciones de visualización',
  filter_section_export_data: 'Exportar datos',

  // MissingBank page
  review_transactions: 'Revisar transacciones',
  missing_bank_transactions_description:
    'Hemos encontrado transacciones que podrían pertenecer a una cuenta bancaria que aún no se ha conectado. <b>Por favor, revísalas y elige cómo deseas proceder.</b>',
  missing_bank_transactions_description_resolved:
    'Aquí puedes revisar el comentario que enviaste y consultar las transacciones.',
  accountants_comment: 'Comentario del contable',
  what_would_you_like_to_do: '¿Qué te gustaría hacer?',
  connect_a_bank_account: 'Conectar una cuenta bancaria',
  connect_bank_account_description:
    '<b>Serás redirigido para conectar tu cuenta bancaria.</b> Una vez conectada, este problema se resolverá automáticamente.',
  no_additional_bank_accounts: 'No hay cuentas bancarias adicionales',
  no_additional_bank_accounts_description:
    'Si no tienes otras cuentas bancarias para conectar, por favor añade un comentario para ayudarnos a garantizar que tus registros estén completos y sean precisos.',
  receiver: 'Beneficiario',
  add_a_comment: 'Añadir un comentario',
  confirm_no_additional_bank_accounts_modal_title:
    '¿Estás seguro de que no hay cuentas bancarias adicionales?',
  confirm_no_additional_bank_accounts_modal_description_1:
    '<b>Estas transacciones pueden indicar actividad de una cuenta bancaria que aún no se ha conectado.</b> Conectar todas las cuentas ayuda a garantizar que tus datos financieros estén completos y sean precisos.',
  confirm_no_additional_bank_accounts_modal_description_2:
    'Si estás seguro de que no hay cuentas adicionales, puedes continuar.',
  review_again: 'Revisar de nuevo',
  missing_bank_success_modal_title: '¡Todo listo! Estamos revisando tu caso',
  missing_bank_success_modal_description_1:
    'Tu respuesta ha sido enviada y la revisaremos en breve.',
  missing_bank_success_modal_description_2:
    'Si necesitamos información adicional, nos pondremos en contacto contigo por correo electrónico.',
  missing_bank_resolved_alert:
    '<b>Hemos recibido tu comentario y nuestro sistema lo está revisando.</b> Te notificaremos por correo electrónico si necesitamos algo más de tu parte.',
  comment_details: 'Detalles del comentario',
  information_provided_by_the_accountant: 'Información proporcionada por el contable',
  pending_payment_warning: 'Tienes un pago pendiente',
  pending_payment_warning_description:
    'Tienes <strong>{{amount}} en pagos pendientes</strong> relacionados con tu plan de servicio. Por favor, liquide estos pagos lo antes posible para evitar interrupciones del servicio o recargos por mora.',
  help_title_label: 'Ayuda y tutoriales',
  sidebar_section_workspace: 'Workspace',
  sidebar_section_marketplace: 'Marketplace',
  sidebar_section_business_operations: 'Operaciones de negocio',
  dashboard_news_got_it: '¡Entendido!',
  dashboard_news_type_improvement: 'Mejora',
  dashboard_news_type_new_feature: 'Nueva función',
  dashboard_news_type_correction: 'Corrección',
  general_data_company_next_invoice_number: 'número de la próxima factura',
  set_invoice_number_manually: 'Definir el número manualmente',
  invoice_number_out_of_range:
    'El número de factura debe ser un número entero entre 1 y {{maximum}}.',
  invoice_number_cannot_be_below:
    'La numeración de tus facturas de ingreso solo puede avanzar. Usa {{invoice_number}} o superior.',
  invoice_number_raise_too_large:
    'El número de la próxima factura solo puede aumentarse en {{maximum}} cada vez, así que usa {{highest}} o inferior. Si necesitas un salto mayor, contacta con soporte.',
  business_info_next_invoice_number_note:
    'Tus facturas de ingreso se numeran con una única serie de 10 dígitos, compartida por todos tus clientes. Este es el número que tomará la próxima. Solo se puede aumentar, nunca reducir.',

  // Página de solicitud de factura faltante
  missing_invoice_card_title: 'Necesitamos la factura de esta transacción',
  missing_invoice_card_description:
    'Necesitamos la factura o el recibo relacionado con esta transacción para completar correctamente tu contabilidad. Sube o vincula el documento correspondiente.',
  missing_invoice_resolved_alert: 'Esta transacción ya ha sido resuelta.',
  upload_invoice: 'Subir factura',
  other_options: 'Otras opciones',
  match_with_uploaded_invoice: 'Vincular con factura subida',
  ask_someone_from_your_team: 'Pedir a alguien de tu equipo',
  mark_as_non_business_expense: 'Marcar como gasto no relacionado con el negocio',
  other_matching_options: 'Otras opciones de vinculación',
  refund_instructions: 'Instrucciones de reembolso',
  understood: 'Entendido',
  assign: 'Asignar',
  i_changed_my_mind: 'Cambié de opinión',

  mark_non_business_expense_modal_title: '¿Marcar como gasto no relacionado con el negocio?',
  mark_non_business_expense_modal_description_1:
    'Marcar esta transacción como un <strong>gasto no relacionado con el negocio</strong> es la opción correcta cuando el pago no está relacionado con la actividad de tu empresa o cuando no se puede obtener una factura.',
  mark_non_business_expense_modal_description_2:
    'Los gastos no relacionados con el negocio <strong>están sujetos a impuestos según la legislación aplicable.</strong> Los impuestos correspondientes se calcularán automáticamente y se incluirán en tu <strong>próximo informe fiscal mensual.</strong>',
  mark_non_business_expense_modal_description_3: '¿Deseas continuar?',
  mark_non_business_expense_success_modal_title:
    'Transacción marcada como gasto no relacionado con el negocio',
  mark_non_business_expense_success_modal_description:
    'Calcularemos los impuestos asociados a esta transacción y los incluiremos automáticamente en tu próximo informe fiscal. Gracias por ayudarnos a mantener tu contabilidad completa y al día.',

  ask_team_member_modal_title: 'Pedir a alguien de tu equipo',
  ask_team_member_modal_description:
    'Esta persona recibirá un correo electrónico pidiéndole que suba la factura correspondiente a esta transacción. Si lo deseas, también puedes asignar a esta persona como destinataria predeterminada para futuras solicitudes de factura.',
  choose_team_member: 'Elige un miembro del equipo',
  assign_as_default_invoice_request_recipient:
    'Asignar a esta persona como destinataria predeterminada para futuras solicitudes de factura.',
  task_assigned_to_team_member_success_modal_title: 'Tarea asignada a un miembro del equipo',
  task_assigned_to_team_member_success_modal_description:
    'Tu compañero recibirá un correo electrónico pidiéndole que suba la factura de esta transacción. Gracias por ayudarnos a mantener tu contabilidad completa y al día.',
  invoice_matched_success_modal_title: '¡Factura vinculada, gracias!',
  invoice_matched_success_modal_description:
    'Esto es exactamente lo que necesitábamos para completar la contabilidad de esta transacción. Tu documento se ha subido y vinculado correctamente a la transacción.',
  refund_instructions_same_month_title: 'Instrucciones de reembolso - Mismo mes',
  refund_instructions_same_month_description:
    'Como el pago original ocurrió este mes, puedes completar el reembolso ahora por el mismo importe y evitar la necesidad de emitir o recibir una factura rectificativa, siempre que el reembolso se realice antes de fin de mes.<br /><br /><strong>Para mantener tu contabilidad correcta:</strong><ol><li>El reembolso debe realizarse por <strong>exactamente el mismo importe</strong> que el pago original.</li><li>El reembolso debe <strong>enviarse desde o recibirse en la misma cuenta bancaria</strong> utilizada en la transacción original.</li><li>Cuando el reembolso aparezca en tus transacciones bancarias, podrás vincularlo como "Pago y reembolso".</li></ol>',
  refund_instructions_different_month_title: 'Instrucciones de reembolso - Meses diferentes',
  refund_instructions_different_month_description:
    'Como el pago original ocurrió en un mes anterior, un simple reembolso no es suficiente a efectos contables. Deberás emitir o recibir una factura rectificativa para ajustar correctamente tus registros.<br /><br /><strong>Para mantener tu contabilidad correcta:</strong><ol><li>El reembolso se realiza por <strong>exactamente el mismo importe</strong> que el pago original.</li><li>El reembolso se <strong>envía desde o se recibe en la misma cuenta bancaria</strong> utilizada en la transacción original.</li><li><strong>La factura original está subida y vinculada con el pago original.</strong></li><li>Se emite, sube y vincula una <strong>factura rectificativa con la transacción de reembolso.</strong></li></ol>',
  request_invoice_from_team_member_pending: 'Enviando solicitud de factura...',
  request_invoice_from_team_member_success: 'Solicitud de factura enviada correctamente.',
  request_invoice_from_team_member_error:
    'Ha ocurrido un error al enviar la solicitud de factura. Por favor, inténtalo de nuevo.',
  invoice_request_responsible_title: 'Responsable de solicitud de factura',
  invoice_request_responsible_user_selector: 'Selector de usuarios',
  invoice_request_responsible_description:
    'Selecciona el miembro del equipo que recibirá las solicitudes de facturas e información contable de tu contable.',

  // Legal Contact
  legal_contact: 'Contacto legal',
  person_of_contact: 'Persona de contacto',
  legal_contact_description:
    'Esta persona es el representante legal de tu empresa y quien firma los documentos oficiales.',
  signed_document: 'Documento firmado',
  signed_document_in_preparation:
    'No necesitas hacer nada por ahora. Estamos firmando este documento y te avisaremos por correo cuando esté disponible para descargar.',
  signed_document_to_submit:
    'Tu documento está firmado y listo para descargar. Preséntalo en el Registro Mercantil y luego pulsa el botón de abajo para confirmar que lo has subido.',
  signed_document_complete:
    'Presentado en el Registro Mercantil de Estonia el {{date}}. Todo está en orden.',
  signed_document_expired: 'Este documento ha caducado y debe renovarse.',
  legal_authorization: 'Autorización legal',
  submitted: 'Presentado',
  legal_authorization_submitted_pending: 'Confirmando tu presentación…',
  legal_authorization_submitted_success:
    'Gracias: hemos registrado que has presentado el documento.',
  legal_authorization_submitted_error:
    'No hemos podido registrar tu presentación. Inténtalo de nuevo.',
  SIG_IN_PREPARATION: 'En preparación',
  SIG_TO_SUBMIT: 'Listo para presentar',
  SIG_COMPLETE: 'Completado',
  SIG_REJECTED: 'Rechazado',
  SIG_EXPIRED: 'Caducado',
  help_match_with_ai: 'Ayúdame a conciliar esto',
  help_match_modal_title: 'Ayúdame a conciliar esta transacción',
  help_match_ai_subtitle: 'Asistente de conciliación con IA',
  describe_transaction_label: 'Describe esta transacción con tus propias palabras',
  update_description_and_re_analyze: 'Actualizar descripción y volver a analizar',
  supporting_signals: 'Indicios que lo respaldan',
  analyzing_transaction_label: 'Analizando tu transacción con IA',
  describe_transaction_placeholder: 'Escribe aquí tu descripción de la transacción...',
  analyze_transaction: 'Analizar transacción',
  bank_description: 'Descripción bancaria',
  suggested_match_type: 'Tipo de conciliación sugerido',
  help_match_confidence: '{{value}}% de confianza',
  find_matching_invoices: 'Buscar factura(s) coincidente(s)',
  match_with_this_invoice: 'Conciliar con esta factura',
  invoice_number_label: 'Factura n.º {{number}}',
  no_matching_invoices_found:
    'No se encontraron facturas coincidentes. Prueba a subirla o buscarla manualmente.',
  possible_indicators: 'Posibles indicios',
  help_match_low_confidence_title: 'Sugerencia con poca confianza:',
  help_match_low_confidence_text:
    'No estamos del todo seguros de que este sea el tipo de conciliación correcto. Revisa con atención los datos de la transacción antes de conciliarla.',
  help_match_low_confidence_support_prefix: 'Si tienes dudas,',
  help_match_low_confidence_support_link: 'contacta con soporte',
  help_match_low_confidence_support_suffix: 'para que te orientemos.',
  suggested_alternatives: 'Alternativas sugeridas',
  help_match_alternative_match: '{{value}}% de coincidencia',
  help_match_success_title: 'Conciliación aplicada correctamente',
  help_match_success_applied_type: 'Tipo de conciliación aplicado:',
  help_match_success_text: 'La transacción ya está correctamente categorizada en tu contabilidad.',
  help_match_label_out_of_pocket: 'Gasto de bolsillo',
  help_match_label_profit_distribution: 'Distribución de beneficios',
  help_match_mismatch_title: 'Posible discrepancia detectada',
  help_match_mismatch_subtitle: 'La descripción no coincide con los datos de la transacción.',
  help_match_mismatch_reasons: 'Por qué no coincide',
  help_match_alternatives_info_title:
    'Selecciona una de las alternativas sugeridas o actualiza tu descripción',
  help_match_alternatives_info_text: 'para que se ajuste mejor a los datos de la transacción.',
  help_match_subtitle_sales_invoice: 'Pago de un cliente',
  help_match_subtitle_purchase_invoice: 'Pago a un proveedor',
  help_match_subtitle_non_business_expense: 'Transacción personal',
  help_match_subtitle_bank_fee: 'Cargo de tu banco',
  help_match_subtitle_state_fee: 'Pago al Estado',
  help_match_subtitle_state_refund: 'Devolución del Estado',
  help_match_subtitle_internal: 'Transferencia entre cuentas de la empresa',
  help_match_subtitle_investment_add_funds: 'Depósito en una plataforma de inversión',
  help_match_subtitle_investment_withdraw_funds: 'Retirada de una plataforma de inversión',
  help_match_subtitle_inner_trading: 'Movimiento dentro de una plataforma de inversión',
  help_match_subtitle_daily_allowance: 'Dieta de viaje de negocios de un miembro de la empresa',
  help_match_subtitle_share_capital: 'Aportación de capital de un accionista',
  help_match_subtitle_out_of_pocket: 'Reembolso a un miembro de la empresa',
  help_match_subtitle_refunded_sale: 'Devolución a un cliente',
  help_match_subtitle_refunded_purchase: 'Devolución de un proveedor',
  help_match_subtitle_dividends: 'Pago al propietario o accionista de la empresa',
  help_match_subtitle_held_fund_reserve: 'Reserva retenida por un procesador de pagos',
  help_match_subtitle_released_fund_reserve: 'Reserva liberada por un procesador de pagos',
  help_match_subtitle_received_interest: 'Intereses pagados por tu banco',
  help_match_subtitle_bank_cashback: 'Reembolso o recompensa de tu banco',
  help_match_subtitle_card_verification: 'Pequeño cargo de verificación de tarjeta',
  help_match_subtitle_commission_earnings: 'Comisión de una plataforma',
  help_match_already_matched: 'Esta transacción ya está conciliada como {{type}}.',
  help_match_remove_current_match_text:
    'Esta transacción está conciliada actualmente como {{type}}. Elimina la conciliación actual para aplicar una nueva.',
  help_match_remove_current_match: 'Eliminar conciliación actual',
  help_match_action_mark_non_business: 'Marcar como gasto no empresarial',
  help_match_action_reimburse_company:
    'Reembolsar a la empresa y conciliar como devolución de gastos personales',
  help_match_action_select_counterpart_transaction:
    'Seleccionar la transferencia en la otra cuenta',
  help_match_action_select_refund_transaction: 'Seleccionar el pago original',
  help_match_action_select_business_trip: 'Elegir el viaje de negocios',
  help_match_action_contact_support: 'Contactar con soporte',
  help_match_specify_breakdown: 'Especifica el desglose',
  help_match_principal_amount: 'Importe del capital',
  help_match_interest_amount: 'Importe de intereses/rendimientos',
  help_match_total: 'Total',
  help_match_action_apply_breakdown: 'Aplicar desglose',
  help_match_split_must_add_up: 'El capital y los intereses deben sumar {{amount}} {{currency}}.',
  help_match_daily_allowance_rates:
    'La dieta legal en el extranjero es de {{firstRate}} €/día durante los primeros {{firstDays}} días y de {{restRate}} €/día a partir de entonces. ¿Cuántos días duró el viaje?',
  help_match_days_label: 'Días en el extranjero',
  help_match_daily_allowance_expected:
    'Dieta esperada: {{expected}} {{currency}}. Este pago es de {{amount}} {{currency}}.',
  help_match_daily_allowance_exceeds:
    'Este pago ({{amount}} {{currency}}) supera la dieta correspondiente a estos días ({{expected}} {{currency}}). La diferencia no se puede conciliar como dieta.',
  help_match_note_sales_invoice_title: 'Se necesita una factura para completar esta conciliación.',
  help_match_note_sales_invoice_text:
    'Sube la factura que emitiste a {{counterparty}} o búscala entre tus facturas existentes.',
  help_match_note_purchase_invoice_title:
    'Se necesita una factura para completar esta conciliación.',
  help_match_note_purchase_invoice_text:
    'Consejo: la mayoría de los proveedores permiten descargar las facturas desde la sección de facturación o de cuenta de su web.',
  help_match_note_non_business_expense_title:
    'Los gastos personales pagados por la empresa tributan.',
  help_match_note_non_business_expense_text:
    'Según el §51 de la Ley del Impuesto sobre la Renta de Estonia, los gastos no empresariales se consideran beneficios en especie y tributan. Reembolsar a la empresa evita este impuesto.',
  help_match_note_bank_fee_title: 'Las comisiones bancarias no necesitan factura.',
  help_match_note_bank_fee_text:
    'Los cargos bancarios y las comisiones de mantenimiento se pueden conciliar directamente, sin subir documentos.',
  help_match_note_state_fee_title: 'Las tasas estatales no necesitan factura.',
  help_match_note_state_fee_text:
    'Los pagos a la EMTA o al Registro Mercantil electrónico se pueden conciliar directamente.',
  help_match_note_state_refund_title: 'Las devoluciones del Estado no necesitan documentos.',
  help_match_note_state_refund_text:
    'Las devoluciones de una autoridad fiscal u organismo público se pueden conciliar directamente.',
  help_match_note_internal_title: 'Ambas cuentas pertenecen a tu empresa.',
  help_match_note_internal_text:
    'Selecciona la transferencia correspondiente en la otra cuenta. Las diferencias de divisa se gestionan automáticamente.',
  help_match_note_investment_withdraw_funds_title:
    'Necesitamos un poco más de información antes de conciliar esta transacción.',
  help_match_note_investment_withdraw_funds_text:
    'Indica qué parte de esta retirada corresponde a tu inversión original y qué parte a intereses, beneficios o rendimientos de la inversión.',
  help_match_note_daily_allowance_title: 'La dieta debe corresponder a un viaje de negocios.',
  help_match_note_daily_allowance_text:
    'Confirma el número de días y elige el viaje de negocios al que corresponde este pago.',
  help_match_note_share_capital_title: 'Selecciona el accionista que hizo esta aportación.',
  help_match_note_share_capital_text:
    'Recuerda actualizar el capital social en el Registro Mercantil electrónico después de la aportación.',
  help_match_note_out_of_pocket_title: 'Se necesita la factura original.',
  help_match_note_out_of_pocket_text:
    'Sube la factura del gasto emitida a nombre de la empresa (no de la persona que lo pagó).',
  help_match_note_refunded_sale_title:
    'Debes emitir una factura rectificativa por esta devolución.',
  help_match_note_refunded_sale_text:
    'Emite una factura rectificativa para {{counterparty}} y selecciona el pago de venta original que se está devolviendo.',
  help_match_note_refunded_purchase_title: 'Se necesita la factura rectificativa del proveedor.',
  help_match_note_refunded_purchase_text:
    'Pide a {{counterparty}} la factura rectificativa y selecciona el pago de compra original que se está devolviendo.',
  help_match_note_dividends_title: 'La distribución de beneficios tiene obligaciones fiscales.',
  help_match_note_dividends_text:
    'Los beneficios distribuidos tributan en el impuesto de sociedades y deben declararse. Si no estás seguro de que sea una distribución de beneficios, contacta con soporte antes de conciliar.'
};
